import * as zr from "react";
import ct, { useRef as qr, useState as pi, useEffect as Rt, useCallback as Yr } from "react";
var ot = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function Pe(t) {
  return t && t.__esModule && Object.prototype.hasOwnProperty.call(t, "default") ? t.default : t;
}
function Oa(t) {
  if (Object.prototype.hasOwnProperty.call(t, "__esModule")) return t;
  var e = t.default;
  if (typeof e == "function") {
    var r = function n() {
      var i = !1;
      try {
        i = this instanceof n;
      } catch {
      }
      return i ? Reflect.construct(e, arguments, this.constructor) : e.apply(this, arguments);
    };
    r.prototype = e.prototype;
  } else r = {};
  return Object.defineProperty(r, "__esModule", { value: !0 }), Object.keys(t).forEach(function(n) {
    var i = Object.getOwnPropertyDescriptor(t, n);
    Object.defineProperty(r, n, i.get ? i : {
      enumerable: !0,
      get: function() {
        return t[n];
      }
    });
  }), r;
}
var et = {}, tt = {}, bt = {}, Ft = { exports: {} }, Ut, Wr;
function je() {
  if (Wr) return Ut;
  Wr = 1;
  var t = Object.defineProperty, e = Object.defineProperties, r = Object.getOwnPropertyDescriptor, n = Object.getOwnPropertyDescriptors, i = Object.getOwnPropertyNames, a = Object.getOwnPropertySymbols, o = Object.prototype.hasOwnProperty, u = Object.prototype.propertyIsEnumerable, v = (l, h, s) => h in l ? t(l, h, { enumerable: !0, configurable: !0, writable: !0, value: s }) : l[h] = s, E = (l, h) => {
    for (var s in h || (h = {}))
      o.call(h, s) && v(l, s, h[s]);
    if (a)
      for (var s of a(h))
        u.call(h, s) && v(l, s, h[s]);
    return l;
  }, b = (l, h) => e(l, n(h)), P = (l, h) => {
    for (var s in h)
      t(l, s, { get: h[s], enumerable: !0 });
  }, d = (l, h, s, c) => {
    if (h && typeof h == "object" || typeof h == "function")
      for (let g of i(h))
        !o.call(l, g) && g !== s && t(l, g, { get: () => h[g], enumerable: !(c = r(h, g)) || c.enumerable });
    return l;
  }, w = (l) => d(t({}, "__esModule", { value: !0 }), l), m = (l, h, s) => new Promise((c, g) => {
    var y = (I) => {
      try {
        F(s.next(I));
      } catch (T) {
        g(T);
      }
    }, A = (I) => {
      try {
        F(s.throw(I));
      } catch (T) {
        g(T);
      }
    }, F = (I) => I.done ? c(I.value) : Promise.resolve(I.value).then(y, A);
    F((s = s.apply(l, h)).next());
  }), _ = {};
  P(_, {
    AggregateError: () => he,
    AllProviderEvents: () => Q,
    AllProviderStatus: () => pe,
    BaseComparisonStrategy: () => fe,
    BaseEvaluationStrategy: () => Oe,
    BaseFirstMatchStrategy: () => Ne,
    BaseFirstSuccessfulStrategy: () => W,
    ClientProviderEvents: () => Q,
    ClientProviderStatus: () => pe,
    DefaultLogger: () => me,
    ErrorCode: () => z,
    ErrorWithCode: () => De,
    FlagNotFoundError: () => x,
    GeneralError: () => B,
    GenericEventEmitter: () => Le,
    InvalidContextError: () => Y,
    LOG_LEVELS: () => Z,
    MapHookData: () => S,
    OpenFeatureCommonAPI: () => L,
    OpenFeatureError: () => j,
    ParseError: () => be,
    ProviderFatalError: () => we,
    ProviderNotReadyError: () => oe,
    ProviderWrapper: () => D,
    SafeLogger: () => J,
    ServerProviderEvents: () => Se,
    ServerProviderStatus: () => re,
    StandardResolutionReasons: () => k,
    StatusTracker: () => He,
    TargetingKeyMissingError: () => ge,
    TelemetryAttribute: () => ee,
    TelemetryFlagMetadata: () => ye,
    TypeMismatchError: () => Ve,
    constructAggregateError: () => ne,
    createEvaluationEvent: () => Be,
    instantiateErrorByErrorCode: () => Te,
    isObject: () => p,
    isString: () => N,
    objectOrUndefined: () => R,
    statusMatchesEvent: () => Me,
    stringOrUndefined: () => f,
    throwAggregateErrorFromPromiseResults: () => ke
  }), Ut = w(_);
  var S = class {
    constructor() {
      this.data = /* @__PURE__ */ new Map();
    }
    set(l, h) {
      this.data.set(l, h);
    }
    get(l) {
      return this.data.get(l);
    }
    has(l) {
      return this.data.has(l);
    }
    delete(l) {
      return this.data.delete(l);
    }
    clear() {
      this.data.clear();
    }
  }, k = {
    /**
     * The resolved value is static (no dynamic evaluation).
     */
    STATIC: "STATIC",
    /**
     *  The resolved value was configured statically, or otherwise fell back to a pre-configured value.
     */
    DEFAULT: "DEFAULT",
    /**
     * The resolved value was the result of a dynamic evaluation, such as a rule or specific user-targeting.
     */
    TARGETING_MATCH: "TARGETING_MATCH",
    /**
     * The resolved value was the result of pseudorandom assignment.
     */
    SPLIT: "SPLIT",
    /**
     * The resolved value was retrieved from cache.
     */
    CACHED: "CACHED",
    /**
     * The resolved value was the result of the flag being disabled in the management system.
     */
    DISABLED: "DISABLED",
    /**
     * The reason for the resolved value could not be determined.
     */
    UNKNOWN: "UNKNOWN",
    /**
     * The resolved value is non-authoritative or possibly out of date.
     */
    STALE: "STALE",
    /**
     * The resolved value was the result of an error.
     *
     * Note: The `errorCode` and `errorMessage` fields may contain additional details of this error.
     */
    ERROR: "ERROR"
  }, z = /* @__PURE__ */ ((l) => (l.PROVIDER_NOT_READY = "PROVIDER_NOT_READY", l.PROVIDER_FATAL = "PROVIDER_FATAL", l.FLAG_NOT_FOUND = "FLAG_NOT_FOUND", l.PARSE_ERROR = "PARSE_ERROR", l.TYPE_MISMATCH = "TYPE_MISMATCH", l.TARGETING_KEY_MISSING = "TARGETING_KEY_MISSING", l.INVALID_CONTEXT = "INVALID_CONTEXT", l.GENERAL = "GENERAL", l))(z || {}), j = class mi extends Error {
    constructor(h, s) {
      super(h), Object.setPrototypeOf(this, mi.prototype), this.name = "OpenFeatureError", this.cause = s?.cause;
    }
  }, x = class yi extends j {
    constructor(h, s) {
      super(h, s), Object.setPrototypeOf(this, yi.prototype), this.name = "FlagNotFoundError", this.code = "FLAG_NOT_FOUND";
    }
  }, B = class _i extends j {
    constructor(h, s) {
      super(h, s), Object.setPrototypeOf(this, _i.prototype), this.name = "GeneralError", this.code = "GENERAL";
    }
  }, Y = class Ei extends j {
    constructor(h, s) {
      super(h, s), Object.setPrototypeOf(this, Ei.prototype), this.name = "InvalidContextError", this.code = "INVALID_CONTEXT";
    }
  }, be = class bi extends j {
    constructor(h, s) {
      super(h, s), Object.setPrototypeOf(this, bi.prototype), this.name = "ParseError", this.code = "PARSE_ERROR";
    }
  }, we = class wi extends j {
    constructor(h, s) {
      super(h, s), Object.setPrototypeOf(this, wi.prototype), this.name = "ProviderFatalError", this.code = "PROVIDER_FATAL";
    }
  }, oe = class Oi extends j {
    constructor(h, s) {
      super(h, s), Object.setPrototypeOf(this, Oi.prototype), this.name = "ProviderNotReadyError", this.code = "PROVIDER_NOT_READY";
    }
  }, ge = class Ri extends j {
    constructor(h, s) {
      super(h, s), Object.setPrototypeOf(this, Ri.prototype), this.name = "TargetingKeyMissingError", this.code = "TARGETING_KEY_MISSING";
    }
  }, Ve = class Ci extends j {
    constructor(h, s) {
      super(h, s), Object.setPrototypeOf(this, Ci.prototype), this.name = "TypeMismatchError", this.code = "TYPE_MISMATCH";
    }
  }, Te = (l, h) => {
    switch (l) {
      case "FLAG_NOT_FOUND":
        return new x(h);
      case "PARSE_ERROR":
        return new be(h);
      case "TYPE_MISMATCH":
        return new Ve(h);
      case "TARGETING_KEY_MISSING":
        return new ge(h);
      case "INVALID_CONTEXT":
        return new Y(h);
      case "PROVIDER_NOT_READY":
        return new oe(h);
      case "PROVIDER_FATAL":
        return new we(h);
      default:
        return new B(h);
    }
  }, re = /* @__PURE__ */ ((l) => (l.NOT_READY = "NOT_READY", l.READY = "READY", l.ERROR = "ERROR", l.STALE = "STALE", l.FATAL = "FATAL", l))(re || {}), pe = /* @__PURE__ */ ((l) => (l.NOT_READY = "NOT_READY", l.READY = "READY", l.ERROR = "ERROR", l.STALE = "STALE", l.FATAL = "FATAL", l.RECONCILING = "RECONCILING", l))(pe || {}), De = class extends j {
    constructor(l, h) {
      super(h), this.code = l;
    }
  }, he = class Ni extends B {
    constructor(h, s) {
      super(h), this.originalErrors = s, Object.setPrototypeOf(this, Ni.prototype), this.name = "AggregateError";
    }
  }, ne = (l) => {
    const h = l.map(({ providerName: g, error: y }) => ({ source: g, error: y })).flat(), s = h[0], c = s ? `Provider errors occurred: ${s.source}: ${s.error}` : "Provider errors occurred";
    return new he(c, h);
  }, ke = (l, h) => {
    const s = l.map((c, g) => c.status === "rejected" ? { error: c.reason, providerName: h[g].name } : null).filter((c) => !!c);
    if (s.length)
      throw ne(s);
  }, He = class {
    constructor(l, h, s) {
      this.events = l, this.statusEnum = h, this.eventEnum = s, this.providerStatuses = {};
    }
    wrapEventHandler(l) {
      var h, s, c, g, y;
      const A = l.provider;
      (h = A.events) == null || h.addHandler(this.eventEnum.Error, (T) => {
        this.changeProviderStatus(l.name, this.statusEnum.ERROR, T);
      }), (s = A.events) == null || s.addHandler(this.eventEnum.Stale, (T) => {
        this.changeProviderStatus(l.name, this.statusEnum.STALE, T);
      }), (c = A.events) == null || c.addHandler(this.eventEnum.ConfigurationChanged, (T) => {
        this.events.emit(this.eventEnum.ConfigurationChanged, T);
      }), (g = A.events) == null || g.addHandler(this.eventEnum.Ready, (T) => {
        this.changeProviderStatus(l.name, this.statusEnum.READY, T);
      });
      const F = this.eventEnum.Reconciling, I = this.statusEnum.RECONCILING;
      F && I && ((y = A.events) == null || y.addHandler(F, (T) => {
        this.changeProviderStatus(l.name, I, T);
      }));
    }
    providerStatus(l) {
      return this.providerStatuses[l];
    }
    getStatusFromProviderStatuses() {
      const l = Object.values(this.providerStatuses);
      return l.includes(this.statusEnum.FATAL) ? this.statusEnum.FATAL : l.includes(this.statusEnum.NOT_READY) ? this.statusEnum.NOT_READY : l.includes(this.statusEnum.ERROR) ? this.statusEnum.ERROR : l.includes(this.statusEnum.STALE) ? this.statusEnum.STALE : this.statusEnum.RECONCILING && l.includes(this.statusEnum.RECONCILING) ? this.statusEnum.RECONCILING : this.statusEnum.READY;
    }
    changeProviderStatus(l, h, s) {
      const c = this.getStatusFromProviderStatuses();
      this.providerStatuses[l] = h;
      const g = this.getStatusFromProviderStatuses();
      if (c !== g)
        if (g === this.statusEnum.FATAL || g === this.statusEnum.ERROR)
          this.events.emit(this.eventEnum.Error, s);
        else if (g === this.statusEnum.STALE)
          this.events.emit(this.eventEnum.Stale, s);
        else if (g === this.statusEnum.READY)
          this.events.emit(this.eventEnum.Ready, s);
        else {
          const y = this.eventEnum.Reconciling;
          y && this.statusEnum.RECONCILING && g === this.statusEnum.RECONCILING && this.events.emit(y, s);
        }
    }
  }, Oe = class {
    constructor(l) {
      this.statusEnum = l, this.runMode = "sequential";
    }
    shouldEvaluateThisProvider(l, h) {
      return !(l.providerStatus === this.statusEnum.NOT_READY || l.providerStatus === this.statusEnum.FATAL);
    }
    shouldEvaluateNextProvider(l, h, s) {
      return !0;
    }
    shouldTrackWithThisProvider(l, h, s, c) {
      return !(l.providerStatus === this.statusEnum.NOT_READY || l.providerStatus === this.statusEnum.FATAL);
    }
    hasError(l) {
      return "thrownError" in l || !!l.details.errorCode;
    }
    hasErrorWithCode(l, h) {
      var s;
      return "thrownError" in l ? ((s = l.thrownError) == null ? void 0 : s.code) === h : l.details.errorCode === h;
    }
    collectProviderErrors(l) {
      var h;
      const s = [];
      for (const c of l)
        "thrownError" in c ? s.push({ providerName: c.providerName, error: c.thrownError }) : c.details.errorCode && s.push({
          providerName: c.providerName,
          error: new De(c.details.errorCode, (h = c.details.errorMessage) != null ? h : "unknown error")
        });
      return { errors: s };
    }
    resolutionToFinalResult(l) {
      return { details: l.details, provider: l.provider, providerName: l.providerName };
    }
  }, Ne = class extends Oe {
    shouldEvaluateNextProvider(l, h, s) {
      return this.hasErrorWithCode(
        s,
        "FLAG_NOT_FOUND"
        /* FLAG_NOT_FOUND */
      ) ? !0 : (this.hasError(s), !1);
    }
    determineFinalResult(l, h, s) {
      const c = s[s.length - 1];
      return this.hasError(c) ? this.collectProviderErrors(s) : this.resolutionToFinalResult(c);
    }
  }, W = class extends Oe {
    shouldEvaluateNextProvider(l, h, s) {
      return this.hasError(s);
    }
    determineFinalResult(l, h, s) {
      const c = s[s.length - 1];
      return this.hasError(c) ? this.collectProviderErrors(s) : this.resolutionToFinalResult(c);
    }
  }, fe = class extends Oe {
    constructor(l, h, s) {
      super(l), this.fallbackProvider = h, this.onMismatch = s, this.runMode = "parallel";
    }
    determineFinalResult(l, h, s) {
      var c;
      let g, y, A, F = !1;
      for (const [I, T] of s.entries()) {
        if (this.hasError(T))
          return this.collectProviderErrors(s);
        T.provider === this.fallbackProvider && (y = T), I === 0 && (A = T), typeof g < "u" && g !== T.details.value ? F = !0 : g = T.details.value;
      }
      if (!y)
        throw new B("Fallback provider not found in resolution results");
      if (!A)
        throw new B("Final resolution not found in resolution results");
      return F ? ((c = this.onMismatch) == null || c.call(this, s), {
        details: y.details,
        provider: y.provider
      }) : this.resolutionToFinalResult(A);
    }
  }, Se = /* @__PURE__ */ ((l) => (l.Ready = "PROVIDER_READY", l.Error = "PROVIDER_ERROR", l.ConfigurationChanged = "PROVIDER_CONFIGURATION_CHANGED", l.Stale = "PROVIDER_STALE", l))(Se || {}), Q = /* @__PURE__ */ ((l) => (l.Ready = "PROVIDER_READY", l.Error = "PROVIDER_ERROR", l.ConfigurationChanged = "PROVIDER_CONFIGURATION_CHANGED", l.ContextChanged = "PROVIDER_CONTEXT_CHANGED", l.Reconciling = "PROVIDER_RECONCILING", l.Stale = "PROVIDER_STALE", l))(Q || {}), Ae = {
    READY: "PROVIDER_READY",
    ERROR: "PROVIDER_ERROR",
    FATAL: "PROVIDER_ERROR",
    STALE: "PROVIDER_STALE",
    RECONCILING: "PROVIDER_RECONCILING",
    NOT_READY: void 0
  }, Me = (l, h) => !h && l === "PROVIDER_READY" || Ae[h] === l, me = class {
    error(...l) {
      console.error(...l);
    }
    warn(...l) {
      console.warn(...l);
    }
    info() {
    }
    debug() {
    }
  }, Z = ["error", "warn", "info", "debug"], J = class {
    constructor(l) {
      this.fallbackLogger = new me();
      try {
        for (const h of Z)
          if (!l[h] || typeof l[h] != "function")
            throw new Error(`The provided logger is missing the ${h} method.`);
        this.logger = l;
      } catch (h) {
        console.error(h), console.error("Falling back to the default logger."), this.logger = this.fallbackLogger;
      }
    }
    error(...l) {
      this.log("error", ...l);
    }
    warn(...l) {
      this.log("warn", ...l);
    }
    info(...l) {
      this.log("info", ...l);
    }
    debug(...l) {
      this.log("debug", ...l);
    }
    log(l, ...h) {
      try {
        this.logger[l](...h);
      } catch {
        this.fallbackLogger[l](...h);
      }
    }
  }, Le = class {
    constructor(l) {
      this.globalLogger = l, this._handlers = {
        PROVIDER_CONFIGURATION_CHANGED: /* @__PURE__ */ new WeakMap(),
        PROVIDER_CONTEXT_CHANGED: /* @__PURE__ */ new WeakMap(),
        PROVIDER_READY: /* @__PURE__ */ new WeakMap(),
        PROVIDER_ERROR: /* @__PURE__ */ new WeakMap(),
        PROVIDER_STALE: /* @__PURE__ */ new WeakMap(),
        PROVIDER_RECONCILING: /* @__PURE__ */ new WeakMap()
      };
    }
    // here we use E, to restrict the events a provider can manually emit (PROVIDER_CONTEXT_CHANGED is emitted by the SDK)
    emit(l, h) {
      this.eventEmitter.emit(l, h);
    }
    addHandler(l, h) {
      const s = (g) => m(this, null, function* () {
        var y;
        try {
          yield h(g);
        } catch (A) {
          (y = this._logger) == null || y.error("Error running event handler:", A);
        }
      }), c = this._handlers[l].get(h);
      this._handlers[l].set(h, [...c || [], s]), this.eventEmitter.on(l, s);
    }
    removeHandler(l, h) {
      const s = this._handlers[l].get(h);
      if (s) {
        const c = s.pop();
        c && this.eventEmitter.removeListener(l, c);
      }
    }
    removeAllHandlers(l) {
      l ? this.eventEmitter.removeAllListeners(l) : this.eventEmitter.removeAllListeners();
    }
    getHandlers(l) {
      return this.eventEmitter.listeners(l);
    }
    setLogger(l) {
      return this._eventLogger = new J(l), this;
    }
    get _logger() {
      var l, h;
      return (h = this._eventLogger) != null ? h : (l = this.globalLogger) == null ? void 0 : l.call(this);
    }
  }, ee = {
    /**
     * The lookup key of the feature flag.
     *
     * - type: `string`
     * - requirement level: `required`
     * - example: `logo-color`
     */
    KEY: "feature_flag.key",
    /**
     * Describes a class of error the operation ended with.
     *
     * - type: `string`
     * - requirement level: `conditionally required`
     * - condition: `reason` is `error`
     * - example: `flag_not_found`
     */
    ERROR_CODE: "error.type",
    /**
     * A message explaining the nature of an error occurring during flag evaluation.
     *
     * - type: `string`
     * - requirement level: `recommended`
     * - example: `Flag not found`
     */
    ERROR_MESSAGE: "error.message",
    /**
     * A semantic identifier for an evaluated flag value.
     *
     * - type: `string`
     * - requirement level: `conditionally required`
     * - condition: variant is defined on the evaluation details
     * - example: `blue`; `on`; `true`
     */
    VARIANT: "feature_flag.result.variant",
    /**
     * The evaluated value of the feature flag.
     *
     * - type: `undefined`
     * - requirement level: `conditionally required`
     * - example: `#ff0000`; `1`; `true`
     */
    VALUE: "feature_flag.result.value",
    /**
     * The unique identifier for the flag evaluation context. For example, the targeting key.
     *
     * - type: `string`
     * - requirement level: `recommended`
     * - example: `5157782b-2203-4c80-a857-dbbd5e7761db`
     */
    CONTEXT_ID: "feature_flag.context.id",
    /**
     * The reason code which shows how a feature flag value was determined.
     *
     * - type: `string`
     * - requirement level: `recommended`
     * - example: `targeting_match`
     */
    REASON: "feature_flag.result.reason",
    /**
     * Describes a class of error the operation ended with.
     *
     * - type: `string`
     * - requirement level: `recommended`
     * - example: `flag_not_found`
     */
    PROVIDER: "feature_flag.provider.name",
    /**
     * The identifier of the flag set to which the feature flag belongs.
     *
     * - type: `string`
     * - requirement level: `recommended`
     * - example: `proj-1`; `ab98sgs`; `service1/dev`
     */
    FLAG_SET_ID: "feature_flag.set.id",
    /**
     * The version of the ruleset used during the evaluation. This may be any stable value which uniquely identifies the ruleset.
     *
     * - type: `string`
     * - requirement level: `recommended`
     * - example: `1.0.0`; `2021-01-01`
     */
    VERSION: "feature_flag.version"
  }, ye = {
    /**
     * The context identifier returned in the flag metadata uniquely identifies
     * the subject of the flag evaluation. If not available, the targeting key
     * should be used.
     */
    CONTEXT_ID: "contextId",
    /**
     * 	A logical identifier for the flag set.
     */
    FLAG_SET_ID: "flagSetId",
    /**
     * 	A version string (format unspecified) for the flag or flag set.
     */
    VERSION: "version"
  }, Ge = "feature_flag.evaluation";
  function Be(l, h) {
    var s, c, g;
    const y = {
      [ee.KEY]: l.flagKey,
      [ee.PROVIDER]: l.providerMetadata.name,
      [ee.REASON]: ((s = h.reason) != null ? s : k.UNKNOWN).toLowerCase()
    };
    if (h.variant && (y[ee.VARIANT] = h.variant), h.value !== null)
      if (typeof h.value != "object")
        y[ee.VALUE] = h.value;
      else
        try {
          y[ee.VALUE] = JSON.stringify(h.value);
        } catch {
        }
    const A = (c = h.flagMetadata[ye.CONTEXT_ID]) != null ? c : l.context.targetingKey;
    A && (y[ee.CONTEXT_ID] = A);
    const F = h.flagMetadata[ye.FLAG_SET_ID];
    F && (y[ee.FLAG_SET_ID] = F);
    const I = h.flagMetadata[ye.VERSION];
    return I && (y[ee.VERSION] = I), h.reason === k.ERROR && (y[ee.ERROR_CODE] = ((g = h.errorCode) != null ? g : "GENERAL").toLowerCase(), h.errorMessage && (y[ee.ERROR_MESSAGE] = h.errorMessage)), {
      name: Ge,
      attributes: y
    };
  }
  function N(l) {
    return typeof l == "string";
  }
  function f(l) {
    return N(l) ? l : void 0;
  }
  function p(l) {
    return typeof l == "object";
  }
  function R(l) {
    return p(l) ? l : void 0;
  }
  function C(l) {
    return typeof l < "u" && l !== null;
  }
  var D = class {
    constructor(l, h, s) {
      this._provider = l, this._status = h, this._pendingContextChanges = 0;
      var c, g, y;
      (c = l.events) == null || c.addHandler("PROVIDER_READY", () => {
        this._status = s.READY;
      }), (g = l.events) == null || g.addHandler("PROVIDER_STALE", () => {
        this._status = s.STALE;
      }), (y = l.events) == null || y.addHandler("PROVIDER_ERROR", (A) => {
        A?.errorCode === "PROVIDER_FATAL" ? this._status = s.FATAL : this._status = s.ERROR;
      });
    }
    get provider() {
      return this._provider;
    }
    set provider(l) {
      this._provider = l;
    }
    get status() {
      return this._status;
    }
    set status(l) {
      this._status = l;
    }
    get allContextChangesSettled() {
      return this._pendingContextChanges === 0;
    }
    incrementPendingContextChanges() {
      this._pendingContextChanges++;
    }
    decrementPendingContextChanges() {
      this._pendingContextChanges--;
    }
  }, L = class {
    constructor(l) {
      this._hooks = [], this._context = {}, this._logger = new me(), this._clientEventHandlers = /* @__PURE__ */ new Map(), this._domainScopedContext = /* @__PURE__ */ new Map(), this._clientEvents = /* @__PURE__ */ new Map(), this._runsOn = l;
    }
    addHooks(...l) {
      return this._hooks = [...this._hooks, ...l], this;
    }
    getHooks() {
      return this._hooks;
    }
    clearHooks() {
      return this._hooks = [], this;
    }
    setLogger(l) {
      return this._logger = new J(l), this;
    }
    /**
     * Get metadata about the default provider.
     * @returns {ProviderMetadata} Provider Metadata
     */
    get providerMetadata() {
      return this.getProviderMetadata();
    }
    /**
     * Get metadata about a registered provider using the client name.
     * An unbound or empty client name will return metadata from the default provider.
     * @param {string} domain An identifier which logically binds clients with providers
     * @returns {ProviderMetadata} Provider Metadata
     */
    getProviderMetadata(l) {
      return this.getProviderForClient(l).metadata;
    }
    /**
     * Adds a handler for the given provider event type.
     * The handlers are called in the order they have been added.
     * API (global) events run for all providers.
     * @param {AnyProviderEvent} eventType The provider event type to listen to
     * @param {EventHandler} handler The handler to run on occurrence of the event type
     * @param {EventOptions} options Optional options such as signal for aborting
     */
    addHandler(l, h, s) {
      [.../* @__PURE__ */ new Map([[void 0, this._defaultProvider]]), ...this._domainScopedProviders].forEach((c) => {
        var g;
        const y = c[0], A = c[1].provider, F = c[1].status;
        if (Me(l, F))
          try {
            h({ domain: y, providerName: A.metadata.name });
          } catch (T) {
            (g = this._logger) == null || g.error("Error running event handler:", T);
          }
      }), this._apiEmitter.addHandler(l, h), s?.signal && typeof s.signal.addEventListener == "function" && s.signal.addEventListener("abort", () => {
        this.removeHandler(l, h);
      });
    }
    /**
     * Removes a handler for the given provider event type.
     * @param {AnyProviderEvent} eventType The provider event type to remove the listener for
     * @param {EventHandler} handler The handler to remove for the provider event type
     */
    removeHandler(l, h) {
      this._apiEmitter.removeHandler(l, h);
    }
    /**
     * Removes all event handlers.
     */
    clearHandlers() {
      this._apiEmitter.removeAllHandlers();
    }
    /**
     * Gets the current handlers for the given provider event type.
     * @param {AnyProviderEvent} eventType The provider event type to get the current handlers for
     * @returns {EventHandler[]} The handlers currently attached to the given provider event type
     */
    getHandlers(l) {
      return this._apiEmitter.getHandlers(l);
    }
    setAwaitableProvider(l, h) {
      var s, c, g, y, A, F, I, T;
      const O = f(l), M = (s = R(l)) != null ? s : R(h);
      if (!M) {
        this._logger.debug("No provider defined, ignoring setProvider call");
        return;
      }
      const H = this.getProviderForClient(O), $ = M.metadata.name;
      if (H === M) {
        this._logger.debug("Provider is already set, ignoring setProvider call");
        return;
      }
      if (!M.runsOn)
        this._logger.debug(`Provider '${M.metadata.name}' has not defined its intended use.`);
      else if (M.runsOn !== this._runsOn)
        throw new B(`Provider '${M.metadata.name}' is intended for use on the ${M.runsOn}.`);
      const q = this.getAssociatedEventEmitters(O);
      let G;
      const ue = new D(
        M,
        this._statusEnumType.NOT_READY,
        this._statusEnumType
      );
      return typeof M.initialize == "function" && !this.allProviders.includes(M) ? G = (A = (y = (g = M.initialize) == null ? void 0 : g.call(M, O ? (c = this._domainScopedContext.get(O)) != null ? c : this._context : this._context)) == null ? void 0 : y.then(() => {
        var te;
        ue.status = this._statusEnumType.READY, this.getAssociatedEventEmitters(O).forEach((qe) => {
          qe?.emit("PROVIDER_READY", { clientName: O, domain: O, providerName: $ });
        }), (te = this._apiEmitter) == null || te.emit("PROVIDER_READY", { clientName: O, domain: O, providerName: $ });
      })) == null ? void 0 : A.catch((te) => {
        var qe;
        throw te?.code === "PROVIDER_FATAL" ? ue.status = this._statusEnumType.FATAL : ue.status = this._statusEnumType.ERROR, this.getAssociatedEventEmitters(O).forEach(($r) => {
          $r?.emit("PROVIDER_ERROR", {
            clientName: O,
            domain: O,
            providerName: $,
            message: te?.message
          });
        }), (qe = this._apiEmitter) == null || qe.emit("PROVIDER_ERROR", {
          clientName: O,
          domain: O,
          providerName: $,
          message: te?.message
        }), te;
      }) : (ue.status = this._statusEnumType.READY, q.forEach((te) => {
        te?.emit("PROVIDER_READY", { clientName: O, domain: O, providerName: $ });
      }), (F = this._apiEmitter) == null || F.emit("PROVIDER_READY", { clientName: O, domain: O, providerName: $ })), O ? this._domainScopedProviders.set(O, ue) : this._defaultProvider = ue, this.transferListeners(H, M, O, q), this.allProviders.includes(H) || (T = (I = H?.onClose) == null ? void 0 : I.call(H)) == null || T.catch((te) => {
        this._logger.error(`error closing provider: ${te?.message}, ${te?.stack}`);
      }), G;
    }
    getProviderForClient(l) {
      var h, s;
      return l ? (s = (h = this._domainScopedProviders.get(l)) == null ? void 0 : h.provider) != null ? s : this._defaultProvider.provider : this._defaultProvider.provider;
    }
    buildAndCacheEventEmitterForClient(l) {
      const h = this._clientEvents.get(l);
      if (h)
        return h;
      const s = this._createEventEmitter();
      this._clientEvents.set(l, s);
      const c = this.getProviderForClient(l);
      return Object.values(Q).forEach(
        (g) => {
          var y;
          return (y = c.events) == null ? void 0 : y.addHandler(g, (A) => m(this, null, function* () {
            s.emit(g, b(E({}, A), {
              clientName: l,
              domain: l,
              providerName: c.metadata.name
            }));
          }));
        }
      ), s;
    }
    getUnboundEmitters() {
      const l = [...this._domainScopedProviders.keys()];
      return [
        // all unbound, named emitters
        ...[...this._clientEvents.keys()].filter(C).filter((c) => !l.includes(c)).map((c) => this._clientEvents.get(c)),
        // the default emitter
        this._clientEvents.get(void 0)
      ].filter(C);
    }
    getAssociatedEventEmitters(l) {
      return l ? [this.buildAndCacheEventEmitterForClient(l)] : this.getUnboundEmitters();
    }
    transferListeners(l, h, s, c) {
      var g;
      (g = this._clientEventHandlers.get(s)) == null || g.forEach((A) => {
        var F;
        return (F = l.events) == null ? void 0 : F.removeHandler(...A);
      });
      const y = Object.values(Q).map((A) => [A, (I) => m(this, null, function* () {
        c.forEach((T) => {
          T?.emit(A, b(E({}, I), { clientName: s, domain: s, providerName: h.metadata.name }));
        }), this._apiEmitter.emit(A, b(E({}, I), {
          clientName: s,
          domain: s,
          providerName: h.metadata.name
        }));
      })]);
      this._clientEventHandlers.set(s, y), y.forEach((A) => {
        var F;
        return (F = h.events) == null ? void 0 : F.addHandler(...A);
      });
    }
    close() {
      return m(this, null, function* () {
        var l, h;
        try {
          yield (h = (l = this == null ? void 0 : this._defaultProvider.provider) == null ? void 0 : l.onClose) == null ? void 0 : h.call(l);
        } catch (c) {
          this.handleShutdownError(this._defaultProvider.provider, c);
        }
        const s = Array.from(this._domainScopedProviders);
        yield Promise.all(
          s.map((c) => m(this, [c], function* ([, g]) {
            var y, A;
            try {
              yield (A = g == null ? void 0 : (y = g.provider).onClose) == null ? void 0 : A.call(y);
            } catch (F) {
              this.handleShutdownError(g?.provider, F);
            }
          }))
        );
      });
    }
    clearProvidersAndSetDefault(l) {
      return m(this, null, function* () {
        try {
          yield this.close();
        } catch {
          this._logger.error("Unable to cleanly close providers. Resetting to the default configuration.");
        } finally {
          this._domainScopedProviders.clear(), this._defaultProvider = new D(
            l,
            this._statusEnumType.NOT_READY,
            this._statusEnumType
          );
        }
      });
    }
    get allProviders() {
      return [
        ...[...this._domainScopedProviders.values()].map((l) => l.provider),
        this._defaultProvider.provider
      ];
    }
    handleShutdownError(l, h) {
      this._logger.error(`Error during shutdown of provider ${l.metadata.name}: ${h}`), this._logger.error(h?.stack);
    }
  };
  return Ut;
}
var Kr;
function Ra() {
  return Kr || (Kr = 1, (function(t) {
    var e = Object.create, r = Object.defineProperty, n = Object.defineProperties, i = Object.getOwnPropertyDescriptor, a = Object.getOwnPropertyDescriptors, o = Object.getOwnPropertyNames, u = Object.getOwnPropertySymbols, v = Object.getPrototypeOf, E = Object.prototype.hasOwnProperty, b = Object.prototype.propertyIsEnumerable, P = Reflect.get, d = (N, f, p) => f in N ? r(N, f, { enumerable: !0, configurable: !0, writable: !0, value: p }) : N[f] = p, w = (N, f) => {
      for (var p in f || (f = {}))
        E.call(f, p) && d(N, p, f[p]);
      if (u)
        for (var p of u(f))
          b.call(f, p) && d(N, p, f[p]);
      return N;
    }, m = (N, f) => n(N, a(f)), _ = (N, f) => function() {
      return f || (0, N[o(N)[0]])((f = { exports: {} }).exports, f), f.exports;
    }, S = (N, f) => {
      for (var p in f)
        r(N, p, { get: f[p], enumerable: !0 });
    }, k = (N, f, p, R) => {
      if (f && typeof f == "object" || typeof f == "function")
        for (let C of o(f))
          !E.call(N, C) && C !== p && r(N, C, { get: () => f[C], enumerable: !(R = i(f, C)) || R.enumerable });
      return N;
    }, z = (N, f, p) => (k(N, f, "default"), p && k(p, f, "default")), j = (N, f, p) => (p = N != null ? e(v(N)) : {}, k(
      // If the importer is in node compatibility mode or this is not an ESM
      // file that has been converted to a CommonJS file using a Babel-
      // compatible transform (i.e. "__esModule" has not been set), then set
      // "default" to the CommonJS "module.exports" for node compatibility.
      r(p, "default", { value: N, enumerable: !0 }),
      N
    )), x = (N) => k(r({}, "__esModule", { value: !0 }), N), B = (N, f, p) => P(v(N), p, f), Y = (N, f, p) => new Promise((R, C) => {
      var D = (h) => {
        try {
          l(p.next(h));
        } catch (s) {
          C(s);
        }
      }, L = (h) => {
        try {
          l(p.throw(h));
        } catch (s) {
          C(s);
        }
      }, l = (h) => h.done ? R(h.value) : Promise.resolve(h.value).then(D, L);
      l((p = p.apply(N, f)).next());
    }), be = _({
      "../../node_modules/eventemitter3/index.js"(N, f) {
        var p = Object.prototype.hasOwnProperty, R = "~";
        function C() {
        }
        Object.create && (C.prototype = /* @__PURE__ */ Object.create(null), new C().__proto__ || (R = !1));
        function D(s, c, g) {
          this.fn = s, this.context = c, this.once = g || !1;
        }
        function L(s, c, g, y, A) {
          if (typeof g != "function")
            throw new TypeError("The listener must be a function");
          var F = new D(g, y || s, A), I = R ? R + c : c;
          return s._events[I] ? s._events[I].fn ? s._events[I] = [s._events[I], F] : s._events[I].push(F) : (s._events[I] = F, s._eventsCount++), s;
        }
        function l(s, c) {
          --s._eventsCount === 0 ? s._events = new C() : delete s._events[c];
        }
        function h() {
          this._events = new C(), this._eventsCount = 0;
        }
        h.prototype.eventNames = function() {
          var c = [], g, y;
          if (this._eventsCount === 0) return c;
          for (y in g = this._events)
            p.call(g, y) && c.push(R ? y.slice(1) : y);
          return Object.getOwnPropertySymbols ? c.concat(Object.getOwnPropertySymbols(g)) : c;
        }, h.prototype.listeners = function(c) {
          var g = R ? R + c : c, y = this._events[g];
          if (!y) return [];
          if (y.fn) return [y.fn];
          for (var A = 0, F = y.length, I = new Array(F); A < F; A++)
            I[A] = y[A].fn;
          return I;
        }, h.prototype.listenerCount = function(c) {
          var g = R ? R + c : c, y = this._events[g];
          return y ? y.fn ? 1 : y.length : 0;
        }, h.prototype.emit = function(c, g, y, A, F, I) {
          var T = R ? R + c : c;
          if (!this._events[T]) return !1;
          var O = this._events[T], M = arguments.length, H, $;
          if (O.fn) {
            switch (O.once && this.removeListener(c, O.fn, void 0, !0), M) {
              case 1:
                return O.fn.call(O.context), !0;
              case 2:
                return O.fn.call(O.context, g), !0;
              case 3:
                return O.fn.call(O.context, g, y), !0;
              case 4:
                return O.fn.call(O.context, g, y, A), !0;
              case 5:
                return O.fn.call(O.context, g, y, A, F), !0;
              case 6:
                return O.fn.call(O.context, g, y, A, F, I), !0;
            }
            for ($ = 1, H = new Array(M - 1); $ < M; $++)
              H[$ - 1] = arguments[$];
            O.fn.apply(O.context, H);
          } else {
            var q = O.length, G;
            for ($ = 0; $ < q; $++)
              switch (O[$].once && this.removeListener(c, O[$].fn, void 0, !0), M) {
                case 1:
                  O[$].fn.call(O[$].context);
                  break;
                case 2:
                  O[$].fn.call(O[$].context, g);
                  break;
                case 3:
                  O[$].fn.call(O[$].context, g, y);
                  break;
                case 4:
                  O[$].fn.call(O[$].context, g, y, A);
                  break;
                default:
                  if (!H) for (G = 1, H = new Array(M - 1); G < M; G++)
                    H[G - 1] = arguments[G];
                  O[$].fn.apply(O[$].context, H);
              }
          }
          return !0;
        }, h.prototype.on = function(c, g, y) {
          return L(this, c, g, y, !1);
        }, h.prototype.once = function(c, g, y) {
          return L(this, c, g, y, !0);
        }, h.prototype.removeListener = function(c, g, y, A) {
          var F = R ? R + c : c;
          if (!this._events[F]) return this;
          if (!g)
            return l(this, F), this;
          var I = this._events[F];
          if (I.fn)
            I.fn === g && (!A || I.once) && (!y || I.context === y) && l(this, F);
          else {
            for (var T = 0, O = [], M = I.length; T < M; T++)
              (I[T].fn !== g || A && !I[T].once || y && I[T].context !== y) && O.push(I[T]);
            O.length ? this._events[F] = O.length === 1 ? O[0] : O : l(this, F);
          }
          return this;
        }, h.prototype.removeAllListeners = function(c) {
          var g;
          return c ? (g = R ? R + c : c, this._events[g] && l(this, g)) : (this._events = new C(), this._eventsCount = 0), this;
        }, h.prototype.off = h.prototype.removeListener, h.prototype.addListener = h.prototype.on, h.prefixed = R, h.EventEmitter = h, typeof f < "u" && (f.exports = h);
      }
    }), we = {};
    S(we, {
      ComparisonStrategy: () => Ae,
      FirstMatchStrategy: () => Se,
      FirstSuccessfulStrategy: () => Q,
      InMemoryProvider: () => Oe,
      MultiProvider: () => me,
      NOOP_PROVIDER: () => Te,
      OpenFeature: () => Be,
      OpenFeatureAPI: () => Ge,
      OpenFeatureEventEmitter: () => he,
      ProviderEvents: () => ne.ClientProviderEvents,
      ProviderStatus: () => oe.ClientProviderStatus,
      TypedInMemoryProvider: () => Ne
    }), t.exports = x(we);
    var oe = /* @__PURE__ */ je(), ge = "No-op", Ve = class {
      constructor() {
        this.metadata = {
          name: "No-op Provider"
        };
      }
      resolveBooleanEvaluation(N, f) {
        return this.noOp(f);
      }
      resolveStringEvaluation(N, f) {
        return this.noOp(f);
      }
      resolveNumberEvaluation(N, f) {
        return this.noOp(f);
      }
      resolveObjectEvaluation(N, f) {
        return this.noOp(f);
      }
      noOp(N) {
        return {
          value: N,
          reason: ge
        };
      }
    }, Te = new Ve(), re = /* @__PURE__ */ je(), pe = /* @__PURE__ */ je(), De = j(be()), he = class extends pe.GenericEventEmitter {
      constructor() {
        super(), this.eventEmitter = new De.default();
      }
    }, ne = /* @__PURE__ */ je(), ke = /* @__PURE__ */ je(), He = class Si extends ke.OpenFeatureError {
      constructor(f) {
        super(f), Object.setPrototypeOf(this, Si.prototype), this.name = "VariantNotFoundError", this.code = ke.ErrorCode.GENERAL;
      }
    }, Oe = class {
      constructor(N = {}) {
        this.events = new he(), this.runsOn = "client", this.metadata = {
          name: "in-memory"
        }, this._flagConfiguration = w({}, N);
      }
      /**
       * Overwrites the configured flags.
       * @param { FlagConfiguration } flagConfiguration new flag configuration
       */
      putConfiguration(N) {
        return Y(this, null, function* () {
          try {
            const f = Object.entries(w(w({}, N), this._flagConfiguration)).map(([p]) => p);
            this._flagConfiguration = w({}, N), this.events.emit(ne.ClientProviderEvents.ConfigurationChanged, { flagsChanged: f });
          } catch (f) {
            throw this.events.emit(ne.ClientProviderEvents.Error), f;
          }
        });
      }
      resolveBooleanEvaluation(N, f, p, R) {
        return this.resolveAndCheckFlag(N, f, p || this._context, R);
      }
      resolveNumberEvaluation(N, f, p, R) {
        return this.resolveAndCheckFlag(N, f, p || this._context, R);
      }
      resolveStringEvaluation(N, f, p, R) {
        return this.resolveAndCheckFlag(N, f, p || this._context, R);
      }
      resolveObjectEvaluation(N, f, p, R) {
        return this.resolveAndCheckFlag(N, f, p || this._context, R);
      }
      resolveAndCheckFlag(N, f, p, R) {
        if (!(N in this._flagConfiguration)) {
          const D = `no flag found with key ${N}`;
          throw R?.debug(D), new re.FlagNotFoundError(D);
        }
        if (this._flagConfiguration[N].disabled)
          return { value: f, reason: re.StandardResolutionReasons.DISABLED };
        const C = this.resolveFlagWithReason(N, p);
        if (C.value === void 0) {
          const D = `no value associated with variant provided for ${N} found`;
          throw R?.error(D), new He(D);
        }
        if (typeof C.value != typeof f)
          throw new re.TypeMismatchError();
        return C;
      }
      resolveFlagWithReason(N, f) {
        try {
          return this.lookupFlagValue(N, f);
        } catch (p) {
          throw p instanceof re.OpenFeatureError ? p : new re.GeneralError(p?.message || "unknown error");
        }
      }
      lookupFlagValue(N, f) {
        var p;
        const R = this._flagConfiguration[N], C = f && R?.contextEvaluator, D = C ? (p = R.contextEvaluator) == null ? void 0 : p.call(R, f) : R.defaultVariant, L = D && R?.variants[D], l = C ? re.StandardResolutionReasons.TARGETING_MATCH : re.StandardResolutionReasons.STATIC;
        return m(w({
          value: L
        }, D && { variant: D }), {
          reason: l
        });
      }
    }, Ne = class Ai extends Oe {
      constructor(f = {}) {
        super(f);
      }
      /**
       * Overwrites the configured flags.
       * @param { FlagConfiguration } flagConfiguration new flag configuration
       * @example
       * ```
       * await provider.putConfiguration({
       *   'my-flag': {
       *     variants: { on: true, off: false },
       *     defaultVariant: 'on',
       *     contextEvaluator: (ctx) => ctx?.user?.id === '123' ? 'on' : 'off',
       *     disabled: false,
       *   },
       * });
       *
       * const flags = {
       *   'my-flag': {
       *     variants: { on: true, off: false },
       *     defaultVariant: 'on',
       *     contextEvaluator: (ctx) => ctx?.user?.id === '123' ? 'on' : 'off',
       *     disabled: false,
       *   },
       * } as const; // 'as const' needed to preserve the `defaultVariant` narrow literal type rather than `string`
       * await provider.putConfiguration(flags);
       * ```
       */
      putConfiguration(f) {
        return Y(this, null, function* () {
          yield B(Ai.prototype, this, "putConfiguration").call(this, f);
        });
      }
    }, W = /* @__PURE__ */ je(), fe = /* @__PURE__ */ je(), Se = class extends fe.BaseFirstMatchStrategy {
      constructor() {
        super(oe.ClientProviderStatus);
      }
    }, Q = class extends fe.BaseFirstSuccessfulStrategy {
      constructor() {
        super(oe.ClientProviderStatus);
      }
    }, Ae = class extends fe.BaseComparisonStrategy {
      constructor(N, f) {
        super(oe.ClientProviderStatus, N, f);
      }
    }, Me = class {
      constructor(N) {
        this.logger = N;
      }
      beforeHooks(N, f, p) {
        var R;
        for (const C of N ?? [])
          (R = C?.before) == null || R.call(C, f, Object.freeze(p));
      }
      afterHooks(N, f, p, R) {
        var C;
        for (const D of N ?? [])
          (C = D?.after) == null || C.call(D, f, p, R);
      }
      errorHooks(N, f, p, R) {
        var C;
        for (const D of N ?? [])
          try {
            (C = D?.error) == null || C.call(D, f, p, R);
          } catch (L) {
            this.logger.error(`Unhandled error during 'error' hook: ${L}`), L instanceof Error && this.logger.error(L.stack);
          }
      }
      finallyHooks(N, f, p, R) {
        var C;
        for (const D of N ?? [])
          try {
            (C = D?.finally) == null || C.call(D, f, p, R);
          } catch (L) {
            this.logger.error(`Unhandled error during 'finally' hook: ${L}`), L instanceof Error && this.logger.error(L.stack);
          }
      }
    }, me = class Ii {
      constructor(f, p = new Se(), R = new W.DefaultLogger()) {
        this.constructorProviders = f, this.evaluationStrategy = p, this.logger = R, this.runsOn = "client", this.events = new he(), this.hookContexts = /* @__PURE__ */ new WeakMap(), this.hookHints = /* @__PURE__ */ new WeakMap(), this.providerEntries = [], this.providerEntriesByName = {}, this.statusTracker = new W.StatusTracker(this.events, oe.ClientProviderStatus, ne.ClientProviderEvents), this.hookExecutor = new Me(this.logger), this.registerProviders(f);
        const C = Object.keys(this.providerEntriesByName).reduce((D, L) => m(w({}, D), { [L]: this.providerEntriesByName[L].provider.metadata }), {});
        this.metadata = m(w({}, C), {
          name: Ii.name
        });
      }
      registerProviders(f) {
        var p, R;
        const C = {};
        for (const D of f) {
          const L = D.provider.metadata.name, l = (p = D.name) != null ? p : L;
          if (D.name && C[D.name])
            throw new Error("Provider names must be unique");
          (R = C[l]) != null || (C[l] = []), C[l].push(D.provider);
        }
        for (const D of Object.keys(C)) {
          const L = C[D].length > 1;
          for (let l = 0; l < C[D].length; l++) {
            const h = L ? `${D}-${l + 1}` : D;
            this.providerEntriesByName[h] = { provider: C[D][l], name: h }, this.providerEntries.push(this.providerEntriesByName[h]), this.statusTracker.wrapEventHandler(this.providerEntriesByName[h]);
          }
        }
        Object.freeze(this.providerEntries), Object.freeze(this.providerEntriesByName);
      }
      initialize(f) {
        return Y(this, null, function* () {
          const p = yield Promise.allSettled(
            this.providerEntries.map((R) => {
              var C, D;
              return (D = (C = R.provider).initialize) == null ? void 0 : D.call(C, f);
            })
          );
          (0, W.throwAggregateErrorFromPromiseResults)(p, this.providerEntries);
        });
      }
      onClose() {
        return Y(this, null, function* () {
          const f = yield Promise.allSettled(this.providerEntries.map((p) => {
            var R, C;
            return (C = (R = p.provider).onClose) == null ? void 0 : C.call(R);
          }));
          (0, W.throwAggregateErrorFromPromiseResults)(f, this.providerEntries);
        });
      }
      onContextChange(f, p) {
        return Y(this, null, function* () {
          var R, C;
          for (const D of this.providerEntries)
            yield (C = (R = D.provider).onContextChange) == null ? void 0 : C.call(R, f, p);
        });
      }
      resolveBooleanEvaluation(f, p, R) {
        return this.flagResolutionProxy(f, "boolean", p, R);
      }
      resolveStringEvaluation(f, p, R) {
        return this.flagResolutionProxy(f, "string", p, R);
      }
      resolveNumberEvaluation(f, p, R) {
        return this.flagResolutionProxy(f, "number", p, R);
      }
      resolveObjectEvaluation(f, p, R) {
        return this.flagResolutionProxy(f, "object", p, R);
      }
      track(f, p, R) {
        var C, D;
        for (const L of this.providerEntries) {
          if (!L.provider.track)
            continue;
          const l = {
            provider: L.provider,
            providerName: L.name,
            providerStatus: this.statusTracker.providerStatus(L.name)
          };
          if (this.evaluationStrategy.shouldTrackWithThisProvider(
            l,
            p,
            f,
            R
          ))
            try {
              (D = (C = L.provider).track) == null || D.call(C, f, p, R);
            } catch (h) {
              this.logger.error(
                `Error tracking event "${f}" with provider "${L.name}":`,
                h
              );
            }
        }
      }
      flagResolutionProxy(f, p, R, C) {
        var D;
        const L = this.hookContexts.get(C), l = this.hookHints.get(C);
        if (!L || !l)
          throw new W.GeneralError("Hook context not available for evaluation");
        const h = [];
        for (const g of this.providerEntries) {
          const [y, A] = this.evaluateProviderEntry(
            f,
            p,
            R,
            g,
            L,
            l,
            C
          );
          if (h.push(A), !y)
            break;
        }
        const s = h.filter(
          (g) => !!g
        ), c = this.evaluationStrategy.determineFinalResult({ flagKey: f, flagType: p }, C, s);
        if ((D = c.errors) != null && D.length)
          throw (0, W.constructAggregateError)(c.errors);
        if (!c.details)
          throw new W.GeneralError("No result was returned from any provider");
        return c.details;
      }
      evaluateProviderEntry(f, p, R, C, D, L, l) {
        let h;
        const s = C.provider, c = {
          flagKey: f,
          flagType: p,
          provider: s,
          providerName: C.name,
          providerStatus: this.statusTracker.providerStatus(C.name)
        };
        if (!this.evaluationStrategy.shouldEvaluateThisProvider(c, l))
          return [!0, null];
        let g;
        try {
          h = this.evaluateProviderAndHooks(f, R, s, D, L), g = {
            details: h,
            provider: s,
            providerName: C.name
          };
        } catch (y) {
          g = {
            thrownError: y,
            provider: s,
            providerName: C.name
          };
        }
        return [this.evaluationStrategy.shouldEvaluateNextProvider(c, l, g), g];
      }
      evaluateProviderAndHooks(f, p, R, C, D) {
        var L;
        let l;
        try {
          this.hookExecutor.beforeHooks(R.hooks, C, D);
          const h = this.callProviderResolve(
            R,
            f,
            p,
            C.context
          );
          l = m(w({}, h), {
            flagMetadata: Object.freeze((L = h.flagMetadata) != null ? L : {}),
            flagKey: f
          }), this.hookExecutor.afterHooks(R.hooks, C, l, D);
        } catch (h) {
          this.hookExecutor.errorHooks(R.hooks, C, h, D), l = this.getErrorEvaluationDetails(f, p, h);
        }
        return this.hookExecutor.finallyHooks(R.hooks, C, l, D), l;
      }
      callProviderResolve(f, p, R, C) {
        switch (typeof R) {
          case "string":
            return f.resolveStringEvaluation(p, R, C, this.logger);
          case "number":
            return f.resolveNumberEvaluation(p, R, C, this.logger);
          case "object":
            return f.resolveObjectEvaluation(p, R, C, this.logger);
          case "boolean":
            return f.resolveBooleanEvaluation(p, R, C, this.logger);
          default:
            throw new W.GeneralError("Invalid flag evaluation type");
        }
      }
      get hooks() {
        return [
          {
            before: (f, p) => (this.hookContexts.set(f.context, f), this.hookHints.set(f.context, p ?? {}), f.context)
          }
        ];
      }
      getErrorEvaluationDetails(f, p, R, C = {}) {
        const D = R?.message;
        return {
          errorCode: R?.code || W.ErrorCode.GENERAL,
          errorMessage: D,
          value: p,
          reason: W.StandardResolutionReasons.ERROR,
          flagMetadata: Object.freeze(C),
          flagKey: f
        };
      }
    }, Z = /* @__PURE__ */ je(), J = /* @__PURE__ */ je(), Le = class {
      constructor(N, f, p, R, C, D, L) {
        this.providerAccessor = N, this.providerStatusAccessor = f, this.emitterAccessor = p, this.apiContextAccessor = R, this.apiHooksAccessor = C, this.globalLogger = D, this.options = L, this._hooks = [];
      }
      get metadata() {
        var N, f;
        return {
          // Use domain if name is not provided
          name: (N = this.options.domain) != null ? N : this.options.name,
          domain: (f = this.options.domain) != null ? f : this.options.name,
          version: this.options.version,
          providerMetadata: this.providerAccessor().metadata
        };
      }
      get providerStatus() {
        return this.providerStatusAccessor();
      }
      addHandler(N, f, p) {
        var R;
        if (this.emitterAccessor().addHandler(N, f), (0, J.statusMatchesEvent)(N, this.providerStatus))
          try {
            f({
              clientName: this.metadata.name,
              domain: this.metadata.domain,
              providerName: this._provider.metadata.name
            });
          } catch (D) {
            (R = this._logger) == null || R.error("Error running event handler:", D);
          }
        p?.signal && typeof p.signal.addEventListener == "function" && p.signal.addEventListener("abort", () => {
          this.removeHandler(N, f);
        });
      }
      removeHandler(N, f) {
        this.emitterAccessor().removeHandler(N, f);
      }
      getHandlers(N) {
        return this.emitterAccessor().getHandlers(N);
      }
      setLogger(N) {
        return this._clientLogger = new J.SafeLogger(N), this;
      }
      addHooks(...N) {
        return this._hooks = [...this._hooks, ...N], this;
      }
      getHooks() {
        return this._hooks;
      }
      clearHooks() {
        return this._hooks = [], this;
      }
      getBooleanValue(N, f, p) {
        return this.getBooleanDetails(N, f, p).value;
      }
      getBooleanDetails(N, f, p) {
        return this.evaluate(N, this._provider.resolveBooleanEvaluation, f, "boolean", p);
      }
      getStringValue(N, f, p) {
        return this.getStringDetails(N, f, p).value;
      }
      getStringDetails(N, f, p) {
        return this.evaluate(
          N,
          // this isolates providers from our restricted string generic argument.
          this._provider.resolveStringEvaluation,
          f,
          "string",
          p
        );
      }
      getNumberValue(N, f, p) {
        return this.getNumberDetails(N, f, p).value;
      }
      getNumberDetails(N, f, p) {
        return this.evaluate(
          N,
          // this isolates providers from our restricted number generic argument.
          this._provider.resolveNumberEvaluation,
          f,
          "number",
          p
        );
      }
      getObjectValue(N, f, p) {
        return this.getObjectDetails(N, f, p).value;
      }
      getObjectDetails(N, f, p) {
        return this.evaluate(N, this._provider.resolveObjectEvaluation, f, "object", p);
      }
      track(N, f = {}) {
        var p, R, C;
        try {
          if (this.shortCircuitIfNotReady(), typeof this._provider.track == "function") {
            const D = Object.freeze(w({}, this.apiContextAccessor((p = this == null ? void 0 : this.options) == null ? void 0 : p.domain)));
            return (C = (R = this._provider).track) == null ? void 0 : C.call(R, N, D, f);
          } else
            this._logger.debug("Provider does not support the track function; will no-op.");
        } catch (D) {
          this._logger.debug("Error recording tracking event.", D);
        }
      }
      evaluate(N, f, p, R, C = {}) {
        var D, L;
        const l = [
          ...this.apiHooksAccessor(),
          ...this.getHooks(),
          ...C.hooks || [],
          ...this._provider.hooks || []
        ], h = [...l].reverse(), s = w({}, this.apiContextAccessor((D = this == null ? void 0 : this.options) == null ? void 0 : D.domain)), c = h.map(
          () => Object.freeze({
            flagKey: N,
            defaultValue: p,
            flagValueType: R,
            clientMetadata: this.metadata,
            providerMetadata: this._provider.metadata,
            context: s,
            logger: this._logger,
            hookData: new J.MapHookData()
          })
        );
        let g;
        try {
          this.beforeHooks(l, c, C), this.shortCircuitIfNotReady();
          const y = f.call(this._provider, N, p, s, this._logger), A = m(w({}, y), {
            flagMetadata: Object.freeze((L = y.flagMetadata) != null ? L : {}),
            flagKey: N
          });
          if (A.errorCode) {
            const F = (0, J.instantiateErrorByErrorCode)(A.errorCode, A.errorMessage);
            this.errorHooks(h, c, F, C), g = this.getErrorEvaluationDetails(N, p, F, A.flagMetadata);
          } else
            this.afterHooks(h, c, A, C), g = A;
        } catch (y) {
          this.errorHooks(h, c, y, C), g = this.getErrorEvaluationDetails(N, p, y);
        }
        return this.finallyHooks(h, c, g, C), g;
      }
      beforeHooks(N, f, p) {
        var R;
        for (const [C, D] of N.entries()) {
          const L = N.length - 1 - C, l = f[L];
          Object.freeze(l), Object.freeze(l.context), (R = D?.before) == null || R.call(D, l, Object.freeze(p.hookHints));
        }
      }
      afterHooks(N, f, p, R) {
        var C;
        for (const [D, L] of N.entries()) {
          const l = f[D];
          (C = L?.after) == null || C.call(L, l, p, R.hookHints);
        }
      }
      errorHooks(N, f, p, R) {
        var C;
        for (const [D, L] of N.entries())
          try {
            const l = f[D];
            (C = L?.error) == null || C.call(L, l, p, R.hookHints);
          } catch (l) {
            this._logger.error(`Unhandled error during 'error' hook: ${l}`), l instanceof Error && this._logger.error(l.stack), this._logger.error(l?.stack);
          }
      }
      finallyHooks(N, f, p, R) {
        var C;
        for (const [D, L] of N.entries())
          try {
            const l = f[D];
            (C = L?.finally) == null || C.call(L, l, p, R.hookHints);
          } catch (l) {
            this._logger.error(`Unhandled error during 'finally' hook: ${l}`), l instanceof Error && this._logger.error(l.stack), this._logger.error(l?.stack);
          }
      }
      get _provider() {
        return this.providerAccessor();
      }
      get _logger() {
        return this._clientLogger || this.globalLogger();
      }
      shortCircuitIfNotReady() {
        if (this.providerStatus === oe.ClientProviderStatus.NOT_READY)
          throw new J.ProviderNotReadyError("provider has not yet initialized");
        if (this.providerStatus === oe.ClientProviderStatus.FATAL)
          throw new J.ProviderFatalError("provider is in an irrecoverable error state");
      }
      getErrorEvaluationDetails(N, f, p, R = {}) {
        const C = p?.message;
        return {
          errorCode: p?.code || J.ErrorCode.GENERAL,
          errorMessage: C,
          value: f,
          reason: J.StandardResolutionReasons.ERROR,
          flagMetadata: Object.freeze(R),
          flagKey: N
        };
      }
    }, ee = /* @__PURE__ */ Symbol.for("@openfeature/web-sdk/api"), ye = globalThis, Ge = class Rr extends Z.OpenFeatureCommonAPI {
      constructor() {
        super("client"), this._statusEnumType = oe.ClientProviderStatus, this._apiEmitter = new he(), this._defaultProvider = new Z.ProviderWrapper(
          Te,
          oe.ClientProviderStatus.NOT_READY,
          this._statusEnumType
        ), this._domainScopedProviders = /* @__PURE__ */ new Map(), this._createEventEmitter = () => new he();
      }
      /**
       * Gets a singleton instance of the OpenFeature API.
       * @ignore
       * @returns {OpenFeatureAPI} OpenFeature API
       */
      static getInstance() {
        const f = ye[ee];
        if (f)
          return f;
        const p = new Rr();
        return ye[ee] = p, p;
      }
      getProviderStatus(f) {
        var p, R;
        return f ? (R = (p = this._domainScopedProviders.get(f)) == null ? void 0 : p.status) != null ? R : this._defaultProvider.status : this._defaultProvider.status;
      }
      setProviderAndWait(f, p, R) {
        return Y(this, null, function* () {
          const C = (0, Z.stringOrUndefined)(f), D = C ? (0, Z.objectOrUndefined)(p) : (0, Z.objectOrUndefined)(f), L = C ? (0, Z.objectOrUndefined)(R) : (0, Z.objectOrUndefined)(p);
          L && (C ? this._domainScopedContext.set(C, L) : this._context = L), yield this.setAwaitableProvider(C, D);
        });
      }
      setProvider(f, p, R) {
        const C = (0, Z.stringOrUndefined)(f), D = C ? (0, Z.objectOrUndefined)(p) : (0, Z.objectOrUndefined)(f), L = C ? (0, Z.objectOrUndefined)(R) : (0, Z.objectOrUndefined)(p);
        L && (C ? this._domainScopedContext.set(C, L) : this._context = L);
        const l = this.setAwaitableProvider(C, D);
        return Promise.resolve(l).catch((h) => {
          this._logger.error("Error during provider initialization:", h);
        }), this;
      }
      getProvider(f) {
        return this.getProviderForClient(f);
      }
      setContext(f, p) {
        return Y(this, null, function* () {
          var R, C;
          const D = (0, Z.stringOrUndefined)(f), L = (C = (R = (0, Z.objectOrUndefined)(f)) != null ? R : (0, Z.objectOrUndefined)(p)) != null ? C : {};
          if (D) {
            const l = this._domainScopedProviders.get(D);
            if (l) {
              const h = this.getContext(D);
              this._domainScopedContext.set(D, L), yield this.runProviderContextChangeHandler(D, l, h, L);
            } else
              this._domainScopedContext.set(D, L);
          } else {
            const l = this._context;
            this._context = L;
            const h = Array.from(this._domainScopedProviders.entries()).filter(([c]) => !this._domainScopedContext.has(c)).reduce((c, [g, y]) => (c.push({ domain: g, wrapper: y }), c), []), s = [
              // add in the default (no domain)
              { domain: void 0, wrapper: this._defaultProvider },
              ...h
            ];
            yield Promise.all(
              s.map((c) => this.runProviderContextChangeHandler(c.domain, c.wrapper, l, L))
            );
          }
        });
      }
      getContext(f) {
        const p = (0, Z.stringOrUndefined)(f);
        if (p) {
          const R = this._domainScopedContext.get(p);
          if (R)
            return R;
          this._logger.debug(`Unable to find context for '${p}'.`);
        }
        return this._context;
      }
      clearContext(f) {
        return Y(this, null, function* () {
          const p = (0, Z.stringOrUndefined)(f);
          if (p) {
            const R = this._domainScopedProviders.get(p);
            if (R) {
              const C = this.getContext(p);
              this._domainScopedContext.delete(p);
              const D = this.getContext();
              yield this.runProviderContextChangeHandler(p, R, C, D);
            } else
              this._domainScopedContext.delete(p);
          } else
            return this.setContext({});
        });
      }
      /**
       * Resets the global evaluation context and removes the evaluation context for
       * all domains.
       */
      clearContexts() {
        return Y(this, null, function* () {
          yield this.clearContext(), yield Promise.allSettled(Array.from(this._domainScopedProviders.keys()).map((f) => this.clearContext(f)));
        });
      }
      /**
       * A factory function for creating new domain-scoped OpenFeature clients. Clients
       * can contain their own state (e.g. logger, hook, context). Multiple domains
       * can be used to segment feature flag configuration.
       *
       * If there is already a provider bound to this name via {@link this.setProvider setProvider}, this provider will be used.
       * Otherwise, the default provider is used until a provider is assigned to that name.
       * @param {string} domain An identifier which logically binds clients with providers
       * @param {string} version The version of the client (only used for metadata)
       * @returns {Client} OpenFeature Client
       */
      getClient(f, p) {
        return new Le(
          // functions are passed here to make sure that these values are always up to date,
          // and so we don't have to make these public properties on the API class.
          () => this.getProviderForClient(f),
          () => this.getProviderStatus(f),
          () => this.buildAndCacheEventEmitterForClient(f),
          (R) => this.getContext(R),
          () => this.getHooks(),
          () => this._logger,
          { domain: f, version: p }
        );
      }
      /**
       * Clears all registered providers and resets the default provider.
       * @returns {Promise<void>}
       */
      clearProviders() {
        return Y(this, null, function* () {
          yield B(Rr.prototype, this, "clearProvidersAndSetDefault").call(this, Te), this._domainScopedContext.clear();
        });
      }
      runProviderContextChangeHandler(f, p, R, C) {
        return Y(this, null, function* () {
          var D, L, l, h, s, c;
          const g = ((L = (D = p.provider) == null ? void 0 : D.metadata) == null ? void 0 : L.name) || "unnamed-provider";
          try {
            if (typeof p.provider.onContextChange == "function") {
              const y = p.provider.onContextChange(R, C);
              y && typeof y?.then == "function" && (p.incrementPendingContextChanges(), p.status = this._statusEnumType.RECONCILING, this.getAssociatedEventEmitters(f).forEach((A) => {
                A?.emit(ne.ClientProviderEvents.Reconciling, { domain: f, providerName: g });
              }), (l = this._apiEmitter) == null || l.emit(ne.ClientProviderEvents.Reconciling, { domain: f, providerName: g }), yield y, p.decrementPendingContextChanges());
            }
            p.status = this._statusEnumType.READY, p.allContextChangesSettled && (this.getAssociatedEventEmitters(f).forEach((y) => {
              y?.emit(ne.ClientProviderEvents.ContextChanged, { clientName: f, domain: f, providerName: g });
            }), (h = this._apiEmitter) == null || h.emit(ne.ClientProviderEvents.ContextChanged, { clientName: f, domain: f, providerName: g }));
          } catch (y) {
            if (p.decrementPendingContextChanges(), p.status = this._statusEnumType.ERROR, p.allContextChangesSettled) {
              const A = y, F = `Error running ${g}'s context change handler: ${A?.message}`;
              (s = this._logger) == null || s.error(`${F}`, y), this.getAssociatedEventEmitters(f).forEach((I) => {
                I?.emit(ne.ClientProviderEvents.Error, { clientName: f, domain: f, providerName: g, message: F });
              }), (c = this._apiEmitter) == null || c.emit(ne.ClientProviderEvents.Error, { clientName: f, domain: f, providerName: g, message: F });
            }
          }
        });
      }
    }, Be = Ge.getInstance();
    z(we, /* @__PURE__ */ je(), t.exports);
  })(Ft)), Ft.exports;
}
var Vt, Jr;
function Ca() {
  if (Jr) return Vt;
  Jr = 1;
  var t = typeof ot == "object" && ot && ot.Object === Object && ot;
  return Vt = t, Vt;
}
var Ht, Qr;
function Na() {
  if (Qr) return Ht;
  Qr = 1;
  var t = Ca(), e = typeof self == "object" && self && self.Object === Object && self, r = t || e || Function("return this")();
  return Ht = r, Ht;
}
var Gt, Xr;
function Pi() {
  if (Xr) return Gt;
  Xr = 1;
  var t = Na(), e = t.Symbol;
  return Gt = e, Gt;
}
var Bt, Zr;
function Sa() {
  if (Zr) return Bt;
  Zr = 1;
  var t = Pi(), e = Object.prototype, r = e.hasOwnProperty, n = e.toString, i = t ? t.toStringTag : void 0;
  function a(o) {
    var u = r.call(o, i), v = o[i];
    try {
      o[i] = void 0;
      var E = !0;
    } catch {
    }
    var b = n.call(o);
    return E && (u ? o[i] = v : delete o[i]), b;
  }
  return Bt = a, Bt;
}
var $t, en;
function Aa() {
  if (en) return $t;
  en = 1;
  var t = Object.prototype, e = t.toString;
  function r(n) {
    return e.call(n);
  }
  return $t = r, $t;
}
var zt, tn;
function dt() {
  if (tn) return zt;
  tn = 1;
  var t = Pi(), e = Sa(), r = Aa(), n = "[object Null]", i = "[object Undefined]", a = t ? t.toStringTag : void 0;
  function o(u) {
    return u == null ? u === void 0 ? i : n : a && a in Object(u) ? e(u) : r(u);
  }
  return zt = o, zt;
}
var qt, rn;
function Ia() {
  if (rn) return qt;
  rn = 1;
  var t = Array.isArray;
  return qt = t, qt;
}
var Yt, nn;
function _t() {
  if (nn) return Yt;
  nn = 1;
  function t(e) {
    return e != null && typeof e == "object";
  }
  return Yt = t, Yt;
}
var Wt, an;
function Pa() {
  if (an) return Wt;
  an = 1;
  var t = dt(), e = Ia(), r = _t(), n = "[object String]";
  function i(a) {
    return typeof a == "string" || !e(a) && r(a) && t(a) == n;
  }
  return Wt = i, Wt;
}
var xa = Pa();
const Ke = /* @__PURE__ */ Pe(xa);
var Tt = (
  /** @class */
  /* @__PURE__ */ (function() {
    function t(e) {
      this.groups = [], this.each = !1, this.context = void 0, this.type = e.type, this.name = e.name, this.target = e.target, this.propertyName = e.propertyName, this.constraints = e?.constraints, this.constraintCls = e.constraintCls, this.validationTypeOptions = e.validationTypeOptions, e.validationOptions && (this.message = e.validationOptions.message, this.groups = e.validationOptions.groups, this.always = e.validationOptions.always, this.each = e.validationOptions.each, this.context = e.validationOptions.context);
    }
    return t;
  })()
), Ta = (
  /** @class */
  (function() {
    function t() {
    }
    return t.prototype.transform = function(e) {
      var r = [];
      return Object.keys(e.properties).forEach(function(n) {
        e.properties[n].forEach(function(i) {
          var a = {
            message: i.message,
            groups: i.groups,
            always: i.always,
            each: i.each
          }, o = {
            type: i.type,
            name: i.name,
            target: e.name,
            propertyName: n,
            constraints: i.constraints,
            validationTypeOptions: i.options,
            validationOptions: a
          };
          r.push(new Tt(o));
        });
      }), r;
    }, t;
  })()
);
function Da() {
  if (typeof globalThis < "u")
    return globalThis;
  if (typeof global < "u")
    return global;
  if (typeof window < "u")
    return window;
  if (typeof self < "u")
    return self;
}
var ka = function(t) {
  var e = typeof Symbol == "function" && Symbol.iterator, r = e && t[e], n = 0;
  if (r) return r.call(t);
  if (t && typeof t.length == "number") return {
    next: function() {
      return t && n >= t.length && (t = void 0), { value: t && t[n++], done: !t };
    }
  };
  throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, on = function(t, e) {
  var r = typeof Symbol == "function" && t[Symbol.iterator];
  if (!r) return t;
  var n = r.call(t), i, a = [], o;
  try {
    for (; (e === void 0 || e-- > 0) && !(i = n.next()).done; ) a.push(i.value);
  } catch (u) {
    o = { error: u };
  } finally {
    try {
      i && !i.done && (r = n.return) && r.call(n);
    } finally {
      if (o) throw o.error;
    }
  }
  return a;
}, Ma = function(t, e, r) {
  if (r || arguments.length === 2) for (var n = 0, i = e.length, a; n < i; n++)
    (a || !(n in e)) && (a || (a = Array.prototype.slice.call(e, 0, n)), a[n] = e[n]);
  return t.concat(a || Array.prototype.slice.call(e));
}, xi = (
  /** @class */
  (function() {
    function t() {
      this.validationMetadatas = /* @__PURE__ */ new Map(), this.constraintMetadatas = /* @__PURE__ */ new Map();
    }
    return Object.defineProperty(t.prototype, "hasValidationMetaData", {
      get: function() {
        return !!this.validationMetadatas.size;
      },
      enumerable: !1,
      configurable: !0
    }), t.prototype.addValidationSchema = function(e) {
      var r = this, n = new Ta().transform(e);
      n.forEach(function(i) {
        return r.addValidationMetadata(i);
      });
    }, t.prototype.addValidationMetadata = function(e) {
      var r = this.validationMetadatas.get(e.target);
      r ? r.push(e) : this.validationMetadatas.set(e.target, [e]);
    }, t.prototype.addConstraintMetadata = function(e) {
      var r = this.constraintMetadatas.get(e.target);
      r ? r.push(e) : this.constraintMetadatas.set(e.target, [e]);
    }, t.prototype.groupByPropertyName = function(e) {
      var r = {};
      return e.forEach(function(n) {
        r[n.propertyName] || (r[n.propertyName] = []), r[n.propertyName].push(n);
      }), r;
    }, t.prototype.getTargetValidationMetadatas = function(e, r, n, i, a) {
      var o, u, v = function(x) {
        return typeof x.always < "u" ? x.always : x.groups && x.groups.length ? !1 : n;
      }, E = function(x) {
        return !!(i && (!a || !a.length) && x.groups && x.groups.length);
      }, b = this.validationMetadatas.get(e) || [], P = b.filter(function(x) {
        return x.target !== e && x.target !== r ? !1 : v(x) ? !0 : E(x) ? !1 : a && a.length > 0 ? x.groups && !!x.groups.find(function(B) {
          return a.indexOf(B) !== -1;
        }) : !0;
      }), d = [];
      try {
        for (var w = ka(this.validationMetadatas.entries()), m = w.next(); !m.done; m = w.next()) {
          var _ = on(m.value, 2), S = _[0], k = _[1];
          e.prototype instanceof S && d.push.apply(d, Ma([], on(k), !1));
        }
      } catch (x) {
        o = { error: x };
      } finally {
        try {
          m && !m.done && (u = w.return) && u.call(w);
        } finally {
          if (o) throw o.error;
        }
      }
      var z = d.filter(function(x) {
        return typeof x.target == "string" || x.target === e || x.target instanceof Function && !(e.prototype instanceof x.target) ? !1 : v(x) ? !0 : E(x) ? !1 : a && a.length > 0 ? x.groups && !!x.groups.find(function(B) {
          return a.indexOf(B) !== -1;
        }) : !0;
      }), j = z.filter(function(x) {
        return !P.find(function(B) {
          return B.propertyName === x.propertyName && B.type === x.type;
        });
      });
      return P.concat(j);
    }, t.prototype.getTargetValidatorConstraints = function(e) {
      return this.constraintMetadatas.get(e) || [];
    }, t;
  })()
);
function Nt() {
  var t = Da();
  return t.classValidatorMetadataStorage || (t.classValidatorMetadataStorage = new xi()), t.classValidatorMetadataStorage;
}
var St = (
  /** @class */
  (function() {
    function t() {
    }
    return t.isValid = function(e) {
      var r = this;
      return e !== "isValid" && e !== "getMessage" && Object.keys(this).map(function(n) {
        return r[n];
      }).indexOf(e) !== -1;
    }, t.CUSTOM_VALIDATION = "customValidation", t.NESTED_VALIDATION = "nestedValidation", t.PROMISE_VALIDATION = "promiseValidation", t.CONDITIONAL_VALIDATION = "conditionalValidation", t.WHITELIST = "whitelistValidation", t.IS_DEFINED = "isDefined", t;
  })()
), La = new /** @class */
((function() {
  function t() {
    this.instances = [];
  }
  return t.prototype.get = function(e) {
    var r = this.instances.find(function(n) {
      return n.type === e;
    });
    return r || (r = { type: e, object: new e() }, this.instances.push(r)), r.object;
  }, t;
})())();
function Ti(t) {
  return La.get(t);
}
var ja = (
  /** @class */
  (function() {
    function t(e, r, n) {
      n === void 0 && (n = !1), this.target = e, this.name = r, this.async = n;
    }
    return Object.defineProperty(t.prototype, "instance", {
      // -------------------------------------------------------------------------
      // Accessors
      // -------------------------------------------------------------------------
      /**
       * Instance of the target custom validation class which performs validation.
       */
      get: function() {
        return Ti(this.target);
      },
      enumerable: !1,
      configurable: !0
    }), t;
  })()
);
function kr(t) {
  var e;
  if (t.validator instanceof Function) {
    e = t.validator;
    var r = Ti(xi).getTargetValidatorConstraints(t.validator);
    if (r.length > 1)
      throw "More than one implementation of ValidatorConstraintInterface found for validator on: ".concat(t.target.name, ":").concat(t.propertyName);
  } else {
    var n = t.validator;
    e = /** @class */
    (function() {
      function a() {
      }
      return a.prototype.validate = function(o, u) {
        return n.validate(o, u);
      }, a.prototype.defaultMessage = function(o) {
        return n.defaultMessage ? n.defaultMessage(o) : "";
      }, a;
    })(), Nt().addConstraintMetadata(new ja(e, t.name, t.async));
  }
  var i = {
    type: t.name && St.isValid(t.name) ? t.name : St.CUSTOM_VALIDATION,
    name: t.name,
    target: t.target,
    propertyName: t.propertyName,
    validationOptions: t.options,
    constraintCls: e,
    constraints: t.constraints
  };
  Nt().addValidationMetadata(new Tt(i));
}
function Fe(t, e) {
  return function(r) {
    var n = "";
    return t(n, r);
  };
}
function Ue(t, e) {
  return function(r, n) {
    kr({
      name: t.name,
      target: r.constructor,
      propertyName: n,
      options: e,
      constraints: t.constraints,
      validator: t.validator
    });
  };
}
function K(t) {
  return function(e, r) {
    var n = {
      type: St.CONDITIONAL_VALIDATION,
      target: e.constructor,
      propertyName: r,
      constraints: [
        function(i, a) {
          return i[r] !== null && i[r] !== void 0;
        }
      ],
      validationOptions: t
    };
    Nt().addValidationMetadata(new Tt(n));
  };
}
var Cr = function() {
  return Cr = Object.assign || function(t) {
    for (var e, r = 1, n = arguments.length; r < n; r++) {
      e = arguments[r];
      for (var i in e) Object.prototype.hasOwnProperty.call(e, i) && (t[i] = e[i]);
    }
    return t;
  }, Cr.apply(this, arguments);
};
function Di(t) {
  var e = Cr({}, t), r = e.each ? "each value in " : "";
  return e.message = e.message || r + "nested property $property must be either object or array", function(n, i) {
    var a = {
      type: St.NESTED_VALIDATION,
      target: n.constructor,
      propertyName: i,
      validationOptions: e
    };
    Nt().addValidationMetadata(new Tt(a));
  };
}
var wt = { exports: {} }, sn;
function Fa() {
  return sn || (sn = 1, (function(t, e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.default = r;
    function r(n) {
      if (n == null) throw new TypeError("Expected a string but received a ".concat(n));
      if (n.constructor.name !== "String") throw new TypeError("Expected a string but received a ".concat(n.constructor.name));
    }
    t.exports = e.default, t.exports.default = e.default;
  })(wt, wt.exports)), wt.exports;
}
var Ua = "isNotEmpty";
function Va(t) {
  return t !== "" && t !== null && t !== void 0;
}
function Ce(t) {
  return Ue({
    name: Ua,
    validator: {
      validate: function(e, r) {
        return Va(e);
      },
      defaultMessage: Fe(function(e) {
        return e + "$property should not be empty";
      })
    }
  }, t);
}
var Ha = "isIn";
function Ga(t, e) {
  return Array.isArray(e) && e.some(function(r) {
    return r === t;
  });
}
function ki(t, e) {
  return Ue({
    name: Ha,
    constraints: [t],
    validator: {
      validate: function(r, n) {
        return Ga(r, n?.constraints[0]);
      },
      defaultMessage: Fe(function(r) {
        return r + "$property must be one of the following values: $constraint1";
      })
    }
  }, e);
}
var rt = {}, ln;
function Ba() {
  if (ln) return rt;
  ln = 1, Object.defineProperty(rt, "__esModule", {
    value: !0
  }), rt.CountryCodes = void 0, rt.default = i;
  var t = e(/* @__PURE__ */ Fa());
  function e(a) {
    return a && a.__esModule ? a : { default: a };
  }
  var r = /* @__PURE__ */ new Set(["AD", "AE", "AF", "AG", "AI", "AL", "AM", "AO", "AQ", "AR", "AS", "AT", "AU", "AW", "AX", "AZ", "BA", "BB", "BD", "BE", "BF", "BG", "BH", "BI", "BJ", "BL", "BM", "BN", "BO", "BQ", "BR", "BS", "BT", "BV", "BW", "BY", "BZ", "CA", "CC", "CD", "CF", "CG", "CH", "CI", "CK", "CL", "CM", "CN", "CO", "CR", "CU", "CV", "CW", "CX", "CY", "CZ", "DE", "DJ", "DK", "DM", "DO", "DZ", "EC", "EE", "EG", "EH", "ER", "ES", "ET", "FI", "FJ", "FK", "FM", "FO", "FR", "GA", "GB", "GD", "GE", "GF", "GG", "GH", "GI", "GL", "GM", "GN", "GP", "GQ", "GR", "GS", "GT", "GU", "GW", "GY", "HK", "HM", "HN", "HR", "HT", "HU", "ID", "IE", "IL", "IM", "IN", "IO", "IQ", "IR", "IS", "IT", "JE", "JM", "JO", "JP", "KE", "KG", "KH", "KI", "KM", "KN", "KP", "KR", "KW", "KY", "KZ", "LA", "LB", "LC", "LI", "LK", "LR", "LS", "LT", "LU", "LV", "LY", "MA", "MC", "MD", "ME", "MF", "MG", "MH", "MK", "ML", "MM", "MN", "MO", "MP", "MQ", "MR", "MS", "MT", "MU", "MV", "MW", "MX", "MY", "MZ", "NA", "NC", "NE", "NF", "NG", "NI", "NL", "NO", "NP", "NR", "NU", "NZ", "OM", "PA", "PE", "PF", "PG", "PH", "PK", "PL", "PM", "PN", "PR", "PS", "PT", "PW", "PY", "QA", "RE", "RO", "RS", "RU", "RW", "SA", "SB", "SC", "SD", "SE", "SG", "SH", "SI", "SJ", "SK", "SL", "SM", "SN", "SO", "SR", "SS", "ST", "SV", "SX", "SY", "SZ", "TC", "TD", "TF", "TG", "TH", "TJ", "TK", "TL", "TM", "TN", "TO", "TR", "TT", "TV", "TW", "TZ", "UA", "UG", "UM", "US", "UY", "UZ", "VA", "VC", "VE", "VG", "VI", "VN", "VU", "WF", "WS", "YE", "YT", "ZA", "ZM", "ZW"]), n = /^[a-zA-Z]{2}$/;
  function i(a) {
    var o = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    (0, t.default)(a);
    var u = o.userAssignedCodes, v = (u || []).reduce(function(E, b) {
      return n.test(b) && E.push(b.toUpperCase()), E;
    }, []);
    return v.includes(a.toUpperCase()) ? !0 : r.has(a.toUpperCase());
  }
  return rt.CountryCodes = r, rt;
}
var $a = /* @__PURE__ */ Ba();
const za = /* @__PURE__ */ Pe($a);
var qa = "isISO31661Alpha2";
function Ya(t) {
  return typeof t == "string" && za(t);
}
function Mi(t) {
  return Ue({
    name: qa,
    validator: {
      validate: function(e, r) {
        return Ya(e);
      },
      defaultMessage: Fe(function(e) {
        return e + "$property must be a valid ISO31661 Alpha2 code";
      })
    }
  }, t);
}
var Wa = "isBoolean";
function Ka(t) {
  return t instanceof Boolean || typeof t == "boolean";
}
function Mr(t) {
  return Ue({
    name: Wa,
    validator: {
      validate: function(e, r) {
        return Ka(e);
      },
      defaultMessage: Fe(function(e) {
        return e + "$property must be a boolean value";
      })
    }
  }, t);
}
var Ja = "isDate";
function Qa(t) {
  return t instanceof Date && !isNaN(t.getTime());
}
function Dt(t) {
  return Ue({
    name: Ja,
    validator: {
      validate: function(e, r) {
        return Qa(e);
      },
      defaultMessage: Fe(function(e) {
        return e + "$property must be a Date instance";
      })
    }
  }, t);
}
var Xa = "isNumber";
function Za(t, e) {
  if (e === void 0 && (e = {}), typeof t != "number")
    return !1;
  if (t === 1 / 0 || t === -1 / 0)
    return !!e.allowInfinity;
  if (Number.isNaN(t))
    return !!e.allowNaN;
  if (e.maxDecimalPlaces !== void 0) {
    var r = 0;
    if (t % 1 !== 0 && (r = t.toString().split(".")[1].length), r > e.maxDecimalPlaces)
      return !1;
  }
  return Number.isFinite(t);
}
function Ze(t, e) {
  return t === void 0 && (t = {}), Ue({
    name: Xa,
    constraints: [t],
    validator: {
      validate: function(r, n) {
        return Za(r, n?.constraints[0]);
      },
      defaultMessage: Fe(function(r) {
        return r + "$property must be a number conforming to the specified constraints";
      })
    }
  }, e);
}
var eo = "isString";
function to(t) {
  return t instanceof String || typeof t == "string";
}
function X(t) {
  return Ue({
    name: eo,
    validator: {
      validate: function(e, r) {
        return to(e);
      },
      defaultMessage: Fe(function(e) {
        return e + "$property must be a string";
      })
    }
  }, t);
}
var ro = "isArray";
function no(t) {
  return Array.isArray(t);
}
function io(t) {
  return Ue({
    name: ro,
    validator: {
      validate: function(e, r) {
        return no(e);
      },
      defaultMessage: Fe(function(e) {
        return e + "$property must be an array";
      })
    }
  }, t);
}
var ao = "isObject";
function oo(t) {
  return t != null && (typeof t == "object" || typeof t == "function") && !Array.isArray(t);
}
function so(t) {
  return Ue({
    name: ao,
    validator: {
      validate: function(e, r) {
        return oo(e);
      },
      defaultMessage: Fe(function(e) {
        return e + "$property must be an object";
      })
    }
  }, t);
}
var Ie;
(function(t) {
  t[t.PLAIN_TO_CLASS = 0] = "PLAIN_TO_CLASS", t[t.CLASS_TO_PLAIN = 1] = "CLASS_TO_PLAIN", t[t.CLASS_TO_CLASS = 2] = "CLASS_TO_CLASS";
})(Ie || (Ie = {}));
var lo = (
  /** @class */
  (function() {
    function t() {
      this._typeMetadatas = /* @__PURE__ */ new Map(), this._transformMetadatas = /* @__PURE__ */ new Map(), this._exposeMetadatas = /* @__PURE__ */ new Map(), this._excludeMetadatas = /* @__PURE__ */ new Map(), this._ancestorsMap = /* @__PURE__ */ new Map();
    }
    return t.prototype.addTypeMetadata = function(e) {
      this._typeMetadatas.has(e.target) || this._typeMetadatas.set(e.target, /* @__PURE__ */ new Map()), this._typeMetadatas.get(e.target).set(e.propertyName, e);
    }, t.prototype.addTransformMetadata = function(e) {
      this._transformMetadatas.has(e.target) || this._transformMetadatas.set(e.target, /* @__PURE__ */ new Map()), this._transformMetadatas.get(e.target).has(e.propertyName) || this._transformMetadatas.get(e.target).set(e.propertyName, []), this._transformMetadatas.get(e.target).get(e.propertyName).push(e);
    }, t.prototype.addExposeMetadata = function(e) {
      this._exposeMetadatas.has(e.target) || this._exposeMetadatas.set(e.target, /* @__PURE__ */ new Map()), this._exposeMetadatas.get(e.target).set(e.propertyName, e);
    }, t.prototype.addExcludeMetadata = function(e) {
      this._excludeMetadatas.has(e.target) || this._excludeMetadatas.set(e.target, /* @__PURE__ */ new Map()), this._excludeMetadatas.get(e.target).set(e.propertyName, e);
    }, t.prototype.findTransformMetadatas = function(e, r, n) {
      return this.findMetadatas(this._transformMetadatas, e, r).filter(function(i) {
        return !i.options || i.options.toClassOnly === !0 && i.options.toPlainOnly === !0 ? !0 : i.options.toClassOnly === !0 ? n === Ie.CLASS_TO_CLASS || n === Ie.PLAIN_TO_CLASS : i.options.toPlainOnly === !0 ? n === Ie.CLASS_TO_PLAIN : !0;
      });
    }, t.prototype.findExcludeMetadata = function(e, r) {
      return this.findMetadata(this._excludeMetadatas, e, r);
    }, t.prototype.findExposeMetadata = function(e, r) {
      return this.findMetadata(this._exposeMetadatas, e, r);
    }, t.prototype.findExposeMetadataByCustomName = function(e, r) {
      return this.getExposedMetadatas(e).find(function(n) {
        return n.options && n.options.name === r;
      });
    }, t.prototype.findTypeMetadata = function(e, r) {
      return this.findMetadata(this._typeMetadatas, e, r);
    }, t.prototype.getStrategy = function(e) {
      var r = this._excludeMetadatas.get(e), n = r && r.get(void 0), i = this._exposeMetadatas.get(e), a = i && i.get(void 0);
      return n && a || !n && !a ? "none" : n ? "excludeAll" : "exposeAll";
    }, t.prototype.getExposedMetadatas = function(e) {
      return this.getMetadata(this._exposeMetadatas, e);
    }, t.prototype.getExcludedMetadatas = function(e) {
      return this.getMetadata(this._excludeMetadatas, e);
    }, t.prototype.getExposedProperties = function(e, r) {
      return this.getExposedMetadatas(e).filter(function(n) {
        return !n.options || n.options.toClassOnly === !0 && n.options.toPlainOnly === !0 ? !0 : n.options.toClassOnly === !0 ? r === Ie.CLASS_TO_CLASS || r === Ie.PLAIN_TO_CLASS : n.options.toPlainOnly === !0 ? r === Ie.CLASS_TO_PLAIN : !0;
      }).map(function(n) {
        return n.propertyName;
      });
    }, t.prototype.getExcludedProperties = function(e, r) {
      return this.getExcludedMetadatas(e).filter(function(n) {
        return !n.options || n.options.toClassOnly === !0 && n.options.toPlainOnly === !0 ? !0 : n.options.toClassOnly === !0 ? r === Ie.CLASS_TO_CLASS || r === Ie.PLAIN_TO_CLASS : n.options.toPlainOnly === !0 ? r === Ie.CLASS_TO_PLAIN : !0;
      }).map(function(n) {
        return n.propertyName;
      });
    }, t.prototype.clear = function() {
      this._typeMetadatas.clear(), this._exposeMetadatas.clear(), this._excludeMetadatas.clear(), this._ancestorsMap.clear();
    }, t.prototype.getMetadata = function(e, r) {
      var n = e.get(r), i;
      n && (i = Array.from(n.values()).filter(function(P) {
        return P.propertyName !== void 0;
      }));
      for (var a = [], o = 0, u = this.getAncestors(r); o < u.length; o++) {
        var v = u[o], E = e.get(v);
        if (E) {
          var b = Array.from(E.values()).filter(function(P) {
            return P.propertyName !== void 0;
          });
          a.push.apply(a, b);
        }
      }
      return a.concat(i || []);
    }, t.prototype.findMetadata = function(e, r, n) {
      var i = e.get(r);
      if (i) {
        var a = i.get(n);
        if (a)
          return a;
      }
      for (var o = 0, u = this.getAncestors(r); o < u.length; o++) {
        var v = u[o], E = e.get(v);
        if (E) {
          var b = E.get(n);
          if (b)
            return b;
        }
      }
    }, t.prototype.findMetadatas = function(e, r, n) {
      var i = e.get(r), a;
      i && (a = i.get(n));
      for (var o = [], u = 0, v = this.getAncestors(r); u < v.length; u++) {
        var E = v[u], b = e.get(E);
        b && b.has(n) && o.push.apply(o, b.get(n));
      }
      return o.slice().reverse().concat((a || []).slice().reverse());
    }, t.prototype.getAncestors = function(e) {
      if (!e)
        return [];
      if (!this._ancestorsMap.has(e)) {
        for (var r = [], n = Object.getPrototypeOf(e.prototype.constructor); typeof n.prototype < "u"; n = Object.getPrototypeOf(n.prototype.constructor))
          r.push(n);
        this._ancestorsMap.set(e, r);
      }
      return this._ancestorsMap.get(e);
    }, t;
  })()
), Li = new lo();
function Ee(t, e) {
  return e === void 0 && (e = {}), function(r, n) {
    Li.addTransformMetadata({
      target: r.constructor,
      propertyName: n,
      transformFn: t,
      options: e
    });
  };
}
function xe(t, e) {
  return e === void 0 && (e = {}), function(r, n) {
    var i = Reflect.getMetadata("design:type", r, n);
    Li.addTypeMetadata({
      target: r.constructor,
      propertyName: n,
      reflectedType: i,
      typeFunction: t,
      options: e
    });
  };
}
var un = {};
var cn;
function uo() {
  if (cn) return un;
  cn = 1;
  var t;
  return (function(e) {
    (function(r) {
      var n = typeof ot == "object" ? ot : typeof self == "object" ? self : typeof this == "object" ? this : Function("return this;")(), i = a(e);
      typeof n.Reflect > "u" ? n.Reflect = e : i = a(n.Reflect, i), r(i);
      function a(o, u) {
        return function(v, E) {
          typeof o[v] != "function" && Object.defineProperty(o, v, { configurable: !0, writable: !0, value: E }), u && u(v, E);
        };
      }
    })(function(r) {
      var n = Object.prototype.hasOwnProperty, i = typeof Symbol == "function", a = i && typeof Symbol.toPrimitive < "u" ? Symbol.toPrimitive : "@@toPrimitive", o = i && typeof Symbol.iterator < "u" ? Symbol.iterator : "@@iterator", u = typeof Object.create == "function", v = { __proto__: [] } instanceof Array, E = !u && !v, b = {
        // create an object in dictionary mode (a.k.a. "slow" mode in v8)
        create: u ? function() {
          return h(/* @__PURE__ */ Object.create(null));
        } : v ? function() {
          return h({ __proto__: null });
        } : function() {
          return h({});
        },
        has: E ? function(s, c) {
          return n.call(s, c);
        } : function(s, c) {
          return c in s;
        },
        get: E ? function(s, c) {
          return n.call(s, c) ? s[c] : void 0;
        } : function(s, c) {
          return s[c];
        }
      }, P = Object.getPrototypeOf(Function), d = typeof process == "object" && process.env && process.env.REFLECT_METADATA_USE_MAP_POLYFILL === "true", w = !d && typeof Map == "function" && typeof Map.prototype.entries == "function" ? Map : D(), m = !d && typeof Set == "function" && typeof Set.prototype.entries == "function" ? Set : L(), _ = !d && typeof WeakMap == "function" ? WeakMap : l(), S = new _();
      function k(s, c, g, y) {
        if (W(g)) {
          if (!Le(s))
            throw new TypeError();
          if (!ye(c))
            throw new TypeError();
          return Ve(s, c);
        } else {
          if (!Le(s))
            throw new TypeError();
          if (!Q(c))
            throw new TypeError();
          if (!Q(y) && !W(y) && !fe(y))
            throw new TypeError();
          return fe(y) && (y = void 0), g = J(g), Te(s, c, g, y);
        }
      }
      r("decorate", k);
      function z(s, c) {
        function g(y, A) {
          if (!Q(y))
            throw new TypeError();
          if (!W(A) && !Ge(A))
            throw new TypeError();
          ke(s, c, y, A);
        }
        return g;
      }
      r("metadata", z);
      function j(s, c, g, y) {
        if (!Q(g))
          throw new TypeError();
        return W(y) || (y = J(y)), ke(s, c, g, y);
      }
      r("defineMetadata", j);
      function x(s, c, g) {
        if (!Q(c))
          throw new TypeError();
        return W(g) || (g = J(g)), pe(s, c, g);
      }
      r("hasMetadata", x);
      function B(s, c, g) {
        if (!Q(c))
          throw new TypeError();
        return W(g) || (g = J(g)), De(s, c, g);
      }
      r("hasOwnMetadata", B);
      function Y(s, c, g) {
        if (!Q(c))
          throw new TypeError();
        return W(g) || (g = J(g)), he(s, c, g);
      }
      r("getMetadata", Y);
      function be(s, c, g) {
        if (!Q(c))
          throw new TypeError();
        return W(g) || (g = J(g)), ne(s, c, g);
      }
      r("getOwnMetadata", be);
      function we(s, c) {
        if (!Q(s))
          throw new TypeError();
        return W(c) || (c = J(c)), He(s, c);
      }
      r("getMetadataKeys", we);
      function oe(s, c) {
        if (!Q(s))
          throw new TypeError();
        return W(c) || (c = J(c)), Oe(s, c);
      }
      r("getOwnMetadataKeys", oe);
      function ge(s, c, g) {
        if (!Q(c))
          throw new TypeError();
        W(g) || (g = J(g));
        var y = re(
          c,
          g,
          /*Create*/
          !1
        );
        if (W(y) || !y.delete(s))
          return !1;
        if (y.size > 0)
          return !0;
        var A = S.get(c);
        return A.delete(g), A.size > 0 || S.delete(c), !0;
      }
      r("deleteMetadata", ge);
      function Ve(s, c) {
        for (var g = s.length - 1; g >= 0; --g) {
          var y = s[g], A = y(c);
          if (!W(A) && !fe(A)) {
            if (!ye(A))
              throw new TypeError();
            c = A;
          }
        }
        return c;
      }
      function Te(s, c, g, y) {
        for (var A = s.length - 1; A >= 0; --A) {
          var F = s[A], I = F(c, g, y);
          if (!W(I) && !fe(I)) {
            if (!Q(I))
              throw new TypeError();
            y = I;
          }
        }
        return y;
      }
      function re(s, c, g) {
        var y = S.get(s);
        if (W(y)) {
          if (!g)
            return;
          y = new w(), S.set(s, y);
        }
        var A = y.get(c);
        if (W(A)) {
          if (!g)
            return;
          A = new w(), y.set(c, A);
        }
        return A;
      }
      function pe(s, c, g) {
        var y = De(s, c, g);
        if (y)
          return !0;
        var A = C(c);
        return fe(A) ? !1 : pe(s, A, g);
      }
      function De(s, c, g) {
        var y = re(
          c,
          g,
          /*Create*/
          !1
        );
        return W(y) ? !1 : me(y.has(s));
      }
      function he(s, c, g) {
        var y = De(s, c, g);
        if (y)
          return ne(s, c, g);
        var A = C(c);
        if (!fe(A))
          return he(s, A, g);
      }
      function ne(s, c, g) {
        var y = re(
          c,
          g,
          /*Create*/
          !1
        );
        if (!W(y))
          return y.get(s);
      }
      function ke(s, c, g, y) {
        var A = re(
          g,
          y,
          /*Create*/
          !0
        );
        A.set(s, c);
      }
      function He(s, c) {
        var g = Oe(s, c), y = C(s);
        if (y === null)
          return g;
        var A = He(y, c);
        if (A.length <= 0)
          return g;
        if (g.length <= 0)
          return A;
        for (var F = new m(), I = [], T = 0, O = g; T < O.length; T++) {
          var M = O[T], H = F.has(M);
          H || (F.add(M), I.push(M));
        }
        for (var $ = 0, q = A; $ < q.length; $++) {
          var M = q[$], H = F.has(M);
          H || (F.add(M), I.push(M));
        }
        return I;
      }
      function Oe(s, c) {
        var g = [], y = re(
          s,
          c,
          /*Create*/
          !1
        );
        if (W(y))
          return g;
        for (var A = y.keys(), F = N(A), I = 0; ; ) {
          var T = p(F);
          if (!T)
            return g.length = I, g;
          var O = f(T);
          try {
            g[I] = O;
          } catch (M) {
            try {
              R(F);
            } finally {
              throw M;
            }
          }
          I++;
        }
      }
      function Ne(s) {
        if (s === null)
          return 1;
        switch (typeof s) {
          case "undefined":
            return 0;
          case "boolean":
            return 2;
          case "string":
            return 3;
          case "symbol":
            return 4;
          case "number":
            return 5;
          case "object":
            return s === null ? 1 : 6;
          default:
            return 6;
        }
      }
      function W(s) {
        return s === void 0;
      }
      function fe(s) {
        return s === null;
      }
      function Se(s) {
        return typeof s == "symbol";
      }
      function Q(s) {
        return typeof s == "object" ? s !== null : typeof s == "function";
      }
      function Ae(s, c) {
        switch (Ne(s)) {
          case 0:
            return s;
          case 1:
            return s;
          case 2:
            return s;
          case 3:
            return s;
          case 4:
            return s;
          case 5:
            return s;
        }
        var g = "string", y = Be(s, a);
        if (y !== void 0) {
          var A = y.call(s, g);
          if (Q(A))
            throw new TypeError();
          return A;
        }
        return Me(s);
      }
      function Me(s, c) {
        var g, y;
        {
          var A = s.toString;
          if (ee(A)) {
            var y = A.call(s);
            if (!Q(y))
              return y;
          }
          var g = s.valueOf;
          if (ee(g)) {
            var y = g.call(s);
            if (!Q(y))
              return y;
          }
        }
        throw new TypeError();
      }
      function me(s) {
        return !!s;
      }
      function Z(s) {
        return "" + s;
      }
      function J(s) {
        var c = Ae(s);
        return Se(c) ? c : Z(c);
      }
      function Le(s) {
        return Array.isArray ? Array.isArray(s) : s instanceof Object ? s instanceof Array : Object.prototype.toString.call(s) === "[object Array]";
      }
      function ee(s) {
        return typeof s == "function";
      }
      function ye(s) {
        return typeof s == "function";
      }
      function Ge(s) {
        switch (Ne(s)) {
          case 3:
            return !0;
          case 4:
            return !0;
          default:
            return !1;
        }
      }
      function Be(s, c) {
        var g = s[c];
        if (g != null) {
          if (!ee(g))
            throw new TypeError();
          return g;
        }
      }
      function N(s) {
        var c = Be(s, o);
        if (!ee(c))
          throw new TypeError();
        var g = c.call(s);
        if (!Q(g))
          throw new TypeError();
        return g;
      }
      function f(s) {
        return s.value;
      }
      function p(s) {
        var c = s.next();
        return c.done ? !1 : c;
      }
      function R(s) {
        var c = s.return;
        c && c.call(s);
      }
      function C(s) {
        var c = Object.getPrototypeOf(s);
        if (typeof s != "function" || s === P || c !== P)
          return c;
        var g = s.prototype, y = g && Object.getPrototypeOf(g);
        if (y == null || y === Object.prototype)
          return c;
        var A = y.constructor;
        return typeof A != "function" || A === s ? c : A;
      }
      function D() {
        var s = {}, c = [], g = (
          /** @class */
          (function() {
            function I(T, O, M) {
              this._index = 0, this._keys = T, this._values = O, this._selector = M;
            }
            return I.prototype["@@iterator"] = function() {
              return this;
            }, I.prototype[o] = function() {
              return this;
            }, I.prototype.next = function() {
              var T = this._index;
              if (T >= 0 && T < this._keys.length) {
                var O = this._selector(this._keys[T], this._values[T]);
                return T + 1 >= this._keys.length ? (this._index = -1, this._keys = c, this._values = c) : this._index++, { value: O, done: !1 };
              }
              return { value: void 0, done: !0 };
            }, I.prototype.throw = function(T) {
              throw this._index >= 0 && (this._index = -1, this._keys = c, this._values = c), T;
            }, I.prototype.return = function(T) {
              return this._index >= 0 && (this._index = -1, this._keys = c, this._values = c), { value: T, done: !0 };
            }, I;
          })()
        );
        return (
          /** @class */
          (function() {
            function I() {
              this._keys = [], this._values = [], this._cacheKey = s, this._cacheIndex = -2;
            }
            return Object.defineProperty(I.prototype, "size", {
              get: function() {
                return this._keys.length;
              },
              enumerable: !0,
              configurable: !0
            }), I.prototype.has = function(T) {
              return this._find(
                T,
                /*insert*/
                !1
              ) >= 0;
            }, I.prototype.get = function(T) {
              var O = this._find(
                T,
                /*insert*/
                !1
              );
              return O >= 0 ? this._values[O] : void 0;
            }, I.prototype.set = function(T, O) {
              var M = this._find(
                T,
                /*insert*/
                !0
              );
              return this._values[M] = O, this;
            }, I.prototype.delete = function(T) {
              var O = this._find(
                T,
                /*insert*/
                !1
              );
              if (O >= 0) {
                for (var M = this._keys.length, H = O + 1; H < M; H++)
                  this._keys[H - 1] = this._keys[H], this._values[H - 1] = this._values[H];
                return this._keys.length--, this._values.length--, T === this._cacheKey && (this._cacheKey = s, this._cacheIndex = -2), !0;
              }
              return !1;
            }, I.prototype.clear = function() {
              this._keys.length = 0, this._values.length = 0, this._cacheKey = s, this._cacheIndex = -2;
            }, I.prototype.keys = function() {
              return new g(this._keys, this._values, y);
            }, I.prototype.values = function() {
              return new g(this._keys, this._values, A);
            }, I.prototype.entries = function() {
              return new g(this._keys, this._values, F);
            }, I.prototype["@@iterator"] = function() {
              return this.entries();
            }, I.prototype[o] = function() {
              return this.entries();
            }, I.prototype._find = function(T, O) {
              return this._cacheKey !== T && (this._cacheIndex = this._keys.indexOf(this._cacheKey = T)), this._cacheIndex < 0 && O && (this._cacheIndex = this._keys.length, this._keys.push(T), this._values.push(void 0)), this._cacheIndex;
            }, I;
          })()
        );
        function y(I, T) {
          return I;
        }
        function A(I, T) {
          return T;
        }
        function F(I, T) {
          return [I, T];
        }
      }
      function L() {
        return (
          /** @class */
          (function() {
            function s() {
              this._map = new w();
            }
            return Object.defineProperty(s.prototype, "size", {
              get: function() {
                return this._map.size;
              },
              enumerable: !0,
              configurable: !0
            }), s.prototype.has = function(c) {
              return this._map.has(c);
            }, s.prototype.add = function(c) {
              return this._map.set(c, c), this;
            }, s.prototype.delete = function(c) {
              return this._map.delete(c);
            }, s.prototype.clear = function() {
              this._map.clear();
            }, s.prototype.keys = function() {
              return this._map.keys();
            }, s.prototype.values = function() {
              return this._map.values();
            }, s.prototype.entries = function() {
              return this._map.entries();
            }, s.prototype["@@iterator"] = function() {
              return this.keys();
            }, s.prototype[o] = function() {
              return this.keys();
            }, s;
          })()
        );
      }
      function l() {
        var s = 16, c = b.create(), g = y();
        return (
          /** @class */
          (function() {
            function O() {
              this._key = y();
            }
            return O.prototype.has = function(M) {
              var H = A(
                M,
                /*create*/
                !1
              );
              return H !== void 0 ? b.has(H, this._key) : !1;
            }, O.prototype.get = function(M) {
              var H = A(
                M,
                /*create*/
                !1
              );
              return H !== void 0 ? b.get(H, this._key) : void 0;
            }, O.prototype.set = function(M, H) {
              var $ = A(
                M,
                /*create*/
                !0
              );
              return $[this._key] = H, this;
            }, O.prototype.delete = function(M) {
              var H = A(
                M,
                /*create*/
                !1
              );
              return H !== void 0 ? delete H[this._key] : !1;
            }, O.prototype.clear = function() {
              this._key = y();
            }, O;
          })()
        );
        function y() {
          var O;
          do
            O = "@@WeakMap@@" + T();
          while (b.has(c, O));
          return c[O] = !0, O;
        }
        function A(O, M) {
          if (!n.call(O, g)) {
            if (!M)
              return;
            Object.defineProperty(O, g, { value: b.create() });
          }
          return O[g];
        }
        function F(O, M) {
          for (var H = 0; H < M; ++H)
            O[H] = Math.random() * 255 | 0;
          return O;
        }
        function I(O) {
          return typeof Uint8Array == "function" ? typeof crypto < "u" ? crypto.getRandomValues(new Uint8Array(O)) : typeof msCrypto < "u" ? msCrypto.getRandomValues(new Uint8Array(O)) : F(new Uint8Array(O), O) : F(new Array(O), O);
        }
        function T() {
          var O = I(s);
          O[6] = O[6] & 79 | 64, O[8] = O[8] & 191 | 128;
          for (var M = "", H = 0; H < s; ++H) {
            var $ = O[H];
            (H === 4 || H === 6 || H === 8) && (M += "-"), $ < 16 && (M += "0"), M += $.toString(16).toLowerCase();
          }
          return M;
        }
      }
      function h(s) {
        return s.__ = void 0, delete s.__, s;
      }
    });
  })(t || (t = {})), un;
}
uo();
var Kt, dn;
function co() {
  if (dn) return Kt;
  dn = 1;
  var t = dt(), e = _t(), r = "[object Number]";
  function n(i) {
    return typeof i == "number" || e(i) && t(i) == r;
  }
  return Kt = n, Kt;
}
var ho = co();
const ji = /* @__PURE__ */ Pe(ho);
var Jt, hn;
function fo() {
  if (hn) return Jt;
  hn = 1;
  var t = dt(), e = _t(), r = "[object Boolean]";
  function n(i) {
    return i === !0 || i === !1 || e(i) && t(i) == r;
  }
  return Jt = n, Jt;
}
var vo = fo();
const go = /* @__PURE__ */ Pe(vo);
var Qt, fn;
function po() {
  if (fn) return Qt;
  fn = 1;
  function t(e, r) {
    return function(n) {
      return e(r(n));
    };
  }
  return Qt = t, Qt;
}
var Xt, vn;
function mo() {
  if (vn) return Xt;
  vn = 1;
  var t = po(), e = t(Object.getPrototypeOf, Object);
  return Xt = e, Xt;
}
var Zt, gn;
function yo() {
  if (gn) return Zt;
  gn = 1;
  var t = dt(), e = mo(), r = _t(), n = "[object Object]", i = Function.prototype, a = Object.prototype, o = i.toString, u = a.hasOwnProperty, v = o.call(Object);
  function E(b) {
    if (!r(b) || t(b) != n)
      return !1;
    var P = e(b);
    if (P === null)
      return !0;
    var d = u.call(P, "constructor") && P.constructor;
    return typeof d == "function" && d instanceof d && o.call(d) == v;
  }
  return Zt = E, Zt;
}
var _o = yo();
const Eo = /* @__PURE__ */ Pe(_o);
var er, pn;
function bo() {
  if (pn) return er;
  pn = 1;
  function t(e) {
    return e === null;
  }
  return er = t, er;
}
var wo = bo();
const Oo = /* @__PURE__ */ Pe(wo);
var tr, mn;
function Ro() {
  if (mn) return tr;
  mn = 1;
  function t(e) {
    return e === void 0;
  }
  return tr = t, tr;
}
var Co = Ro();
const No = /* @__PURE__ */ Pe(Co), Ye = {
  aa: {
    name: "Afar",
    nativeName: "Afaraf"
  },
  ab: {
    name: "Abkhaz",
    nativeName: "аҧсуа бызшәа"
  },
  ae: {
    name: "Avestan",
    nativeName: "avesta"
  },
  af: {
    name: "Afrikaans",
    nativeName: "Afrikaans"
  },
  ak: {
    name: "Akan",
    nativeName: "Akan"
  },
  am: {
    name: "Amharic",
    nativeName: "አማርኛ"
  },
  an: {
    name: "Aragonese",
    nativeName: "aragonés"
  },
  ar: {
    name: "Arabic",
    nativeName: "اَلْعَرَبِيَّةُ"
  },
  as: {
    name: "Assamese",
    nativeName: "অসমীয়া"
  },
  av: {
    name: "Avaric",
    nativeName: "авар мацӀ"
  },
  ay: {
    name: "Aymara",
    nativeName: "aymar aru"
  },
  az: {
    name: "Azerbaijani",
    nativeName: "azərbaycan dili"
  },
  ba: {
    name: "Bashkir",
    nativeName: "башҡорт теле"
  },
  be: {
    name: "Belarusian",
    nativeName: "беларуская мова"
  },
  bg: {
    name: "Bulgarian",
    nativeName: "български език"
  },
  bi: {
    name: "Bislama",
    nativeName: "Bislama"
  },
  bm: {
    name: "Bambara",
    nativeName: "bamanankan"
  },
  bn: {
    name: "Bengali",
    nativeName: "বাংলা"
  },
  bo: {
    name: "Tibetan",
    nativeName: "བོད་ཡིག"
  },
  br: {
    name: "Breton",
    nativeName: "brezhoneg"
  },
  bs: {
    name: "Bosnian",
    nativeName: "bosanski jezik"
  },
  ca: {
    name: "Catalan",
    nativeName: "Català"
  },
  ce: {
    name: "Chechen",
    nativeName: "нохчийн мотт"
  },
  ch: {
    name: "Chamorro",
    nativeName: "Chamoru"
  },
  co: {
    name: "Corsican",
    nativeName: "corsu"
  },
  cr: {
    name: "Cree",
    nativeName: "ᓀᐦᐃᔭᐍᐏᐣ"
  },
  cs: {
    name: "Czech",
    nativeName: "čeština"
  },
  cu: {
    name: "Old Church Slavonic",
    nativeName: "ѩзыкъ словѣньскъ"
  },
  cv: {
    name: "Chuvash",
    nativeName: "чӑваш чӗлхи"
  },
  cy: {
    name: "Welsh",
    nativeName: "Cymraeg"
  },
  da: {
    name: "Danish",
    nativeName: "dansk"
  },
  de: {
    name: "German",
    nativeName: "Deutsch"
  },
  dv: {
    name: "Divehi",
    nativeName: "ދިވެހި"
  },
  dz: {
    name: "Dzongkha",
    nativeName: "རྫོང་ཁ"
  },
  ee: {
    name: "Ewe",
    nativeName: "Eʋegbe"
  },
  el: {
    name: "Greek",
    nativeName: "Ελληνικά"
  },
  en: {
    name: "English",
    nativeName: "English"
  },
  eo: {
    name: "Esperanto",
    nativeName: "Esperanto"
  },
  es: {
    name: "Spanish",
    nativeName: "Español"
  },
  et: {
    name: "Estonian",
    nativeName: "eesti"
  },
  eu: {
    name: "Basque",
    nativeName: "euskara"
  },
  fa: {
    name: "Persian",
    nativeName: "فارسی"
  },
  ff: {
    name: "Fula",
    nativeName: "Fulfulde"
  },
  fi: {
    name: "Finnish",
    nativeName: "suomi"
  },
  fj: {
    name: "Fijian",
    nativeName: "vosa Vakaviti"
  },
  fo: {
    name: "Faroese",
    nativeName: "føroyskt"
  },
  fr: {
    name: "French",
    nativeName: "Français"
  },
  fy: {
    name: "Western Frisian",
    nativeName: "Frysk"
  },
  ga: {
    name: "Irish",
    nativeName: "Gaeilge"
  },
  gd: {
    name: "Scottish Gaelic",
    nativeName: "Gàidhlig"
  },
  gl: {
    name: "Galician",
    nativeName: "galego"
  },
  gn: {
    name: "Guaraní",
    nativeName: "Avañe'ẽ"
  },
  gu: {
    name: "Gujarati",
    nativeName: "ગુજરાતી"
  },
  gv: {
    name: "Manx",
    nativeName: "Gaelg"
  },
  ha: {
    name: "Hausa",
    nativeName: "هَوُسَ"
  },
  he: {
    name: "Hebrew",
    nativeName: "עברית"
  },
  hi: {
    name: "Hindi",
    nativeName: "हिन्दी"
  },
  ho: {
    name: "Hiri Motu",
    nativeName: "Hiri Motu"
  },
  hr: {
    name: "Croatian",
    nativeName: "Hrvatski"
  },
  ht: {
    name: "Haitian",
    nativeName: "Kreyòl ayisyen"
  },
  hu: {
    name: "Hungarian",
    nativeName: "magyar"
  },
  hy: {
    name: "Armenian",
    nativeName: "Հայերեն"
  },
  hz: {
    name: "Herero",
    nativeName: "Otjiherero"
  },
  ia: {
    name: "Interlingua",
    nativeName: "Interlingua"
  },
  id: {
    name: "Indonesian",
    nativeName: "Bahasa Indonesia"
  },
  ie: {
    name: "Interlingue",
    nativeName: "Interlingue"
  },
  ig: {
    name: "Igbo",
    nativeName: "Asụsụ Igbo"
  },
  ii: {
    name: "Nuosu",
    nativeName: "ꆈꌠ꒿ Nuosuhxop"
  },
  ik: {
    name: "Inupiaq",
    nativeName: "Iñupiaq"
  },
  io: {
    name: "Ido",
    nativeName: "Ido"
  },
  is: {
    name: "Icelandic",
    nativeName: "Íslenska"
  },
  it: {
    name: "Italian",
    nativeName: "Italiano"
  },
  iu: {
    name: "Inuktitut",
    nativeName: "ᐃᓄᒃᑎᑐᑦ"
  },
  ja: {
    name: "Japanese",
    nativeName: "日本語"
  },
  jv: {
    name: "Javanese",
    nativeName: "basa Jawa"
  },
  ka: {
    name: "Georgian",
    nativeName: "ქართული"
  },
  kg: {
    name: "Kongo",
    nativeName: "Kikongo"
  },
  ki: {
    name: "Kikuyu",
    nativeName: "Gĩkũyũ"
  },
  kj: {
    name: "Kwanyama",
    nativeName: "Kuanyama"
  },
  kk: {
    name: "Kazakh",
    nativeName: "қазақ тілі"
  },
  kl: {
    name: "Kalaallisut",
    nativeName: "kalaallisut"
  },
  km: {
    name: "Khmer",
    nativeName: "ខេមរភាសា"
  },
  kn: {
    name: "Kannada",
    nativeName: "ಕನ್ನಡ"
  },
  ko: {
    name: "Korean",
    nativeName: "한국어"
  },
  kr: {
    name: "Kanuri",
    nativeName: "Kanuri"
  },
  ks: {
    name: "Kashmiri",
    nativeName: "कश्मीरी"
  },
  ku: {
    name: "Kurdish",
    nativeName: "Kurdî"
  },
  kv: {
    name: "Komi",
    nativeName: "коми кыв"
  },
  kw: {
    name: "Cornish",
    nativeName: "Kernewek"
  },
  ky: {
    name: "Kyrgyz",
    nativeName: "Кыргызча"
  },
  la: {
    name: "Latin",
    nativeName: "latine"
  },
  lb: {
    name: "Luxembourgish",
    nativeName: "Lëtzebuergesch"
  },
  lg: {
    name: "Ganda",
    nativeName: "Luganda"
  },
  li: {
    name: "Limburgish",
    nativeName: "Limburgs"
  },
  ln: {
    name: "Lingala",
    nativeName: "Lingála"
  },
  lo: {
    name: "Lao",
    nativeName: "ພາສາລາວ"
  },
  lt: {
    name: "Lithuanian",
    nativeName: "lietuvių kalba"
  },
  lu: {
    name: "Luba-Katanga",
    nativeName: "Kiluba"
  },
  lv: {
    name: "Latvian",
    nativeName: "latviešu valoda"
  },
  mg: {
    name: "Malagasy",
    nativeName: "fiteny malagasy"
  },
  mh: {
    name: "Marshallese",
    nativeName: "Kajin M̧ajeļ"
  },
  mi: {
    name: "Māori",
    nativeName: "te reo Māori"
  },
  mk: {
    name: "Macedonian",
    nativeName: "македонски јазик"
  },
  ml: {
    name: "Malayalam",
    nativeName: "മലയാളം"
  },
  mn: {
    name: "Mongolian",
    nativeName: "Монгол хэл"
  },
  mr: {
    name: "Marathi",
    nativeName: "मराठी"
  },
  ms: {
    name: "Malay",
    nativeName: "Bahasa Melayu"
  },
  mt: {
    name: "Maltese",
    nativeName: "Malti"
  },
  my: {
    name: "Burmese",
    nativeName: "ဗမာစာ"
  },
  na: {
    name: "Nauru",
    nativeName: "Dorerin Naoero"
  },
  nb: {
    name: "Norwegian Bokmål",
    nativeName: "Norsk bokmål"
  },
  nd: {
    name: "Northern Ndebele",
    nativeName: "isiNdebele"
  },
  ne: {
    name: "Nepali",
    nativeName: "नेपाली"
  },
  ng: {
    name: "Ndonga",
    nativeName: "Owambo"
  },
  nl: {
    name: "Dutch",
    nativeName: "Nederlands"
  },
  nn: {
    name: "Norwegian Nynorsk",
    nativeName: "Norsk nynorsk"
  },
  no: {
    name: "Norwegian",
    nativeName: "Norsk"
  },
  nr: {
    name: "Southern Ndebele",
    nativeName: "isiNdebele"
  },
  nv: {
    name: "Navajo",
    nativeName: "Diné bizaad"
  },
  ny: {
    name: "Chichewa",
    nativeName: "chiCheŵa"
  },
  oc: {
    name: "Occitan",
    nativeName: "occitan"
  },
  oj: {
    name: "Ojibwe",
    nativeName: "ᐊᓂᔑᓈᐯᒧᐎᓐ"
  },
  om: {
    name: "Oromo",
    nativeName: "Afaan Oromoo"
  },
  or: {
    name: "Oriya",
    nativeName: "ଓଡ଼ିଆ"
  },
  os: {
    name: "Ossetian",
    nativeName: "ирон æвзаг"
  },
  pa: {
    name: "Panjabi",
    nativeName: "ਪੰਜਾਬੀ"
  },
  pi: {
    name: "Pāli",
    nativeName: "पाऴि"
  },
  pl: {
    name: "Polish",
    nativeName: "Polski"
  },
  ps: {
    name: "Pashto",
    nativeName: "پښتو"
  },
  pt: {
    name: "Portuguese",
    nativeName: "Português"
  },
  qu: {
    name: "Quechua",
    nativeName: "Runa Simi"
  },
  rm: {
    name: "Romansh",
    nativeName: "rumantsch grischun"
  },
  rn: {
    name: "Kirundi",
    nativeName: "Ikirundi"
  },
  ro: {
    name: "Romanian",
    nativeName: "Română"
  },
  ru: {
    name: "Russian",
    nativeName: "Русский"
  },
  rw: {
    name: "Kinyarwanda",
    nativeName: "Ikinyarwanda"
  },
  sa: {
    name: "Sanskrit",
    nativeName: "संस्कृतम्"
  },
  sc: {
    name: "Sardinian",
    nativeName: "sardu"
  },
  sd: {
    name: "Sindhi",
    nativeName: "सिन्धी"
  },
  se: {
    name: "Northern Sami",
    nativeName: "Davvisámegiella"
  },
  sg: {
    name: "Sango",
    nativeName: "yângâ tî sängö"
  },
  si: {
    name: "Sinhala",
    nativeName: "සිංහල"
  },
  sk: {
    name: "Slovak",
    nativeName: "slovenčina"
  },
  sl: {
    name: "Slovenian",
    nativeName: "slovenščina"
  },
  sm: {
    name: "Samoan",
    nativeName: "gagana fa'a Samoa"
  },
  sn: {
    name: "Shona",
    nativeName: "chiShona"
  },
  so: {
    name: "Somali",
    nativeName: "Soomaaliga"
  },
  sq: {
    name: "Albanian",
    nativeName: "Shqip"
  },
  sr: {
    name: "Serbian",
    nativeName: "српски језик"
  },
  ss: {
    name: "Swati",
    nativeName: "SiSwati"
  },
  st: {
    name: "Southern Sotho",
    nativeName: "Sesotho"
  },
  su: {
    name: "Sundanese",
    nativeName: "Basa Sunda"
  },
  sv: {
    name: "Swedish",
    nativeName: "Svenska"
  },
  sw: {
    name: "Swahili",
    nativeName: "Kiswahili"
  },
  ta: {
    name: "Tamil",
    nativeName: "தமிழ்"
  },
  te: {
    name: "Telugu",
    nativeName: "తెలుగు"
  },
  tg: {
    name: "Tajik",
    nativeName: "тоҷикӣ"
  },
  th: {
    name: "Thai",
    nativeName: "ไทย"
  },
  ti: {
    name: "Tigrinya",
    nativeName: "ትግርኛ"
  },
  tk: {
    name: "Turkmen",
    nativeName: "Türkmençe"
  },
  tl: {
    name: "Tagalog",
    nativeName: "Wikang Tagalog"
  },
  tn: {
    name: "Tswana",
    nativeName: "Setswana"
  },
  to: {
    name: "Tonga",
    nativeName: "faka Tonga"
  },
  tr: {
    name: "Turkish",
    nativeName: "Türkçe"
  },
  ts: {
    name: "Tsonga",
    nativeName: "Xitsonga"
  },
  tt: {
    name: "Tatar",
    nativeName: "татар теле"
  },
  tw: {
    name: "Twi",
    nativeName: "Twi"
  },
  ty: {
    name: "Tahitian",
    nativeName: "Reo Tahiti"
  },
  ug: {
    name: "Uyghur",
    nativeName: "ئۇيغۇرچە‎"
  },
  uk: {
    name: "Ukrainian",
    nativeName: "Українська"
  },
  ur: {
    name: "Urdu",
    nativeName: "اردو"
  },
  uz: {
    name: "Uzbek",
    nativeName: "Ўзбек"
  },
  ve: {
    name: "Venda",
    nativeName: "Tshivenḓa"
  },
  vi: {
    name: "Vietnamese",
    nativeName: "Tiếng Việt"
  },
  vo: {
    name: "Volapük",
    nativeName: "Volapük"
  },
  wa: {
    name: "Walloon",
    nativeName: "walon"
  },
  wo: {
    name: "Wolof",
    nativeName: "Wollof"
  },
  xh: {
    name: "Xhosa",
    nativeName: "isiXhosa"
  },
  yi: {
    name: "Yiddish",
    nativeName: "ייִדיש"
  },
  yo: {
    name: "Yoruba",
    nativeName: "Yorùbá"
  },
  za: {
    name: "Zhuang",
    nativeName: "Saɯ cueŋƅ"
  },
  zh: {
    name: "Chinese",
    nativeName: "中文"
  },
  zu: {
    name: "Zulu",
    nativeName: "isiZulu"
  }
};
class st {
  static getLanguages(e = []) {
    return e.map((r) => ({
      code: r,
      name: st.getName(r),
      nativeName: st.getNativeName(r)
    }));
  }
  static getName(e) {
    return st.validate(e) ? Ye[e].name : "";
  }
  static getAllNames() {
    return Object.values(Ye).map((e) => e.name);
  }
  static getNativeName(e) {
    return st.validate(e) ? Ye[e].nativeName : "";
  }
  static getAllNativeNames() {
    return Object.values(Ye).map((e) => e.nativeName);
  }
  static getCode(e) {
    return Object.keys(Ye).find((n) => {
      const i = Ye[n];
      return i.name.toLowerCase() === e.toLowerCase() || i.nativeName.toLowerCase() === e.toLowerCase();
    }) || "";
  }
  static getAllCodes() {
    return Object.keys(Ye);
  }
  static validate(e) {
    return Ye.hasOwnProperty(e);
  }
}
function U(t, e, r, n) {
  var i = arguments.length, a = i < 3 ? e : n, o;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") a = Reflect.decorate(t, e, r, n);
  else for (var u = t.length - 1; u >= 0; u--) (o = t[u]) && (a = (i < 3 ? o(a) : i > 3 ? o(e, r, a) : o(e, r)) || a);
  return i > 3 && a && Object.defineProperty(e, r, a), a;
}
function V(t, e) {
  if (typeof Reflect == "object" && typeof Reflect.metadata == "function") return Reflect.metadata(t, e);
}
function kt(t) {
  return function(e, r) {
    kr({
      name: "isLongerThan",
      target: e.constructor,
      propertyName: r,
      options: t,
      validator: {
        validate: So,
        defaultMessage() {
          return "$property must be a JSON Object with only string / number / boolean / null types";
        }
      }
    });
  };
}
function So(t) {
  if (!Eo(t))
    return !1;
  for (const e in t) {
    if (!Ke(e))
      return !1;
    const r = t[e];
    if (No(r) || !(Ke(r) || ji(r) || go(r) || Oo(r)))
      return !1;
  }
  return !0;
}
function Lr(t) {
  return function(e, r) {
    kr({
      name: "isNotBlank",
      target: e.constructor,
      propertyName: r,
      options: t,
      validator: {
        validate: Ao
      }
    });
  };
}
function Ao(t) {
  return typeof t == "string" && t.trim().length > 0;
}
const Io = "isISO6391";
function Po(t) {
  return typeof t == "string" && xo(t);
}
function Fi(t) {
  return Ue({
    name: Io,
    validator: {
      validate: (e, r) => Po(e),
      defaultMessage: Fe((e) => e + "$property must be a valid ISO6391 code")
    }
  }, t);
}
function xo(t) {
  return st.validate(t.toLocaleLowerCase());
}
var At;
(function(t) {
  t.TARGETING_MATCH = "TARGETING_MATCH", t.SPLIT = "SPLIT", t.DEFAULT = "DEFAULT", t.DISABLED = "DISABLED", t.ERROR = "ERROR", t.OVERRIDE = "OVERRIDE", t.OPT_IN = "OPT_IN";
})(At || (At = {}));
var yn;
(function(t) {
  t.ALL_USERS = "All Users", t.AUDIENCE_MATCH = "Audience Match", t.NOT_IN_AUDIENCE = "Not in Audience", t.OPT_IN = "Opt-In", t.NOT_OPTED_IN = "Not Opt-In", t.OVERRIDE = "Override", t.USER_ID = "User ID", t.EMAIL = "Email", t.COUNTRY = "Country", t.PLATFORM = "Platform", t.PLATFORM_VERSION = "Platform Version", t.APP_VERSION = "App Version", t.DEVICE_MODEL = "Device Model", t.CUSTOM_DATA = "Custom Data", t.RANDOM_DISTRIBUTION = "Random Distribution", t.ROLLOUT = "Rollout";
})(yn || (yn = {}));
var It;
(function(t) {
  t.MISSING_CONFIG = "Missing Config", t.MISSING_VARIABLE = "Missing Variable", t.MISSING_FEATURE = "Missing Feature", t.MISSING_VARIATION = "Missing Variation", t.MISSING_VARIABLE_FOR_VARIATION = "Missing Variable for Variation", t.USER_NOT_IN_ROLLOUT = "User Not in Rollout", t.USER_NOT_TARGETED = "User Not Targeted", t.INVALID_VARIABLE_TYPE = "Invalid Variable Type", t.TYPE_MISMATCH = "Variable Type Mismatch", t.UNKNOWN = "Unknown", t.ERROR = "Error";
})(It || (It = {}));
const Ui = ({ value: t }) => t === "true" ? !0 : t === "false" ? !1 : t, Mt = ({ value: t }) => {
  if (!t)
    return;
  const e = Number(t);
  return isNaN(e) ? new Date(t) : new Date(e);
};
class ae {
  isAnonymous;
  user_id;
  /**
   * Email used for identifying a device user in the dashboard,
   * or used for audience segmentation.
   */
  email;
  /**
   * Name of the user which can be used for identifying a device user,
   * or used for audience segmentation.
   */
  name;
  /**
   * ISO 639-1 two-letter codes
   */
  language;
  /**
   * ISO 3166 alpha-2
   */
  country;
  /**
   * Application Version, can be used for audience segmentation.
   */
  appVersion;
  /**
   * Application Build, can be used for audience segmentation.
   */
  appBuild;
  /**
   * Custom JSON data used for audience segmentation, must be limited to __kb in size.
   * Values will be logged to DevCycle's servers and available in the dashboard to view.
   */
  customData;
  /**
   * Private Custom JSON data used for audience segmentation, must be limited to __kb in size.
   * Values will not be logged to DevCycle's servers and
   * will not be available in the dashboard.
   */
  privateCustomData;
  /**
   * Set by SDK automatically
   */
  createdDate;
  /**
   * Set by SDK automatically
   */
  lastSeenDate;
  /**
   * Set by SDK to 'web'
   */
  platform;
  /**
   * Set by SDK to ??
   */
  platformVersion;
  /**
   * Set by SDK to User-Agent
   */
  deviceModel;
  /**
   * SDK type
   */
  sdkType = "api";
  /**
   * SDK Version
   */
  sdkVersion;
}
U([
  Mr(),
  K(),
  Ee(Ui),
  V("design:type", Boolean)
], ae.prototype, "isAnonymous", void 0);
U([
  X(),
  Lr(),
  Ce(),
  V("design:type", String)
], ae.prototype, "user_id", void 0);
U([
  X(),
  K(),
  V("design:type", String)
], ae.prototype, "email", void 0);
U([
  X(),
  K(),
  V("design:type", String)
], ae.prototype, "name", void 0);
U([
  Fi(),
  X(),
  K(),
  V("design:type", String)
], ae.prototype, "language", void 0);
U([
  Mi(),
  K(),
  V("design:type", String)
], ae.prototype, "country", void 0);
U([
  X(),
  K(),
  V("design:type", String)
], ae.prototype, "appVersion", void 0);
U([
  Ze(),
  K(),
  xe(() => Number),
  V("design:type", Number)
], ae.prototype, "appBuild", void 0);
U([
  kt(),
  K(),
  Ee(({ value: t }) => Ke(t) ? JSON.parse(t) : t),
  V("design:type", Object)
], ae.prototype, "customData", void 0);
U([
  kt(),
  K(),
  Ee(({ value: t }) => Ke(t) ? JSON.parse(t) : t),
  V("design:type", Object)
], ae.prototype, "privateCustomData", void 0);
U([
  Dt(),
  K(),
  Ee(Mt),
  V(
    "design:type",
    Date
    /**
     * Set by SDK automatically
     */
  )
], ae.prototype, "createdDate", void 0);
U([
  Dt(),
  K(),
  Ee(Mt),
  V(
    "design:type",
    Date
    /**
     * Set by SDK to 'web'
     */
  )
], ae.prototype, "lastSeenDate", void 0);
U([
  X(),
  K(),
  V("design:type", String)
], ae.prototype, "platform", void 0);
U([
  X(),
  K(),
  V("design:type", String)
], ae.prototype, "platformVersion", void 0);
U([
  X(),
  K(),
  V("design:type", String)
], ae.prototype, "deviceModel", void 0);
U([
  X(),
  K(),
  ki(["client", "server", "mobile", "api"]),
  Ee(({ value: t }) => t),
  V("design:type", String)
], ae.prototype, "sdkType", void 0);
U([
  X(),
  K(),
  V("design:type", String)
], ae.prototype, "sdkVersion", void 0);
class To extends ae {
  /**
   * JSON data recording user opt-in features.
   */
  optIns;
}
U([
  K(),
  Ee(({ value: t }) => Ke(t) ? JSON.parse(t) : t),
  V("design:type", Object)
], To.prototype, "optIns", void 0);
class le {
  /**
   * Users must be explicitly defined as anonymous, where the SDK will
   * generate a random `user_id` for them. If they are `isAnonymous = false`
   * a `user_id` value must be provided.
   */
  isAnonymous;
  user_id;
  /**
   * Email used for identifying a device user in the dashboard,
   * or used for audience segmentation.
   */
  email;
  /**
   * Name of the user which can be used for identifying a device user,
   * or used for audience segmentation.
   */
  name;
  /**
   * ISO 639-1 two-letter codes
   */
  language;
  /**
   * ISO 3166 alpha-2
   */
  country;
  /**
   * Application Version, can be used for audience segmentation.
   */
  appVersion;
  /**
   * Application Build, can be used for audience segmentation.
   */
  appBuild;
  /**
   * Custom JSON data used for audience segmentation, must be limited to __kb in size.
   * Values will be logged to DevCycle's servers and available in the dashboard to view.
   */
  customData;
  /**
   * Private Custom JSON data used for audience segmentation, must be limited to __kb in size.
   * Values will not be logged to DevCycle's servers and
   * will not be available in the dashboard.
   */
  privateCustomData;
  /**
   * Set by SDK automatically
   */
  createdDate;
  /**
   * Set by SDK automatically
   */
  lastSeenDate;
  /**
   * Set by SDK to 'web'
   */
  platform;
  /**
   * Set by SDK to ??
   */
  platformVersion;
  /**
   * Set by SDK to User-Agent
   */
  deviceModel;
  /**
   * SDK type
   */
  sdkType;
  /**
   * SDK Version
   */
  sdkVersion;
  isDebug;
}
U([
  Mr(),
  Ee(Ui),
  V("design:type", Boolean)
], le.prototype, "isAnonymous", void 0);
U([
  X(),
  Lr(),
  Ce(),
  V("design:type", String)
], le.prototype, "user_id", void 0);
U([
  X(),
  K(),
  V("design:type", String)
], le.prototype, "email", void 0);
U([
  X(),
  K(),
  V("design:type", String)
], le.prototype, "name", void 0);
U([
  Fi(),
  X(),
  K(),
  V("design:type", String)
], le.prototype, "language", void 0);
U([
  Mi(),
  K(),
  V("design:type", String)
], le.prototype, "country", void 0);
U([
  X(),
  K(),
  V("design:type", String)
], le.prototype, "appVersion", void 0);
U([
  Ze(),
  K(),
  xe(() => Number),
  V("design:type", Number)
], le.prototype, "appBuild", void 0);
U([
  kt(),
  K(),
  Ee(({ value: t }) => Ke(t) ? JSON.parse(t) : t),
  V("design:type", Object)
], le.prototype, "customData", void 0);
U([
  kt(),
  K(),
  Ee(({ value: t }) => Ke(t) ? JSON.parse(t) : t),
  V("design:type", Object)
], le.prototype, "privateCustomData", void 0);
U([
  Dt(),
  Ee(Mt),
  V(
    "design:type",
    Date
    /**
     * Set by SDK automatically
     */
  )
], le.prototype, "createdDate", void 0);
U([
  Dt(),
  Ee(Mt),
  V(
    "design:type",
    Date
    /**
     * Set by SDK to 'web'
     */
  )
], le.prototype, "lastSeenDate", void 0);
U([
  X(),
  Ce(),
  V("design:type", String)
], le.prototype, "platform", void 0);
U([
  X(),
  Ce(),
  V("design:type", String)
], le.prototype, "platformVersion", void 0);
U([
  X(),
  Ce(),
  V("design:type", String)
], le.prototype, "deviceModel", void 0);
U([
  X(),
  ki(["client", "mobile"]),
  V("design:type", String)
], le.prototype, "sdkType", void 0);
U([
  X(),
  Ce(),
  V("design:type", String)
], le.prototype, "sdkVersion", void 0);
U([
  Mr(),
  K(),
  Ee(({ value: t }) => Ke(t) ? t === "true" : t),
  V("design:type", Boolean)
], le.prototype, "isDebug", void 0);
class Do {
  user_id;
}
U([
  X(),
  Lr(),
  Ce(),
  V("design:type", String)
], Do.prototype, "user_id", void 0);
class ht {
  /**
   * type of the event
   */
  type;
  /**
   * target / subject of event. Contextual to event type
   */
  target;
  /**
   * date the event occurred according to client
   */
  date;
  /**
   * value for numerical events. Contextual to event type
   */
  value;
  /**
   * extra metadata for event. Contextual to event type
   */
  metaData;
}
U([
  Ce(),
  X(),
  V("design:type", String)
], ht.prototype, "type", void 0);
U([
  K(),
  X(),
  V("design:type", String)
], ht.prototype, "target", void 0);
U([
  K(),
  Ze(),
  V("design:type", Number)
], ht.prototype, "date", void 0);
U([
  K(),
  Ze(),
  V("design:type", Number)
], ht.prototype, "value", void 0);
U([
  K(),
  so(),
  V("design:type", Object)
], ht.prototype, "metaData", void 0);
class Vi {
  user;
  events;
}
U([
  Ce(),
  Di(),
  xe(() => ae),
  V("design:type", ae)
], Vi.prototype, "user", void 0);
U([
  Ce(),
  io(),
  Di({ each: !0 }),
  xe(() => ht),
  V("design:type", Array)
], Vi.prototype, "events", void 0);
var _n;
(function(t) {
  t["="] = "=", t["!="] = "!=", t[">"] = ">", t[">="] = ">=", t["<"] = "<", t["<="] = "<=", t.exist = "exist", t["!exist"] = "!exist", t.contain = "contain", t["!contain"] = "!contain", t.startWith = "startWith", t["!startWith"] = "!startWith", t.endWith = "endWith", t["!endWith"] = "!endWith";
})(_n || (_n = {}));
var En;
(function(t) {
  t["="] = "=", t.exist = "exist", t["!exist"] = "!exist";
})(En || (En = {}));
var bn;
(function(t) {
  t["="] = "=", t["!="] = "!=", t.exist = "exist", t["!exist"] = "!exist", t.contain = "contain", t["!contain"] = "!contain", t.startWith = "startWith", t["!startWith"] = "!startWith", t.endWith = "endWith", t["!endWith"] = "!endWith";
})(bn || (bn = {}));
var wn;
(function(t) {
  t["="] = "=", t["!="] = "!=", t[">"] = ">", t[">="] = ">=", t["<"] = "<", t["<="] = "<=", t.exist = "exist", t["!exist"] = "!exist";
})(wn || (wn = {}));
var On;
(function(t) {
  t["="] = "=", t["!="] = "!=", t[">"] = ">", t[">="] = ">=", t["<"] = "<", t["<="] = "<=", t.exist = "exist", t["!exist"] = "!exist";
})(On || (On = {}));
var Rn;
(function(t) {
  t.all = "all", t.user = "user", t.optIn = "optIn", t.audienceMatch = "audienceMatch";
})(Rn || (Rn = {}));
var Cn;
(function(t) {
  t.user_id = "user_id", t.email = "email", t.country = "country", t.platform = "platform", t.platformVersion = "platformVersion", t.appVersion = "appVersion", t.deviceModel = "deviceModel", t.customData = "customData";
})(Cn || (Cn = {}));
var Nn;
(function(t) {
  t.mixpanel = "mixpanel", t.csv = "csv";
})(Nn || (Nn = {}));
var Sn;
(function(t) {
  t.string = "String", t.boolean = "Boolean", t.number = "Number", t.semver = "Semver";
})(Sn || (Sn = {}));
var An;
(function(t) {
  t.and = "and", t.or = "or";
})(An || (An = {}));
var In;
(function(t) {
  t.override = "override";
})(In || (In = {}));
class Hi {
  /**
   * Defines the transition into this percentage level.
   */
  type;
  /**
   * Date the target percentage below should be fully applied.
   */
  date;
  /**
   * Target percentage this step should reach by the above date.
   */
  percentage;
}
U([
  xe(() => Date),
  V(
    "design:type",
    Date
    /**
     * Target percentage this step should reach by the above date.
     */
  )
], Hi.prototype, "date", void 0);
class Pt {
  /**
   * Type of rollout
   */
  type;
  /**
   * Rollout start percentage
   */
  startPercentage;
  /**
   * Date to start rollout
   */
  startDate;
  /**
   * Stages of rollout
   */
  stages;
}
U([
  xe(() => Date),
  V(
    "design:type",
    Date
    /**
     * Stages of rollout
     */
  )
], Pt.prototype, "startDate", void 0);
U([
  xe(() => Hi),
  V("design:type", Array)
], Pt.prototype, "stages", void 0);
class Gi {
  _id;
  /**
   * Audience model describing target segmentation.
   */
  _audience;
  /**
   * Rollout sub-document describing how a Target's audience is rolled out
   */
  rollout;
  /**
   * Specifies variation distribution percentages for features
   */
  distribution;
  /**
   * Field indicating a special kind of targeting rule. Normally blank.
   * Currently indicates virtual targeting rules generated due to overrides.
   */
  type;
  /**
   * Bucketing key to use for this target. If not provided, user_id will be used.
   */
  bucketingKey;
}
U([
  xe(() => Pt),
  V(
    "design:type",
    Pt
    /**
     * Specifies variation distribution percentages for features
     */
  )
], Gi.prototype, "rollout", void 0);
class Nr {
  /**
   * Mongo primary _id.
   */
  _id;
  /**
   * **Implement Later**
   *
   * Defines pre-requisite features that can describe that a user must or must not
   * be bucketed into another feature to be allowed to be bucketed into this feature.
   *
   * Pre-requisites are evaluated before `_winningVariation`,  `forcedUsers`, and `targets`.
   */
  prerequisites;
  /**
   * **Implement Later**
   *
   * Defines the winning variation delivered to all users.
   * Evaluated before `forcedUsers` and `targets`.
   */
  winningVariation;
  /**
   * **Implement Later**
   * Map of `user_id` to `_variation`
   * Defines the list of `user_ids` for which users should be forced into specific variations.
   * `forcedUsers` will be evaluated before `targets`
   */
  forcedUsers;
  /**
   * Defines the targets to evaluate what variation a user should be delivered.
   */
  targets;
}
U([
  xe(() => Gi),
  V("design:type", Array)
], Nr.prototype, "targets", void 0);
var Pn;
(function(t) {
  t.api = "api", t.dashboard = "dashboard";
})(Pn || (Pn = {}));
var xn;
(function(t) {
  t.release = "release", t.experiment = "experiment", t.permission = "permission", t.ops = "ops";
})(xn || (xn = {}));
class Bi {
  /**
   * Mongo primary _id.
   */
  _id;
  /**
   * Define the feature type.
   */
  type;
  /**
   * Unique key by Project, can be used in the SDK / API to reference by 'key' rather than _id.
   * Must only contain lower-case characters and `_` or `-`.
   */
  key;
  /**
   * Variation configurations to be used by feature configurations.
   */
  variations;
  configuration;
  /**
   * Defines feature-level settings
   */
  settings;
  /**
   * List of tags for feature
   */
  tags;
}
U([
  xe(() => Nr),
  V("design:type", Nr)
], Bi.prototype, "configuration", void 0);
var Tn;
(function(t) {
  t.api = "api", t.dashboard = "dashboard", t.clientSDK = "clientSDK", t.serverSDK = "serverSDK";
})(Tn || (Tn = {}));
var lt;
(function(t) {
  t.string = "String", t.boolean = "Boolean", t.number = "Number", t.json = "JSON";
})(lt || (lt = {}));
class ko {
  /**
   * Basic project data used for building bucketing response
   */
  project;
  /**
   * Basic environment data used for building bucketing response
   */
  environment;
  /**
   * Fully populated Feature model containing FeatureConfigurations / Variations / Audiences
   */
  features;
  /**
   * All dynamic variables in a project
   */
  variables;
  /**
   * Map of audience id to audience document, used to populate the _audience field for audienceMatch filters
   */
  audiences;
  /**
   * Map of `variable.key` to `hash(variable.key + environment.apiKey)`
   * of all known variable keys. This is used to generate the `knownVariableKeys`
   * in the BucketingAPI response.
   */
  variableHashes;
  /**
   * **Implement Later**
   *
   * All List Audiences in the project
   * TODO make required when implemented
   */
  listAudiences;
  /**
   * List of DevCycle user IDs that are associated to dashboard profiles, indicating their use in debugging features
   */
  debugUsers;
  /**
   * SSE information used for establishing connections.
   */
  sse;
  /**
   * @deprecated Deprecated ably connection/configuration
   */
  ably;
  /**
   * The client SDK key corresponding to this config. Used when a client config is
   * being retrieved via a server SDK key
   */
  clientSDKKey;
}
U([
  xe(() => Bi),
  V("design:type", Array)
], ko.prototype, "features", void 0);
class ze {
  /**
   * type of the event
   */
  type;
  /**
   * target / subject of event. Contextual to event type
   */
  target;
  /**
   * type of custom event when type == 'customEvent'
   */
  customType;
  /**
   * custom user id of user that triggered event
   */
  user_id;
  /**
   * date event occurred according to server
   */
  date;
  /**
   * date event occurred according to client
   */
  clientDate;
  /**
   * value for numerical events. Contextual to event type
   */
  value;
  /**
   * map of feature ids to variation ids
   */
  featureVars;
  /**
   * extra metadata for event. Contextual to event type
   */
  metaData;
}
U([
  X(),
  V("design:type", String)
], ze.prototype, "type", void 0);
U([
  K(),
  X(),
  V("design:type", String)
], ze.prototype, "target", void 0);
U([
  K(),
  X(),
  V("design:type", String)
], ze.prototype, "customType", void 0);
U([
  X(),
  Ce(),
  V("design:type", String)
], ze.prototype, "user_id", void 0);
U([
  Ze(),
  V("design:type", Number)
], ze.prototype, "date", void 0);
U([
  Ze(),
  V("design:type", Number)
], ze.prototype, "clientDate", void 0);
U([
  K(),
  Ze(),
  V("design:type", Number)
], ze.prototype, "value", void 0);
U([
  Ce(),
  V("design:type", Object)
], ze.prototype, "featureVars", void 0);
U([
  K(),
  V("design:type", Object)
], ze.prototype, "metaData", void 0);
function Dn(t, e, r, n) {
  if (typeof t == "boolean")
    return lt.boolean;
  if (typeof t == "number")
    return lt.number;
  if (typeof t == "string")
    return lt.string;
  if (typeof t == "object")
    return lt.json;
  if (n)
    throw new Error(`The default value for variable ${e} is not of type Boolean, Number, String, or JSON`);
  return r.warn(`The default value for variable ${e} is not of type Boolean, Number, String, or JSON`), null;
}
class mt extends Error {
  constructor(e) {
    super(e instanceof Error ? e.message : e), this.name = "UserError", e instanceof Error && (this.stack = e.stack);
  }
}
var rr, kn;
function Mo() {
  if (kn) return rr;
  kn = 1;
  function t(e, r, n) {
    var i = -1, a = e.length;
    r < 0 && (r = -r > a ? 0 : a + r), n = n > a ? a : n, n < 0 && (n += a), a = r > n ? 0 : n - r >>> 0, r >>>= 0;
    for (var o = Array(a); ++i < a; )
      o[i] = e[i + r];
    return o;
  }
  return rr = t, rr;
}
var nr, Mn;
function Lo() {
  if (Mn) return nr;
  Mn = 1;
  function t(e, r) {
    return e === r || e !== e && r !== r;
  }
  return nr = t, nr;
}
var ir, Ln;
function jr() {
  if (Ln) return ir;
  Ln = 1;
  function t(e) {
    var r = typeof e;
    return e != null && (r == "object" || r == "function");
  }
  return ir = t, ir;
}
var ar, jn;
function jo() {
  if (jn) return ar;
  jn = 1;
  var t = dt(), e = jr(), r = "[object AsyncFunction]", n = "[object Function]", i = "[object GeneratorFunction]", a = "[object Proxy]";
  function o(u) {
    if (!e(u))
      return !1;
    var v = t(u);
    return v == n || v == i || v == r || v == a;
  }
  return ar = o, ar;
}
var or, Fn;
function Fo() {
  if (Fn) return or;
  Fn = 1;
  var t = 9007199254740991;
  function e(r) {
    return typeof r == "number" && r > -1 && r % 1 == 0 && r <= t;
  }
  return or = e, or;
}
var sr, Un;
function Uo() {
  if (Un) return sr;
  Un = 1;
  var t = jo(), e = Fo();
  function r(n) {
    return n != null && e(n.length) && !t(n);
  }
  return sr = r, sr;
}
var lr, Vn;
function Vo() {
  if (Vn) return lr;
  Vn = 1;
  var t = 9007199254740991, e = /^(?:0|[1-9]\d*)$/;
  function r(n, i) {
    var a = typeof n;
    return i = i ?? t, !!i && (a == "number" || a != "symbol" && e.test(n)) && n > -1 && n % 1 == 0 && n < i;
  }
  return lr = r, lr;
}
var ur, Hn;
function Ho() {
  if (Hn) return ur;
  Hn = 1;
  var t = Lo(), e = Uo(), r = Vo(), n = jr();
  function i(a, o, u) {
    if (!n(u))
      return !1;
    var v = typeof o;
    return (v == "number" ? e(u) && r(o, u.length) : v == "string" && o in u) ? t(u[o], a) : !1;
  }
  return ur = i, ur;
}
var cr, Gn;
function Go() {
  if (Gn) return cr;
  Gn = 1;
  var t = /\s/;
  function e(r) {
    for (var n = r.length; n-- && t.test(r.charAt(n)); )
      ;
    return n;
  }
  return cr = e, cr;
}
var dr, Bn;
function Bo() {
  if (Bn) return dr;
  Bn = 1;
  var t = Go(), e = /^\s+/;
  function r(n) {
    return n && n.slice(0, t(n) + 1).replace(e, "");
  }
  return dr = r, dr;
}
var hr, $n;
function $o() {
  if ($n) return hr;
  $n = 1;
  var t = dt(), e = _t(), r = "[object Symbol]";
  function n(i) {
    return typeof i == "symbol" || e(i) && t(i) == r;
  }
  return hr = n, hr;
}
var fr, zn;
function zo() {
  if (zn) return fr;
  zn = 1;
  var t = Bo(), e = jr(), r = $o(), n = NaN, i = /^[-+]0x[0-9a-f]+$/i, a = /^0b[01]+$/i, o = /^0o[0-7]+$/i, u = parseInt;
  function v(E) {
    if (typeof E == "number")
      return E;
    if (r(E))
      return n;
    if (e(E)) {
      var b = typeof E.valueOf == "function" ? E.valueOf() : E;
      E = e(b) ? b + "" : b;
    }
    if (typeof E != "string")
      return E === 0 ? E : +E;
    E = t(E);
    var P = a.test(E);
    return P || o.test(E) ? u(E.slice(2), P ? 2 : 8) : i.test(E) ? n : +E;
  }
  return fr = v, fr;
}
var vr, qn;
function qo() {
  if (qn) return vr;
  qn = 1;
  var t = zo(), e = 1 / 0, r = 17976931348623157e292;
  function n(i) {
    if (!i)
      return i === 0 ? i : 0;
    if (i = t(i), i === e || i === -e) {
      var a = i < 0 ? -1 : 1;
      return a * r;
    }
    return i === i ? i : 0;
  }
  return vr = n, vr;
}
var gr, Yn;
function Yo() {
  if (Yn) return gr;
  Yn = 1;
  var t = qo();
  function e(r) {
    var n = t(r), i = n % 1;
    return n === n ? i ? n - i : n : 0;
  }
  return gr = e, gr;
}
var pr, Wn;
function Wo() {
  if (Wn) return pr;
  Wn = 1;
  var t = Mo(), e = Ho(), r = Yo(), n = Math.ceil, i = Math.max;
  function a(o, u, v) {
    (v ? e(o, u, v) : u === void 0) ? u = 1 : u = i(r(u), 0);
    var E = o == null ? 0 : o.length;
    if (!E || u < 1)
      return [];
    for (var b = 0, P = 0, d = Array(n(E / u)); b < E; )
      d[P++] = t(o, b, b += u);
    return d;
  }
  return pr = a, pr;
}
var Ko = Wo();
const Jo = /* @__PURE__ */ Pe(Ko);
var Ct = { exports: {} }, Qo = Ct.exports, Kn;
function Xo() {
  return Kn || (Kn = 1, (function(t, e) {
    (function(r, n) {
      t.exports = n();
    })(Qo, (function() {
      var r = function(a, o) {
        if (o = o || {}, typeof a != "function")
          throw new i("fetch must be a function");
        if (typeof o != "object")
          throw new i("defaults must be an object");
        if (o.retries !== void 0 && !n(o.retries))
          throw new i("retries must be a positive integer");
        if (o.retryDelay !== void 0 && !n(o.retryDelay) && typeof o.retryDelay != "function")
          throw new i("retryDelay must be a positive integer or a function returning a positive integer");
        if (o.retryOn !== void 0 && !Array.isArray(o.retryOn) && typeof o.retryOn != "function")
          throw new i("retryOn property expects an array or function");
        var u = {
          retries: 3,
          retryDelay: 1e3,
          retryOn: []
        };
        return o = Object.assign(u, o), function(E, b) {
          var P = o.retries, d = o.retryDelay, w = o.retryOn;
          if (b && b.retries !== void 0)
            if (n(b.retries))
              P = b.retries;
            else
              throw new i("retries must be a positive integer");
          if (b && b.retryDelay !== void 0)
            if (n(b.retryDelay) || typeof b.retryDelay == "function")
              d = b.retryDelay;
            else
              throw new i("retryDelay must be a positive integer or a function returning a positive integer");
          if (b && b.retryOn)
            if (Array.isArray(b.retryOn) || typeof b.retryOn == "function")
              w = b.retryOn;
            else
              throw new i("retryOn property expects an array or function");
          return new Promise(function(m, _) {
            var S = function(z) {
              var j = typeof Request < "u" && E instanceof Request ? E.clone() : E;
              a(j, b).then(function(x) {
                if (Array.isArray(w) && w.indexOf(x.status) === -1)
                  m(x);
                else if (typeof w == "function")
                  try {
                    return Promise.resolve(w(z, null, x)).then(function(B) {
                      B ? k(z, null, x) : m(x);
                    }).catch(_);
                  } catch (B) {
                    _(B);
                  }
                else
                  z < P ? k(z, null, x) : m(x);
              }).catch(function(x) {
                if (typeof w == "function")
                  try {
                    Promise.resolve(w(z, x, null)).then(function(B) {
                      B ? k(z, x, null) : _(x);
                    }).catch(function(B) {
                      _(B);
                    });
                  } catch (B) {
                    _(B);
                  }
                else z < P ? k(z, x, null) : _(x);
              });
            };
            function k(z, j, x) {
              var B = typeof d == "function" ? d(z, j, x) : d;
              setTimeout(function() {
                S(++z);
              }, B);
            }
            S(0);
          });
        };
      };
      function n(a) {
        return Number.isInteger(a) && a >= 0;
      }
      function i(a) {
        this.name = "ArgumentError", this.message = a;
      }
      return r;
    }));
  })(Ct)), Ct.exports;
}
var Zo = Xo();
const es = /* @__PURE__ */ Pe(Zo), ce = [];
for (let t = 0; t < 256; ++t)
  ce.push((t + 256).toString(16).slice(1));
function ts(t, e = 0) {
  return (ce[t[e + 0]] + ce[t[e + 1]] + ce[t[e + 2]] + ce[t[e + 3]] + "-" + ce[t[e + 4]] + ce[t[e + 5]] + "-" + ce[t[e + 6]] + ce[t[e + 7]] + "-" + ce[t[e + 8]] + ce[t[e + 9]] + "-" + ce[t[e + 10]] + ce[t[e + 11]] + ce[t[e + 12]] + ce[t[e + 13]] + ce[t[e + 14]] + ce[t[e + 15]]).toLowerCase();
}
let mr;
const rs = new Uint8Array(16);
function ns() {
  if (!mr) {
    if (typeof crypto > "u" || !crypto.getRandomValues)
      throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
    mr = crypto.getRandomValues.bind(crypto);
  }
  return mr(rs);
}
const is = typeof crypto < "u" && crypto.randomUUID && crypto.randomUUID.bind(crypto), Jn = { randomUUID: is };
function as(t, e, r) {
  if (Jn.randomUUID && !t)
    return Jn.randomUUID();
  t = t || {};
  const n = t.random ?? t.rng?.() ?? ns();
  if (n.length < 16)
    throw new Error("Random bytes length must be >= 16");
  return n[6] = n[6] & 15 | 64, n[8] = n[8] & 63 | 128, ts(n);
}
var gt = { exports: {} }, os = gt.exports, Qn;
function ss() {
  return Qn || (Qn = 1, (function(t, e) {
    (function(r, n) {
      var i = "1.0.41", a = "", o = "?", u = "function", v = "undefined", E = "object", b = "string", P = "major", d = "model", w = "name", m = "type", _ = "vendor", S = "version", k = "architecture", z = "console", j = "mobile", x = "tablet", B = "smarttv", Y = "wearable", be = "embedded", we = 500, oe = "Amazon", ge = "Apple", Ve = "ASUS", Te = "BlackBerry", re = "Browser", pe = "Chrome", De = "Edge", he = "Firefox", ne = "Google", ke = "Honor", He = "Huawei", Oe = "Lenovo", Ne = "LG", W = "Microsoft", fe = "Motorola", Se = "Nvidia", Q = "OnePlus", Ae = "Opera", Me = "OPPO", me = "Samsung", Z = "Sharp", J = "Sony", Le = "Xiaomi", ee = "Zebra", ye = "Facebook", Ge = "Chromium OS", Be = "Mac OS", N = " Browser", f = function(I, T) {
        var O = {};
        for (var M in I)
          T[M] && T[M].length % 2 === 0 ? O[M] = T[M].concat(I[M]) : O[M] = I[M];
        return O;
      }, p = function(I) {
        for (var T = {}, O = 0; O < I.length; O++)
          T[I[O].toUpperCase()] = I[O];
        return T;
      }, R = function(I, T) {
        return typeof I === b ? C(T).indexOf(C(I)) !== -1 : !1;
      }, C = function(I) {
        return I.toLowerCase();
      }, D = function(I) {
        return typeof I === b ? I.replace(/[^\d\.]/g, a).split(".")[0] : n;
      }, L = function(I, T) {
        if (typeof I === b)
          return I = I.replace(/^\s\s*/, a), typeof T === v ? I : I.substring(0, we);
      }, l = function(I, T) {
        for (var O = 0, M, H, $, q, G, ue; O < T.length && !G; ) {
          var te = T[O], qe = T[O + 1];
          for (M = H = 0; M < te.length && !G && te[M]; )
            if (G = te[M++].exec(I), G)
              for ($ = 0; $ < qe.length; $++)
                ue = G[++H], q = qe[$], typeof q === E && q.length > 0 ? q.length === 2 ? typeof q[1] == u ? this[q[0]] = q[1].call(this, ue) : this[q[0]] = q[1] : q.length === 3 ? typeof q[1] === u && !(q[1].exec && q[1].test) ? this[q[0]] = ue ? q[1].call(this, ue, q[2]) : n : this[q[0]] = ue ? ue.replace(q[1], q[2]) : n : q.length === 4 && (this[q[0]] = ue ? q[3].call(this, ue.replace(q[1], q[2])) : n) : this[q] = ue || n;
          O += 2;
        }
      }, h = function(I, T) {
        for (var O in T)
          if (typeof T[O] === E && T[O].length > 0) {
            for (var M = 0; M < T[O].length; M++)
              if (R(T[O][M], I))
                return O === o ? n : O;
          } else if (R(T[O], I))
            return O === o ? n : O;
        return T.hasOwnProperty("*") ? T["*"] : I;
      }, s = {
        "1.0": "/8",
        "1.2": "/1",
        "1.3": "/3",
        "2.0": "/412",
        "2.0.2": "/416",
        "2.0.3": "/417",
        "2.0.4": "/419",
        "?": "/"
      }, c = {
        ME: "4.90",
        "NT 3.11": "NT3.51",
        "NT 4.0": "NT4.0",
        2e3: "NT 5.0",
        XP: ["NT 5.1", "NT 5.2"],
        Vista: "NT 6.0",
        7: "NT 6.1",
        8: "NT 6.2",
        "8.1": "NT 6.3",
        10: ["NT 6.4", "NT 10.0"],
        RT: "ARM"
      }, g = {
        browser: [
          [
            /\b(?:crmo|crios)\/([\w\.]+)/i
            // Chrome for Android/iOS
          ],
          [S, [w, "Chrome"]],
          [
            /edg(?:e|ios|a)?\/([\w\.]+)/i
            // Microsoft Edge
          ],
          [S, [w, "Edge"]],
          [
            // Presto based
            /(opera mini)\/([-\w\.]+)/i,
            // Opera Mini
            /(opera [mobiletab]{3,6})\b.+version\/([-\w\.]+)/i,
            // Opera Mobi/Tablet
            /(opera)(?:.+version\/|[\/ ]+)([\w\.]+)/i
            // Opera
          ],
          [w, S],
          [
            /opios[\/ ]+([\w\.]+)/i
            // Opera mini on iphone >= 8.0
          ],
          [S, [w, Ae + " Mini"]],
          [
            /\bop(?:rg)?x\/([\w\.]+)/i
            // Opera GX
          ],
          [S, [w, Ae + " GX"]],
          [
            /\bopr\/([\w\.]+)/i
            // Opera Webkit
          ],
          [S, [w, Ae]],
          [
            // Mixed
            /\bb[ai]*d(?:uhd|[ub]*[aekoprswx]{5,6})[\/ ]?([\w\.]+)/i
            // Baidu
          ],
          [S, [w, "Baidu"]],
          [
            /\b(?:mxbrowser|mxios|myie2)\/?([-\w\.]*)\b/i
            // Maxthon
          ],
          [S, [w, "Maxthon"]],
          [
            /(kindle)\/([\w\.]+)/i,
            // Kindle
            /(lunascape|maxthon|netfront|jasmine|blazer|sleipnir)[\/ ]?([\w\.]*)/i,
            // Lunascape/Maxthon/Netfront/Jasmine/Blazer/Sleipnir
            // Trident based
            /(avant|iemobile|slim(?:browser|boat|jet))[\/ ]?([\d\.]*)/i,
            // Avant/IEMobile/SlimBrowser/SlimBoat/Slimjet
            /(?:ms|\()(ie) ([\w\.]+)/i,
            // Internet Explorer
            // Blink/Webkit/KHTML based                                         // Flock/RockMelt/Midori/Epiphany/Silk/Skyfire/Bolt/Iron/Iridium/PhantomJS/Bowser/QupZilla/Falkon
            /(flock|rockmelt|midori|epiphany|silk|skyfire|ovibrowser|bolt|iron|vivaldi|iridium|phantomjs|bowser|qupzilla|falkon|rekonq|puffin|brave|whale(?!.+naver)|qqbrowserlite|duckduckgo|klar|helio|(?=comodo_)?dragon)\/([-\w\.]+)/i,
            // Rekonq/Puffin/Brave/Whale/QQBrowserLite/QQ//Vivaldi/DuckDuckGo/Klar/Helio/Dragon
            /(heytap|ovi|115)browser\/([\d\.]+)/i,
            // HeyTap/Ovi/115
            /(weibo)__([\d\.]+)/i
            // Weibo
          ],
          [w, S],
          [
            /quark(?:pc)?\/([-\w\.]+)/i
            // Quark
          ],
          [S, [w, "Quark"]],
          [
            /\bddg\/([\w\.]+)/i
            // DuckDuckGo
          ],
          [S, [w, "DuckDuckGo"]],
          [
            /(?:\buc? ?browser|(?:juc.+)ucweb)[\/ ]?([\w\.]+)/i
            // UCBrowser
          ],
          [S, [w, "UC" + re]],
          [
            /microm.+\bqbcore\/([\w\.]+)/i,
            // WeChat Desktop for Windows Built-in Browser
            /\bqbcore\/([\w\.]+).+microm/i,
            /micromessenger\/([\w\.]+)/i
            // WeChat
          ],
          [S, [w, "WeChat"]],
          [
            /konqueror\/([\w\.]+)/i
            // Konqueror
          ],
          [S, [w, "Konqueror"]],
          [
            /trident.+rv[: ]([\w\.]{1,9})\b.+like gecko/i
            // IE11
          ],
          [S, [w, "IE"]],
          [
            /ya(?:search)?browser\/([\w\.]+)/i
            // Yandex
          ],
          [S, [w, "Yandex"]],
          [
            /slbrowser\/([\w\.]+)/i
            // Smart Lenovo Browser
          ],
          [S, [w, "Smart Lenovo " + re]],
          [
            /(avast|avg)\/([\w\.]+)/i
            // Avast/AVG Secure Browser
          ],
          [[w, /(.+)/, "$1 Secure " + re], S],
          [
            /\bfocus\/([\w\.]+)/i
            // Firefox Focus
          ],
          [S, [w, he + " Focus"]],
          [
            /\bopt\/([\w\.]+)/i
            // Opera Touch
          ],
          [S, [w, Ae + " Touch"]],
          [
            /coc_coc\w+\/([\w\.]+)/i
            // Coc Coc Browser
          ],
          [S, [w, "Coc Coc"]],
          [
            /dolfin\/([\w\.]+)/i
            // Dolphin
          ],
          [S, [w, "Dolphin"]],
          [
            /coast\/([\w\.]+)/i
            // Opera Coast
          ],
          [S, [w, Ae + " Coast"]],
          [
            /miuibrowser\/([\w\.]+)/i
            // MIUI Browser
          ],
          [S, [w, "MIUI" + N]],
          [
            /fxios\/([\w\.-]+)/i
            // Firefox for iOS
          ],
          [S, [w, he]],
          [
            /\bqihoobrowser\/?([\w\.]*)/i
            // 360
          ],
          [S, [w, "360"]],
          [
            /\b(qq)\/([\w\.]+)/i
            // QQ
          ],
          [[w, /(.+)/, "$1Browser"], S],
          [
            /(oculus|sailfish|huawei|vivo|pico)browser\/([\w\.]+)/i
          ],
          [[w, /(.+)/, "$1" + N], S],
          [
            // Oculus/Sailfish/HuaweiBrowser/VivoBrowser/PicoBrowser
            /samsungbrowser\/([\w\.]+)/i
            // Samsung Internet
          ],
          [S, [w, me + " Internet"]],
          [
            /metasr[\/ ]?([\d\.]+)/i
            // Sogou Explorer
          ],
          [S, [w, "Sogou Explorer"]],
          [
            /(sogou)mo\w+\/([\d\.]+)/i
            // Sogou Mobile
          ],
          [[w, "Sogou Mobile"], S],
          [
            /(electron)\/([\w\.]+) safari/i,
            // Electron-based App
            /(tesla)(?: qtcarbrowser|\/(20\d\d\.[-\w\.]+))/i,
            // Tesla
            /m?(qqbrowser|2345(?=browser|chrome|explorer))\w*[\/ ]?v?([\w\.]+)/i
            // QQ/2345
          ],
          [w, S],
          [
            /(lbbrowser|rekonq)/i,
            // LieBao Browser/Rekonq
            /\[(linkedin)app\]/i
            // LinkedIn App for iOS & Android
          ],
          [w],
          [
            /ome\/([\w\.]+) \w* ?(iron) saf/i,
            // Iron
            /ome\/([\w\.]+).+qihu (360)[es]e/i
            // 360
          ],
          [S, w],
          [
            // WebView
            /((?:fban\/fbios|fb_iab\/fb4a)(?!.+fbav)|;fbav\/([\w\.]+);)/i
            // Facebook App for iOS & Android
          ],
          [[w, ye], S],
          [
            /(Klarna)\/([\w\.]+)/i,
            // Klarna Shopping Browser for iOS & Android
            /(kakao(?:talk|story))[\/ ]([\w\.]+)/i,
            // Kakao App
            /(naver)\(.*?(\d+\.[\w\.]+).*\)/i,
            // Naver InApp
            /(daum)apps[\/ ]([\w\.]+)/i,
            // Daum App
            /safari (line)\/([\w\.]+)/i,
            // Line App for iOS
            /\b(line)\/([\w\.]+)\/iab/i,
            // Line App for Android
            /(alipay)client\/([\w\.]+)/i,
            // Alipay
            /(twitter)(?:and| f.+e\/([\w\.]+))/i,
            // Twitter
            /(chromium|instagram|snapchat)[\/ ]([-\w\.]+)/i
            // Chromium/Instagram/Snapchat
          ],
          [w, S],
          [
            /\bgsa\/([\w\.]+) .*safari\//i
            // Google Search Appliance on iOS
          ],
          [S, [w, "GSA"]],
          [
            /musical_ly(?:.+app_?version\/|_)([\w\.]+)/i
            // TikTok
          ],
          [S, [w, "TikTok"]],
          [
            /headlesschrome(?:\/([\w\.]+)| )/i
            // Chrome Headless
          ],
          [S, [w, pe + " Headless"]],
          [
            / wv\).+(chrome)\/([\w\.]+)/i
            // Chrome WebView
          ],
          [[w, pe + " WebView"], S],
          [
            /droid.+ version\/([\w\.]+)\b.+(?:mobile safari|safari)/i
            // Android Browser
          ],
          [S, [w, "Android " + re]],
          [
            /(chrome|omniweb|arora|[tizenoka]{5} ?browser)\/v?([\w\.]+)/i
            // Chrome/OmniWeb/Arora/Tizen/Nokia
          ],
          [w, S],
          [
            /version\/([\w\.\,]+) .*mobile\/\w+ (safari)/i
            // Mobile Safari
          ],
          [S, [w, "Mobile Safari"]],
          [
            /version\/([\w(\.|\,)]+) .*(mobile ?safari|safari)/i
            // Safari & Safari Mobile
          ],
          [S, w],
          [
            /webkit.+?(mobile ?safari|safari)(\/[\w\.]+)/i
            // Safari < 3.0
          ],
          [w, [S, h, s]],
          [
            /(webkit|khtml)\/([\w\.]+)/i
          ],
          [w, S],
          [
            // Gecko based
            /(navigator|netscape\d?)\/([-\w\.]+)/i
            // Netscape
          ],
          [[w, "Netscape"], S],
          [
            /(wolvic|librewolf)\/([\w\.]+)/i
            // Wolvic/LibreWolf
          ],
          [w, S],
          [
            /mobile vr; rv:([\w\.]+)\).+firefox/i
            // Firefox Reality
          ],
          [S, [w, he + " Reality"]],
          [
            /ekiohf.+(flow)\/([\w\.]+)/i,
            // Flow
            /(swiftfox)/i,
            // Swiftfox
            /(icedragon|iceweasel|camino|chimera|fennec|maemo browser|minimo|conkeror)[\/ ]?([\w\.\+]+)/i,
            // IceDragon/Iceweasel/Camino/Chimera/Fennec/Maemo/Minimo/Conkeror
            /(seamonkey|k-meleon|icecat|iceape|firebird|phoenix|palemoon|basilisk|waterfox)\/([-\w\.]+)$/i,
            // Firefox/SeaMonkey/K-Meleon/IceCat/IceApe/Firebird/Phoenix
            /(firefox)\/([\w\.]+)/i,
            // Other Firefox-based
            /(mozilla)\/([\w\.]+) .+rv\:.+gecko\/\d+/i,
            // Mozilla
            // Other
            /(amaya|dillo|doris|icab|ladybird|lynx|mosaic|netsurf|obigo|polaris|w3m|(?:go|ice|up)[\. ]?browser)[-\/ ]?v?([\w\.]+)/i,
            // Polaris/Lynx/Dillo/iCab/Doris/Amaya/w3m/NetSurf/Obigo/Mosaic/Go/ICE/UP.Browser/Ladybird
            /\b(links) \(([\w\.]+)/i
            // Links
          ],
          [w, [S, /_/g, "."]],
          [
            /(cobalt)\/([\w\.]+)/i
            // Cobalt
          ],
          [w, [S, /master.|lts./, ""]]
        ],
        cpu: [
          [
            /\b((amd|x|x86[-_]?|wow|win)64)\b/i
            // AMD64 (x64)
          ],
          [[k, "amd64"]],
          [
            /(ia32(?=;))/i,
            // IA32 (quicktime)
            /\b((i[346]|x)86)(pc)?\b/i
            // IA32 (x86)
          ],
          [[k, "ia32"]],
          [
            /\b(aarch64|arm(v?[89]e?l?|_?64))\b/i
            // ARM64
          ],
          [[k, "arm64"]],
          [
            /\b(arm(v[67])?ht?n?[fl]p?)\b/i
            // ARMHF
          ],
          [[k, "armhf"]],
          [
            // PocketPC mistakenly identified as PowerPC
            /( (ce|mobile); ppc;|\/[\w\.]+arm\b)/i
          ],
          [[k, "arm"]],
          [
            /((ppc|powerpc)(64)?)( mac|;|\))/i
            // PowerPC
          ],
          [[k, /ower/, a, C]],
          [
            / sun4\w[;\)]/i
            // SPARC
          ],
          [[k, "sparc"]],
          [
            /\b(avr32|ia64(?=;)|68k(?=\))|\barm(?=v([1-7]|[5-7]1)l?|;|eabi)|(irix|mips|sparc)(64)?\b|pa-risc)/i
            // IA64, 68K, ARM/64, AVR/32, IRIX/64, MIPS/64, SPARC/64, PA-RISC
          ],
          [[k, C]]
        ],
        device: [
          [
            //////////////////////////
            // MOBILES & TABLETS
            /////////////////////////
            // Samsung
            /\b(sch-i[89]0\d|shw-m380s|sm-[ptx]\w{2,4}|gt-[pn]\d{2,4}|sgh-t8[56]9|nexus 10)/i
          ],
          [d, [_, me], [m, x]],
          [
            /\b((?:s[cgp]h|gt|sm)-(?![lr])\w+|sc[g-]?[\d]+a?|galaxy nexus)/i,
            /samsung[- ]((?!sm-[lr])[-\w]+)/i,
            /sec-(sgh\w+)/i
          ],
          [d, [_, me], [m, j]],
          [
            // Apple
            /(?:\/|\()(ip(?:hone|od)[\w, ]*)(?:\/|;)/i
            // iPod/iPhone
          ],
          [d, [_, ge], [m, j]],
          [
            /\((ipad);[-\w\),; ]+apple/i,
            // iPad
            /applecoremedia\/[\w\.]+ \((ipad)/i,
            /\b(ipad)\d\d?,\d\d?[;\]].+ios/i
          ],
          [d, [_, ge], [m, x]],
          [
            /(macintosh);/i
          ],
          [d, [_, ge]],
          [
            // Sharp
            /\b(sh-?[altvz]?\d\d[a-ekm]?)/i
          ],
          [d, [_, Z], [m, j]],
          [
            // Honor
            /\b((?:brt|eln|hey2?|gdi|jdn)-a?[lnw]09|(?:ag[rm]3?|jdn2|kob2)-a?[lw]0[09]hn)(?: bui|\)|;)/i
          ],
          [d, [_, ke], [m, x]],
          [
            /honor([-\w ]+)[;\)]/i
          ],
          [d, [_, ke], [m, j]],
          [
            // Huawei
            /\b((?:ag[rs][2356]?k?|bah[234]?|bg[2o]|bt[kv]|cmr|cpn|db[ry]2?|jdn2|got|kob2?k?|mon|pce|scm|sht?|[tw]gr|vrd)-[ad]?[lw][0125][09]b?|605hw|bg2-u03|(?:gem|fdr|m2|ple|t1)-[7a]0[1-4][lu]|t1-a2[13][lw]|mediapad[\w\. ]*(?= bui|\)))\b(?!.+d\/s)/i
          ],
          [d, [_, He], [m, x]],
          [
            /(?:huawei)([-\w ]+)[;\)]/i,
            /\b(nexus 6p|\w{2,4}e?-[atu]?[ln][\dx][012359c][adn]?)\b(?!.+d\/s)/i
          ],
          [d, [_, He], [m, j]],
          [
            // Xiaomi
            /oid[^\)]+; (2[\dbc]{4}(182|283|rp\w{2})[cgl]|m2105k81a?c)(?: bui|\))/i,
            /\b((?:red)?mi[-_ ]?pad[\w- ]*)(?: bui|\))/i
            // Mi Pad tablets
          ],
          [[d, /_/g, " "], [_, Le], [m, x]],
          [
            /\b(poco[\w ]+|m2\d{3}j\d\d[a-z]{2})(?: bui|\))/i,
            // Xiaomi POCO
            /\b; (\w+) build\/hm\1/i,
            // Xiaomi Hongmi 'numeric' models
            /\b(hm[-_ ]?note?[_ ]?(?:\d\w)?) bui/i,
            // Xiaomi Hongmi
            /\b(redmi[\-_ ]?(?:note|k)?[\w_ ]+)(?: bui|\))/i,
            // Xiaomi Redmi
            /oid[^\)]+; (m?[12][0-389][01]\w{3,6}[c-y])( bui|; wv|\))/i,
            // Xiaomi Redmi 'numeric' models
            /\b(mi[-_ ]?(?:a\d|one|one[_ ]plus|note lte|max|cc)?[_ ]?(?:\d?\w?)[_ ]?(?:plus|se|lite|pro)?)(?: bui|\))/i,
            // Xiaomi Mi
            / ([\w ]+) miui\/v?\d/i
          ],
          [[d, /_/g, " "], [_, Le], [m, j]],
          [
            // OPPO
            /; (\w+) bui.+ oppo/i,
            /\b(cph[12]\d{3}|p(?:af|c[al]|d\w|e[ar])[mt]\d0|x9007|a101op)\b/i
          ],
          [d, [_, Me], [m, j]],
          [
            /\b(opd2(\d{3}a?))(?: bui|\))/i
          ],
          [d, [_, h, { OnePlus: ["304", "403", "203"], "*": Me }], [m, x]],
          [
            // Vivo
            /vivo (\w+)(?: bui|\))/i,
            /\b(v[12]\d{3}\w?[at])(?: bui|;)/i
          ],
          [d, [_, "Vivo"], [m, j]],
          [
            // Realme
            /\b(rmx[1-3]\d{3})(?: bui|;|\))/i
          ],
          [d, [_, "Realme"], [m, j]],
          [
            // Motorola
            /\b(milestone|droid(?:[2-4x]| (?:bionic|x2|pro|razr))?:?( 4g)?)\b[\w ]+build\//i,
            /\bmot(?:orola)?[- ](\w*)/i,
            /((?:moto(?! 360)[\w\(\) ]+|xt\d{3,4}|nexus 6)(?= bui|\)))/i
          ],
          [d, [_, fe], [m, j]],
          [
            /\b(mz60\d|xoom[2 ]{0,2}) build\//i
          ],
          [d, [_, fe], [m, x]],
          [
            // LG
            /((?=lg)?[vl]k\-?\d{3}) bui| 3\.[-\w; ]{10}lg?-([06cv9]{3,4})/i
          ],
          [d, [_, Ne], [m, x]],
          [
            /(lm(?:-?f100[nv]?|-[\w\.]+)(?= bui|\))|nexus [45])/i,
            /\blg[-e;\/ ]+((?!browser|netcast|android tv|watch)\w+)/i,
            /\blg-?([\d\w]+) bui/i
          ],
          [d, [_, Ne], [m, j]],
          [
            // Lenovo
            /(ideatab[-\w ]+|602lv|d-42a|a101lv|a2109a|a3500-hv|s[56]000|pb-6505[my]|tb-?x?\d{3,4}(?:f[cu]|xu|[av])|yt\d?-[jx]?\d+[lfmx])( bui|;|\)|\/)/i,
            /lenovo ?(b[68]0[08]0-?[hf]?|tab(?:[\w- ]+?)|tb[\w-]{6,7})( bui|;|\)|\/)/i
          ],
          [d, [_, Oe], [m, x]],
          [
            // Nokia
            /(nokia) (t[12][01])/i
          ],
          [_, d, [m, x]],
          [
            /(?:maemo|nokia).*(n900|lumia \d+|rm-\d+)/i,
            /nokia[-_ ]?(([-\w\. ]*))/i
          ],
          [[d, /_/g, " "], [m, j], [_, "Nokia"]],
          [
            // Google
            /(pixel (c|tablet))\b/i
            // Google Pixel C/Tablet
          ],
          [d, [_, ne], [m, x]],
          [
            /droid.+; (pixel[\daxl ]{0,6})(?: bui|\))/i
            // Google Pixel
          ],
          [d, [_, ne], [m, j]],
          [
            // Sony
            /droid.+; (a?\d[0-2]{2}so|[c-g]\d{4}|so[-gl]\w+|xq-a\w[4-7][12])(?= bui|\).+chrome\/(?![1-6]{0,1}\d\.))/i
          ],
          [d, [_, J], [m, j]],
          [
            /sony tablet [ps]/i,
            /\b(?:sony)?sgp\w+(?: bui|\))/i
          ],
          [[d, "Xperia Tablet"], [_, J], [m, x]],
          [
            // OnePlus
            / (kb2005|in20[12]5|be20[12][59])\b/i,
            /(?:one)?(?:plus)? (a\d0\d\d)(?: b|\))/i
          ],
          [d, [_, Q], [m, j]],
          [
            // Amazon
            /(alexa)webm/i,
            /(kf[a-z]{2}wi|aeo(?!bc)\w\w)( bui|\))/i,
            // Kindle Fire without Silk / Echo Show
            /(kf[a-z]+)( bui|\)).+silk\//i
            // Kindle Fire HD
          ],
          [d, [_, oe], [m, x]],
          [
            /((?:sd|kf)[0349hijorstuw]+)( bui|\)).+silk\//i
            // Fire Phone
          ],
          [[d, /(.+)/g, "Fire Phone $1"], [_, oe], [m, j]],
          [
            // BlackBerry
            /(playbook);[-\w\),; ]+(rim)/i
            // BlackBerry PlayBook
          ],
          [d, _, [m, x]],
          [
            /\b((?:bb[a-f]|st[hv])100-\d)/i,
            /\(bb10; (\w+)/i
            // BlackBerry 10
          ],
          [d, [_, Te], [m, j]],
          [
            // Asus
            /(?:\b|asus_)(transfo[prime ]{4,10} \w+|eeepc|slider \w+|nexus 7|padfone|p00[cj])/i
          ],
          [d, [_, Ve], [m, x]],
          [
            / (z[bes]6[027][012][km][ls]|zenfone \d\w?)\b/i
          ],
          [d, [_, Ve], [m, j]],
          [
            // HTC
            /(nexus 9)/i
            // HTC Nexus 9
          ],
          [d, [_, "HTC"], [m, x]],
          [
            /(htc)[-;_ ]{1,2}([\w ]+(?=\)| bui)|\w+)/i,
            // HTC
            // ZTE
            /(zte)[- ]([\w ]+?)(?: bui|\/|\))/i,
            /(alcatel|geeksphone|nexian|panasonic(?!(?:;|\.))|sony(?!-bra))[-_ ]?([-\w]*)/i
            // Alcatel/GeeksPhone/Nexian/Panasonic/Sony
          ],
          [_, [d, /_/g, " "], [m, j]],
          [
            // TCL
            /droid [\w\.]+; ((?:8[14]9[16]|9(?:0(?:48|60|8[01])|1(?:3[27]|66)|2(?:6[69]|9[56])|466))[gqswx])\w*(\)| bui)/i
          ],
          [d, [_, "TCL"], [m, x]],
          [
            // itel
            /(itel) ((\w+))/i
          ],
          [[_, C], d, [m, h, { tablet: ["p10001l", "w7001"], "*": "mobile" }]],
          [
            // Acer
            /droid.+; ([ab][1-7]-?[0178a]\d\d?)/i
          ],
          [d, [_, "Acer"], [m, x]],
          [
            // Meizu
            /droid.+; (m[1-5] note) bui/i,
            /\bmz-([-\w]{2,})/i
          ],
          [d, [_, "Meizu"], [m, j]],
          [
            // Ulefone
            /; ((?:power )?armor(?:[\w ]{0,8}))(?: bui|\))/i
          ],
          [d, [_, "Ulefone"], [m, j]],
          [
            // Energizer
            /; (energy ?\w+)(?: bui|\))/i,
            /; energizer ([\w ]+)(?: bui|\))/i
          ],
          [d, [_, "Energizer"], [m, j]],
          [
            // Cat
            /; cat (b35);/i,
            /; (b15q?|s22 flip|s48c|s62 pro)(?: bui|\))/i
          ],
          [d, [_, "Cat"], [m, j]],
          [
            // Smartfren
            /((?:new )?andromax[\w- ]+)(?: bui|\))/i
          ],
          [d, [_, "Smartfren"], [m, j]],
          [
            // Nothing
            /droid.+; (a(?:015|06[35]|142p?))/i
          ],
          [d, [_, "Nothing"], [m, j]],
          [
            // Archos
            /; (x67 5g|tikeasy \w+|ac[1789]\d\w+)( b|\))/i,
            /archos ?(5|gamepad2?|([\w ]*[t1789]|hello) ?\d+[\w ]*)( b|\))/i
          ],
          [d, [_, "Archos"], [m, x]],
          [
            /archos ([\w ]+)( b|\))/i,
            /; (ac[3-6]\d\w{2,8})( b|\))/i
          ],
          [d, [_, "Archos"], [m, j]],
          [
            // MIXED
            /(imo) (tab \w+)/i,
            // IMO
            /(infinix) (x1101b?)/i
            // Infinix XPad
          ],
          [_, d, [m, x]],
          [
            /(blackberry|benq|palm(?=\-)|sonyericsson|acer|asus(?! zenw)|dell|jolla|meizu|motorola|polytron|infinix|tecno|micromax|advan)[-_ ]?([-\w]*)/i,
            // BlackBerry/BenQ/Palm/Sony-Ericsson/Acer/Asus/Dell/Meizu/Motorola/Polytron/Infinix/Tecno/Micromax/Advan
            /; (hmd|imo) ([\w ]+?)(?: bui|\))/i,
            // HMD/IMO
            /(hp) ([\w ]+\w)/i,
            // HP iPAQ
            /(microsoft); (lumia[\w ]+)/i,
            // Microsoft Lumia
            /(lenovo)[-_ ]?([-\w ]+?)(?: bui|\)|\/)/i,
            // Lenovo
            /(oppo) ?([\w ]+) bui/i
            // OPPO
          ],
          [_, d, [m, j]],
          [
            /(kobo)\s(ereader|touch)/i,
            // Kobo
            /(hp).+(touchpad(?!.+tablet)|tablet)/i,
            // HP TouchPad
            /(kindle)\/([\w\.]+)/i,
            // Kindle
            /(nook)[\w ]+build\/(\w+)/i,
            // Nook
            /(dell) (strea[kpr\d ]*[\dko])/i,
            // Dell Streak
            /(le[- ]+pan)[- ]+(\w{1,9}) bui/i,
            // Le Pan Tablets
            /(trinity)[- ]*(t\d{3}) bui/i,
            // Trinity Tablets
            /(gigaset)[- ]+(q\w{1,9}) bui/i,
            // Gigaset Tablets
            /(vodafone) ([\w ]+)(?:\)| bui)/i
            // Vodafone
          ],
          [_, d, [m, x]],
          [
            /(surface duo)/i
            // Surface Duo
          ],
          [d, [_, W], [m, x]],
          [
            /droid [\d\.]+; (fp\du?)(?: b|\))/i
            // Fairphone
          ],
          [d, [_, "Fairphone"], [m, j]],
          [
            /(u304aa)/i
            // AT&T
          ],
          [d, [_, "AT&T"], [m, j]],
          [
            /\bsie-(\w*)/i
            // Siemens
          ],
          [d, [_, "Siemens"], [m, j]],
          [
            /\b(rct\w+) b/i
            // RCA Tablets
          ],
          [d, [_, "RCA"], [m, x]],
          [
            /\b(venue[\d ]{2,7}) b/i
            // Dell Venue Tablets
          ],
          [d, [_, "Dell"], [m, x]],
          [
            /\b(q(?:mv|ta)\w+) b/i
            // Verizon Tablet
          ],
          [d, [_, "Verizon"], [m, x]],
          [
            /\b(?:barnes[& ]+noble |bn[rt])([\w\+ ]*) b/i
            // Barnes & Noble Tablet
          ],
          [d, [_, "Barnes & Noble"], [m, x]],
          [
            /\b(tm\d{3}\w+) b/i
          ],
          [d, [_, "NuVision"], [m, x]],
          [
            /\b(k88) b/i
            // ZTE K Series Tablet
          ],
          [d, [_, "ZTE"], [m, x]],
          [
            /\b(nx\d{3}j) b/i
            // ZTE Nubia
          ],
          [d, [_, "ZTE"], [m, j]],
          [
            /\b(gen\d{3}) b.+49h/i
            // Swiss GEN Mobile
          ],
          [d, [_, "Swiss"], [m, j]],
          [
            /\b(zur\d{3}) b/i
            // Swiss ZUR Tablet
          ],
          [d, [_, "Swiss"], [m, x]],
          [
            /\b((zeki)?tb.*\b) b/i
            // Zeki Tablets
          ],
          [d, [_, "Zeki"], [m, x]],
          [
            /\b([yr]\d{2}) b/i,
            /\b(dragon[- ]+touch |dt)(\w{5}) b/i
            // Dragon Touch Tablet
          ],
          [[_, "Dragon Touch"], d, [m, x]],
          [
            /\b(ns-?\w{0,9}) b/i
            // Insignia Tablets
          ],
          [d, [_, "Insignia"], [m, x]],
          [
            /\b((nxa|next)-?\w{0,9}) b/i
            // NextBook Tablets
          ],
          [d, [_, "NextBook"], [m, x]],
          [
            /\b(xtreme\_)?(v(1[045]|2[015]|[3469]0|7[05])) b/i
            // Voice Xtreme Phones
          ],
          [[_, "Voice"], d, [m, j]],
          [
            /\b(lvtel\-)?(v1[12]) b/i
            // LvTel Phones
          ],
          [[_, "LvTel"], d, [m, j]],
          [
            /\b(ph-1) /i
            // Essential PH-1
          ],
          [d, [_, "Essential"], [m, j]],
          [
            /\b(v(100md|700na|7011|917g).*\b) b/i
            // Envizen Tablets
          ],
          [d, [_, "Envizen"], [m, x]],
          [
            /\b(trio[-\w\. ]+) b/i
            // MachSpeed Tablets
          ],
          [d, [_, "MachSpeed"], [m, x]],
          [
            /\btu_(1491) b/i
            // Rotor Tablets
          ],
          [d, [_, "Rotor"], [m, x]],
          [
            /((?:tegranote|shield t(?!.+d tv))[\w- ]*?)(?: b|\))/i
            // Nvidia Tablets
          ],
          [d, [_, Se], [m, x]],
          [
            /(sprint) (\w+)/i
            // Sprint Phones
          ],
          [_, d, [m, j]],
          [
            /(kin\.[onetw]{3})/i
            // Microsoft Kin
          ],
          [[d, /\./g, " "], [_, W], [m, j]],
          [
            /droid.+; (cc6666?|et5[16]|mc[239][23]x?|vc8[03]x?)\)/i
            // Zebra
          ],
          [d, [_, ee], [m, x]],
          [
            /droid.+; (ec30|ps20|tc[2-8]\d[kx])\)/i
          ],
          [d, [_, ee], [m, j]],
          [
            ///////////////////
            // SMARTTVS
            ///////////////////
            /smart-tv.+(samsung)/i
            // Samsung
          ],
          [_, [m, B]],
          [
            /hbbtv.+maple;(\d+)/i
          ],
          [[d, /^/, "SmartTV"], [_, me], [m, B]],
          [
            /(nux; netcast.+smarttv|lg (netcast\.tv-201\d|android tv))/i
            // LG SmartTV
          ],
          [[_, Ne], [m, B]],
          [
            /(apple) ?tv/i
            // Apple TV
          ],
          [_, [d, ge + " TV"], [m, B]],
          [
            /crkey/i
            // Google Chromecast
          ],
          [[d, pe + "cast"], [_, ne], [m, B]],
          [
            /droid.+aft(\w+)( bui|\))/i
            // Fire TV
          ],
          [d, [_, oe], [m, B]],
          [
            /(shield \w+ tv)/i
            // Nvidia Shield TV
          ],
          [d, [_, Se], [m, B]],
          [
            /\(dtv[\);].+(aquos)/i,
            /(aquos-tv[\w ]+)\)/i
            // Sharp
          ],
          [d, [_, Z], [m, B]],
          [
            /(bravia[\w ]+)( bui|\))/i
            // Sony
          ],
          [d, [_, J], [m, B]],
          [
            /(mi(tv|box)-?\w+) bui/i
            // Xiaomi
          ],
          [d, [_, Le], [m, B]],
          [
            /Hbbtv.*(technisat) (.*);/i
            // TechniSAT
          ],
          [_, d, [m, B]],
          [
            /\b(roku)[\dx]*[\)\/]((?:dvp-)?[\d\.]*)/i,
            // Roku
            /hbbtv\/\d+\.\d+\.\d+ +\([\w\+ ]*; *([\w\d][^;]*);([^;]*)/i
            // HbbTV devices
          ],
          [[_, L], [d, L], [m, B]],
          [
            // SmartTV from Unidentified Vendors
            /droid.+; ([\w- ]+) (?:android tv|smart[- ]?tv)/i
          ],
          [d, [m, B]],
          [
            /\b(android tv|smart[- ]?tv|opera tv|tv; rv:)\b/i
          ],
          [[m, B]],
          [
            ///////////////////
            // CONSOLES
            ///////////////////
            /(ouya)/i,
            // Ouya
            /(nintendo) ([wids3utch]+)/i
            // Nintendo
          ],
          [_, d, [m, z]],
          [
            /droid.+; (shield)( bui|\))/i
            // Nvidia Portable
          ],
          [d, [_, Se], [m, z]],
          [
            /(playstation \w+)/i
            // Playstation
          ],
          [d, [_, J], [m, z]],
          [
            /\b(xbox(?: one)?(?!; xbox))[\); ]/i
            // Microsoft Xbox
          ],
          [d, [_, W], [m, z]],
          [
            ///////////////////
            // WEARABLES
            ///////////////////
            /\b(sm-[lr]\d\d[0156][fnuw]?s?|gear live)\b/i
            // Samsung Galaxy Watch
          ],
          [d, [_, me], [m, Y]],
          [
            /((pebble))app/i,
            // Pebble
            /(asus|google|lg|oppo) ((pixel |zen)?watch[\w ]*)( bui|\))/i
            // Asus ZenWatch / LG Watch / Pixel Watch
          ],
          [_, d, [m, Y]],
          [
            /(ow(?:19|20)?we?[1-3]{1,3})/i
            // Oppo Watch
          ],
          [d, [_, Me], [m, Y]],
          [
            /(watch)(?: ?os[,\/]|\d,\d\/)[\d\.]+/i
            // Apple Watch
          ],
          [d, [_, ge], [m, Y]],
          [
            /(opwwe\d{3})/i
            // OnePlus Watch
          ],
          [d, [_, Q], [m, Y]],
          [
            /(moto 360)/i
            // Motorola 360
          ],
          [d, [_, fe], [m, Y]],
          [
            /(smartwatch 3)/i
            // Sony SmartWatch
          ],
          [d, [_, J], [m, Y]],
          [
            /(g watch r)/i
            // LG G Watch R
          ],
          [d, [_, Ne], [m, Y]],
          [
            /droid.+; (wt63?0{2,3})\)/i
          ],
          [d, [_, ee], [m, Y]],
          [
            ///////////////////
            // XR
            ///////////////////
            /droid.+; (glass) \d/i
            // Google Glass
          ],
          [d, [_, ne], [m, Y]],
          [
            /(pico) (4|neo3(?: link|pro)?)/i
            // Pico
          ],
          [_, d, [m, Y]],
          [
            /; (quest( \d| pro)?)/i
            // Oculus Quest
          ],
          [d, [_, ye], [m, Y]],
          [
            ///////////////////
            // EMBEDDED
            ///////////////////
            /(tesla)(?: qtcarbrowser|\/[-\w\.]+)/i
            // Tesla
          ],
          [_, [m, be]],
          [
            /(aeobc)\b/i
            // Echo Dot
          ],
          [d, [_, oe], [m, be]],
          [
            /(homepod).+mac os/i
            // Apple HomePod
          ],
          [d, [_, ge], [m, be]],
          [
            /windows iot/i
          ],
          [[m, be]],
          [
            ////////////////////
            // MIXED (GENERIC)
            ///////////////////
            /droid .+?; ([^;]+?)(?: bui|; wv\)|\) applew).+? mobile safari/i
            // Android Phones from Unidentified Vendors
          ],
          [d, [m, j]],
          [
            /droid .+?; ([^;]+?)(?: bui|\) applew).+?(?! mobile) safari/i
            // Android Tablets from Unidentified Vendors
          ],
          [d, [m, x]],
          [
            /\b((tablet|tab)[;\/]|focus\/\d(?!.+mobile))/i
            // Unidentifiable Tablet
          ],
          [[m, x]],
          [
            /(phone|mobile(?:[;\/]| [ \w\/\.]*safari)|pda(?=.+windows ce))/i
            // Unidentifiable Mobile
          ],
          [[m, j]],
          [
            /droid .+?; ([\w\. -]+)( bui|\))/i
            // Generic Android Device
          ],
          [d, [_, "Generic"]]
        ],
        engine: [
          [
            /windows.+ edge\/([\w\.]+)/i
            // EdgeHTML
          ],
          [S, [w, De + "HTML"]],
          [
            /(arkweb)\/([\w\.]+)/i
            // ArkWeb
          ],
          [w, S],
          [
            /webkit\/537\.36.+chrome\/(?!27)([\w\.]+)/i
            // Blink
          ],
          [S, [w, "Blink"]],
          [
            /(presto)\/([\w\.]+)/i,
            // Presto
            /(webkit|trident|netfront|netsurf|amaya|lynx|w3m|goanna|servo)\/([\w\.]+)/i,
            // WebKit/Trident/NetFront/NetSurf/Amaya/Lynx/w3m/Goanna/Servo
            /ekioh(flow)\/([\w\.]+)/i,
            // Flow
            /(khtml|tasman|links)[\/ ]\(?([\w\.]+)/i,
            // KHTML/Tasman/Links
            /(icab)[\/ ]([23]\.[\d\.]+)/i,
            // iCab
            /\b(libweb)/i
            // LibWeb
          ],
          [w, S],
          [
            /ladybird\//i
          ],
          [[w, "LibWeb"]],
          [
            /rv\:([\w\.]{1,9})\b.+(gecko)/i
            // Gecko
          ],
          [S, w]
        ],
        os: [
          [
            // Windows
            /microsoft (windows) (vista|xp)/i
            // Windows (iTunes)
          ],
          [w, S],
          [
            /(windows (?:phone(?: os)?|mobile|iot))[\/ ]?([\d\.\w ]*)/i
            // Windows Phone
          ],
          [w, [S, h, c]],
          [
            /windows nt 6\.2; (arm)/i,
            // Windows RT
            /windows[\/ ]([ntce\d\. ]+\w)(?!.+xbox)/i,
            /(?:win(?=3|9|n)|win 9x )([nt\d\.]+)/i
          ],
          [[S, h, c], [w, "Windows"]],
          [
            // iOS/macOS
            /[adehimnop]{4,7}\b(?:.*os ([\w]+) like mac|; opera)/i,
            // iOS
            /(?:ios;fbsv\/|iphone.+ios[\/ ])([\d\.]+)/i,
            /cfnetwork\/.+darwin/i
          ],
          [[S, /_/g, "."], [w, "iOS"]],
          [
            /(mac os x) ?([\w\. ]*)/i,
            /(macintosh|mac_powerpc\b)(?!.+haiku)/i
            // Mac OS
          ],
          [[w, Be], [S, /_/g, "."]],
          [
            // Mobile OSes
            /droid ([\w\.]+)\b.+(android[- ]x86|harmonyos)/i
            // Android-x86/HarmonyOS
          ],
          [S, w],
          [
            /(ubuntu) ([\w\.]+) like android/i
            // Ubuntu Touch
          ],
          [[w, /(.+)/, "$1 Touch"], S],
          [
            // Android/Blackberry/WebOS/QNX/Bada/RIM/KaiOS/Maemo/MeeGo/S40/Sailfish OS/OpenHarmony/Tizen
            /(android|bada|blackberry|kaios|maemo|meego|openharmony|qnx|rim tablet os|sailfish|series40|symbian|tizen|webos)\w*[-\/; ]?([\d\.]*)/i
          ],
          [w, S],
          [
            /\(bb(10);/i
            // BlackBerry 10
          ],
          [S, [w, Te]],
          [
            /(?:symbian ?os|symbos|s60(?=;)|series ?60)[-\/ ]?([\w\.]*)/i
            // Symbian
          ],
          [S, [w, "Symbian"]],
          [
            /mozilla\/[\d\.]+ \((?:mobile|tablet|tv|mobile; [\w ]+); rv:.+ gecko\/([\w\.]+)/i
            // Firefox OS
          ],
          [S, [w, he + " OS"]],
          [
            /web0s;.+rt(tv)/i,
            /\b(?:hp)?wos(?:browser)?\/([\w\.]+)/i
            // WebOS
          ],
          [S, [w, "webOS"]],
          [
            /watch(?: ?os[,\/]|\d,\d\/)([\d\.]+)/i
            // watchOS
          ],
          [S, [w, "watchOS"]],
          [
            // Google Chromecast
            /crkey\/([\d\.]+)/i
            // Google Chromecast
          ],
          [S, [w, pe + "cast"]],
          [
            /(cros) [\w]+(?:\)| ([\w\.]+)\b)/i
            // Chromium OS
          ],
          [[w, Ge], S],
          [
            // Smart TVs
            /panasonic;(viera)/i,
            // Panasonic Viera
            /(netrange)mmh/i,
            // Netrange
            /(nettv)\/(\d+\.[\w\.]+)/i,
            // NetTV
            // Console
            /(nintendo|playstation) ([wids345portablevuch]+)/i,
            // Nintendo/Playstation
            /(xbox); +xbox ([^\);]+)/i,
            // Microsoft Xbox (360, One, X, S, Series X, Series S)
            // Other
            /\b(joli|palm)\b ?(?:os)?\/?([\w\.]*)/i,
            // Joli/Palm
            /(mint)[\/\(\) ]?(\w*)/i,
            // Mint
            /(mageia|vectorlinux)[; ]/i,
            // Mageia/VectorLinux
            /([kxln]?ubuntu|debian|suse|opensuse|gentoo|arch(?= linux)|slackware|fedora|mandriva|centos|pclinuxos|red ?hat|zenwalk|linpus|raspbian|plan 9|minix|risc os|contiki|deepin|manjaro|elementary os|sabayon|linspire)(?: gnu\/linux)?(?: enterprise)?(?:[- ]linux)?(?:-gnu)?[-\/ ]?(?!chrom|package)([-\w\.]*)/i,
            // Ubuntu/Debian/SUSE/Gentoo/Arch/Slackware/Fedora/Mandriva/CentOS/PCLinuxOS/RedHat/Zenwalk/Linpus/Raspbian/Plan9/Minix/RISCOS/Contiki/Deepin/Manjaro/elementary/Sabayon/Linspire
            /(hurd|linux)(?: arm\w*| x86\w*| ?)([\w\.]*)/i,
            // Hurd/Linux
            /(gnu) ?([\w\.]*)/i,
            // GNU
            /\b([-frentopcghs]{0,5}bsd|dragonfly)[\/ ]?(?!amd|[ix346]{1,2}86)([\w\.]*)/i,
            // FreeBSD/NetBSD/OpenBSD/PC-BSD/GhostBSD/DragonFly
            /(haiku) (\w+)/i
            // Haiku
          ],
          [w, S],
          [
            /(sunos) ?([\w\.\d]*)/i
            // Solaris
          ],
          [[w, "Solaris"], S],
          [
            /((?:open)?solaris)[-\/ ]?([\w\.]*)/i,
            // Solaris
            /(aix) ((\d)(?=\.|\)| )[\w\.])*/i,
            // AIX
            /\b(beos|os\/2|amigaos|morphos|openvms|fuchsia|hp-ux|serenityos)/i,
            // BeOS/OS2/AmigaOS/MorphOS/OpenVMS/Fuchsia/HP-UX/SerenityOS
            /(unix) ?([\w\.]*)/i
            // UNIX
          ],
          [w, S]
        ]
      }, y = function(I, T) {
        if (typeof I === E && (T = I, I = n), !(this instanceof y))
          return new y(I, T).getResult();
        var O = typeof r !== v && r.navigator ? r.navigator : n, M = I || (O && O.userAgent ? O.userAgent : a), H = O && O.userAgentData ? O.userAgentData : n, $ = T ? f(g, T) : g, q = O && O.userAgent == M;
        return this.getBrowser = function() {
          var G = {};
          return G[w] = n, G[S] = n, l.call(G, M, $.browser), G[P] = D(G[S]), q && O && O.brave && typeof O.brave.isBrave == u && (G[w] = "Brave"), G;
        }, this.getCPU = function() {
          var G = {};
          return G[k] = n, l.call(G, M, $.cpu), G;
        }, this.getDevice = function() {
          var G = {};
          return G[_] = n, G[d] = n, G[m] = n, l.call(G, M, $.device), q && !G[m] && H && H.mobile && (G[m] = j), q && G[d] == "Macintosh" && O && typeof O.standalone !== v && O.maxTouchPoints && O.maxTouchPoints > 2 && (G[d] = "iPad", G[m] = x), G;
        }, this.getEngine = function() {
          var G = {};
          return G[w] = n, G[S] = n, l.call(G, M, $.engine), G;
        }, this.getOS = function() {
          var G = {};
          return G[w] = n, G[S] = n, l.call(G, M, $.os), q && !G[w] && H && H.platform && H.platform != "Unknown" && (G[w] = H.platform.replace(/chrome os/i, Ge).replace(/macos/i, Be)), G;
        }, this.getResult = function() {
          return {
            ua: this.getUA(),
            browser: this.getBrowser(),
            engine: this.getEngine(),
            os: this.getOS(),
            device: this.getDevice(),
            cpu: this.getCPU()
          };
        }, this.getUA = function() {
          return M;
        }, this.setUA = function(G) {
          return M = typeof G === b && G.length > we ? L(G, we) : G, this;
        }, this.setUA(M), this;
      };
      y.VERSION = i, y.BROWSER = p([w, S, P]), y.CPU = p([k]), y.DEVICE = p([d, _, m, z, j, B, x, Y, be]), y.ENGINE = y.OS = p([w, S]), t.exports && (e = t.exports = y), e.UAParser = y;
      var A = typeof r !== v && (r.jQuery || r.Zepto);
      if (A && !A.ua) {
        var F = new y();
        A.ua = F.getResult(), A.ua.get = function() {
          return F.getUA();
        }, A.ua.set = function(I) {
          F.setUA(I);
          var T = F.getResult();
          for (var O in T)
            A.ua[O] = T[O];
        };
      }
    })(typeof window == "object" ? window : os);
  })(gt, gt.exports)), gt.exports;
}
var ls = ss();
const us = /* @__PURE__ */ Pe(ls), _e = {
  User: "dvc:user",
  AnonUserId: "dvc:anonymous_user_id",
  AnonymousConfig: "dvc:anonymous_config",
  IdentifiedConfig: "dvc:identified_config"
}, cs = (t) => t instanceof Date ? t.getTime() : typeof t == "object" ? JSON.stringify(t) : t, ds = (t, e) => {
  for (const r in t) {
    const n = cs(t[r]);
    n != null && e.append(r, n);
  }
}, yt = (t, e) => {
  if (!hs(e))
    throw new Error(`Missing parameter: ${t}`);
}, hs = (t) => t != null, ut = (t, e, r) => {
  if (!e)
    throw new Error(`Missing parameter: ${t}`);
  if (typeof e !== r)
    throw new Error(`${t} is not of type ${r}`);
};
function $i() {
  return typeof self < "u" && self.constructor && self.constructor.name === "ServiceWorkerGlobalScope";
}
class fs {
  constructor(e) {
    const { key: r, defaultValue: n } = e;
    ut("key", r, "string"), yt("defaultValue", n), this.key = r.toLowerCase(), e.value === void 0 || e.value === null ? (this.isDefaulted = !0, this.value = n) : (this.value = e.value, this.isDefaulted = !1), this.defaultValue = e.defaultValue, this.eval = e.eval, this._feature = e._feature || null;
  }
  onUpdate(e) {
    return ut("callback", e, "function"), this.callback = e, this;
  }
}
const Sr = {
  variableEvaluated: "variableEvaluated",
  variableDefaulted: "variableDefaulted"
};
class vs {
  constructor(e, r, n) {
    var i, a, o;
    this.eventQueueBatchSize = 100, this.sdkKey = e, this.client = r, this.eventQueue = [], this.aggregateEventMap = {}, this.options = n;
    const u = typeof n.eventFlushIntervalMS == "number" ? n.eventFlushIntervalMS : 10 * 1e3;
    if (u < 500)
      throw new Error(`eventFlushIntervalMS: ${u} must be larger than 500ms`);
    if (u > 60 * 1e3)
      throw new Error(`eventFlushIntervalMS: ${u} must be smaller than 1 minute`);
    if (!((i = n.next) === null || i === void 0) && i.disableAutomaticEventFlush || (this.flushInterval = setInterval(this.flushEvents.bind(this), u)), this.flushEventQueueSize = (a = n?.flushEventQueueSize) !== null && a !== void 0 ? a : 100, this.maxEventQueueSize = (o = n?.maxEventQueueSize) !== null && o !== void 0 ? o : 1e3, this.flushEventQueueSize >= this.maxEventQueueSize)
      throw new Error(`flushEventQueueSize: ${this.flushEventQueueSize} must be smaller than maxEventQueueSize: ${this.maxEventQueueSize}`);
    if (this.flushEventQueueSize < 10 || this.flushEventQueueSize > 1e3)
      throw new Error(`flushEventQueueSize: ${this.flushEventQueueSize} must be between 10 and 1000`);
    if (this.maxEventQueueSize < 100 || this.maxEventQueueSize > 5e3)
      throw new Error(`maxEventQueueSize: ${this.maxEventQueueSize} must be between 100 and 5000`);
  }
  async flushEvents() {
    const e = this.client.user;
    if (!e) {
      this.client.logger.warn("Skipping event flush, user has not been set yet.");
      return;
    }
    const r = [...this.eventQueue], n = this.eventsFromAggregateEventMap();
    if (r.push(...n), !r.length)
      return;
    this.client.logger.info(`Flush ${r.length} Events`), this.eventQueue = [], this.aggregateEventMap = {};
    const i = Jo(r, this.eventQueueBatchSize);
    for (const a of i)
      try {
        const o = await As(this.sdkKey, this.client.config, e, a, this.client.logger, this.options);
        o.status === 201 ? this.client.logger.info(`DevCycle Flushed ${a.length} Events.`) : o.status >= 500 || o.status === 408 ? (this.client.logger.warn(`failed to flush events, retrying events. Response status: ${o.status}, message: ${o.statusText}`), this.eventQueue.push(...a)) : this.client.logger.error(`failed to flush events, dropping events. Response status: ${o.status}, message: ${o.statusText}`);
      } catch (o) {
        this.client.eventEmitter.emitError(o), this.client.logger.error(`failed to flush events due to error, dropping events. Error message: ${o?.message}`);
      }
  }
  /**
   * Queue DVCAPIEvent for producing
   */
  queueEvent(e) {
    if (this.checkEventQueueSize()) {
      this.client.logger.warn(`DevCycle: Max event queue size (${this.maxEventQueueSize}) reached, dropping event: ${e}`);
      return;
    }
    this.eventQueue.push(e);
  }
  /**
   * Queue DVCEvent that can be aggregated together, where multiple calls are aggregated
   * by incrementing the 'value' field.
   */
  queueAggregateEvent(e) {
    if (this.checkEventQueueSize()) {
      this.client.logger.warn(`DevCycle: Max event queue size (${this.maxEventQueueSize}) reached, dropping event: ${e}`);
      return;
    }
    yt("type", e.type), yt("target", e.target), e.date = Date.now(), e.value = 1;
    const r = this.aggregateEventMap[e.type];
    r ? r[e.target] ? r[e.target].value++ : r[e.target] = e : this.aggregateEventMap[e.type] = { [e.target]: e };
  }
  checkEventQueueSize() {
    const e = Object.values(this.aggregateEventMap).reduce((n, i) => n + Object.keys(i).length, 0), r = this.eventQueue.length + e;
    return r >= this.flushEventQueueSize && this.flushEvents(), r >= this.maxEventQueueSize;
  }
  /**
   * Turn the Aggregate Event Map into an Array of DVCAPIEvent objects for publishing.
   */
  eventsFromAggregateEventMap() {
    return Object.values(this.aggregateEventMap).map((e) => Object.values(e)).flat();
  }
  async close() {
    clearInterval(this.flushInterval), await this.flushEvents();
  }
}
function gs(t, e, r) {
  return {
    events: r.map((n) => new ps(n, e.user_id, t)),
    user: e
  };
}
class ps {
  constructor(e, r, n) {
    var i;
    const { type: a, target: o, date: u, value: v, metaData: E } = e;
    yt("type", a);
    const b = !(a in Sr);
    if (this.type = b ? "customEvent" : a, this.customType = b ? a : void 0, this.target = o, this.user_id = r, this.clientDate = u || Date.now(), this.value = v, n && (!((i = n.settings) === null || i === void 0) && i.filterFeatureVars) && (a === "variableEvaluated" || a === "variableDefaulted") && o) {
      const P = n?.variables[o], d = P?._feature;
      this.featureVars = d && n?.featureVariationMap[d] ? {
        [d]: n?.featureVariationMap[d]
      } : {};
    } else
      this.featureVars = n?.featureVariationMap || {};
    this.metaData = E;
  }
}
class Ar extends Error {
  constructor(e) {
    super(e), this.name = "ResponseError";
  }
}
const zi = (t) => {
  const e = Math.pow(2, t) * 100, r = e * 0.2 * Math.random();
  return e + r;
}, ms = (t) => (e, r, n) => e >= t ? !1 : !(n && n?.status < 500);
async function Fr(t) {
  if (!t.ok && t.status >= 400) {
    let e;
    try {
      const r = await t.clone().json();
      e = new Ar(r.message || "Something went wrong");
    } catch {
      e = new Ar("Something went wrong");
    }
    throw e.status = t.status, e;
  }
  return t;
}
async function ys(t, e, r) {
  var n;
  const i = new AbortController();
  try {
    const a = setTimeout(() => {
      i.abort();
    }, r), o = await bs(t, {
      ...e,
      signal: i.signal
    });
    return clearTimeout(a), o;
  } catch (a) {
    throw !((n = i?.signal) === null || n === void 0) && n.aborted ? new Error("Network connection timed out.") : a;
  }
}
async function _s(t, e, r) {
  const [n, i] = await Ur(e), a = {
    ...i.headers,
    Authorization: r,
    "Content-Type": "application/json"
  }, o = await n(t, {
    ...i,
    headers: a,
    method: "POST"
  });
  return Fr(o);
}
async function Es(t, e, r) {
  const [n, i] = await Ur(e), a = {
    ...i.headers,
    Authorization: r,
    "Content-Type": "application/json"
  }, o = await n(t, {
    ...i,
    headers: a,
    method: "PATCH"
  });
  return Fr(o);
}
async function bs(t, e) {
  const [r, n] = await Ur(e), i = { ...n.headers, "Content-Type": "application/json" }, a = await r(t, {
    ...n,
    headers: i,
    method: "GET"
  });
  return Fr(a);
}
function ws() {
  return es(fetch);
}
async function Ur(t) {
  if ("retries" in t && t.retries) {
    const r = { ...t };
    return r.retryOn = ms(t.retries), r.retryDelay = zi, [ws(), r];
  }
  return [fetch, t];
}
const qi = ".devcycle.com", Yi = "https://sdk-api" + qi, Os = "https://events" + qi, Rs = "/v1/sdkConfig", Cs = "/v1/events", Ns = "/v1/edgedb", Vr = {
  retries: 5,
  retryDelay: zi
}, Ss = async (t, e, r, n, i) => {
  const a = new URLSearchParams({ sdkKey: t });
  ds(e, a), n?.enableEdgeDB && a.append("enableEdgeDB", n.enableEdgeDB.toString()), i?.sse && (a.append("sse", "1"), i.lastModified && a.append("sseLastModified", i.lastModified.toString()), i.etag && a.append("sseEtag", i.etag)), n?.enableObfuscation && a.append("obfuscated", "1");
  const o = `${n?.apiProxyURL || Yi}${Rs}?` + a.toString();
  try {
    return await (await ys(o, Vr, 5e3)).json();
  } catch (u) {
    throw r.error(`Request to get config failed for url: ${o}, response message: ${u}`), u instanceof Ar ? u.status === 401 || u.status === 403 ? new mt(`Invalid SDK Key. Error details: ${u.message}`) : new Error(`Failed to download DevCycle config. Error details: ${u.message}`) : new Error(`Failed to download DevCycle config. Error details: ${u}`);
  }
}, As = async (t, e, r, n, i, a) => {
  if (!t)
    throw new Error("Missing sdkKey to publish events to Events API");
  const o = gs(e, r, n);
  i.info(`Submit Events Payload: ${JSON.stringify(o)}`);
  let u = `${a?.apiProxyURL || Os}${Cs}`;
  a?.enableObfuscation && (u += "?obfuscated=1");
  const v = await _s(u, {
    ...Vr,
    body: JSON.stringify(o)
  }, t), E = await v.json();
  return v.status >= 400 ? i.error(`Error posting events, status: ${v.status}, body: ${E}`) : i.info(`Posted Events, status: ${v.status}, body: ${E}`), v;
}, Is = async (t, e, r, n) => {
  if (!e)
    throw new Error("Missing sdkKey to save to Edge DB!");
  if (!t || !t.user_id)
    throw new Error("Missing user to save to Edge DB!");
  if (t.isAnonymous)
    throw new Error("Cannot save user data for an anonymous user!");
  try {
    return await Es(`${n?.apiProxyURL || Yi}${Ns}/${encodeURIComponent(t.user_id)}`, {
      ...Vr,
      body: JSON.stringify(t)
    }, e);
  } catch (i) {
    const a = i;
    a.status === 403 ? r.warn("Warning: EdgeDB feature is not enabled for this project") : a.status >= 400 ? r.warn(`Error saving user entity, status: ${a.status}, body: ${a.message}`) : r.info(`Saved user entity, status: ${a.status}, body: ${a.message}`);
    return;
  }
};
var Ps = "1.47.8", xs = {
  version: Ps
};
class We {
  generateAndSaveAnonUserId(e, r) {
    const n = e || as();
    return !e && r && r.saveAnonUserId(n), n;
  }
  constructor(e, r, n, i, a, o) {
    const u = e.user_id === "" ? void 0 : e.user_id;
    if (e.isAnonymous === !1 && !u)
      throw new Error("A User cannot be created with isAnonymous: false without a valid user_id");
    u ? (this.user_id = u, this.isAnonymous = !1) : (this.user_id = this.generateAndSaveAnonUserId(i, o), this.isAnonymous = !0), this.email = e.email, this.name = e.name, this.language = e.language, this.country = e.country, this.appVersion = e.appVersion, this.appBuild = e.appBuild, this.customData = e.customData, this.privateCustomData = e.privateCustomData, this.lastSeenDate = /* @__PURE__ */ new Date();
    const v = typeof window < "u" ? window.navigator.userAgent : a;
    if (n)
      Object.assign(this, n);
    else {
      const E = new us(v), b = E.getBrowser().name && `${E.getBrowser().name} ${E.getBrowser().version}`;
      this.createdDate = /* @__PURE__ */ new Date(), this.platform = r?.reactNative ? "ReactNative" : "web", this.platformVersion = b ?? "unknown", this.deviceModel = r?.reactNative && globalThis.DeviceInfo ? globalThis.DeviceInfo.getModel() : v ?? "SSR - unknown", this.sdkType = "client", this.sdkVersion = xs.version, this.sdkPlatform = r?.sdkPlatform;
    }
  }
  getStaticData() {
    return {
      createdDate: this.createdDate,
      platform: this.platform,
      platformVersion: this.platformVersion,
      deviceModel: this.deviceModel,
      sdkType: this.sdkType,
      sdkVersion: this.sdkVersion,
      sdkPlatform: this.sdkPlatform
    };
  }
  updateUser(e, r) {
    if (this.user_id !== e.user_id)
      throw new Error("Cannot update a user with a different user_id");
    return new We(e, r, this.getStaticData());
  }
}
const Ts = 720 * 60 * 60 * 1e3;
class Ds {
  constructor(e, r, n = Ts) {
    this.store = e, this.logger = r, this.configCacheTTL = n;
  }
  getConfigKey(e) {
    return e.isAnonymous ? `${_e.AnonymousConfig}.${e.user_id}` : `${_e.IdentifiedConfig}.${e.user_id}`;
  }
  getConfigExpiryKey(e) {
    return `${this.getConfigKey(e)}.expiry_date`;
  }
  async loadConfigExpiryDate(e) {
    const r = this.getConfigExpiryKey(e), n = await this.store.load(r) || "0";
    return parseInt(n, 10);
  }
  async saveConfig(e, r) {
    var n;
    const i = this.getConfigKey(r), a = this.getConfigExpiryKey(r), u = Date.now() + this.configCacheTTL;
    await Promise.all([
      this.store.save(i, e),
      this.store.save(a, u)
    ]), (n = this.logger) === null || n === void 0 || n.info(`Successfully saved config for user ${r.user_id} to local storage`);
  }
  isBucketedUserConfig(e) {
    return !e || typeof e != "object" ? !1 : "features" in e && "project" in e && "environment" in e && "featureVariationMap" in e && "variableVariationMap" in e && "variables" in e;
  }
  async loadConfig(e) {
    var r, n, i;
    await this.migrateLegacyConfigs(), await this.cleanupExpiredConfigs();
    const a = this.getConfigKey(e), o = await this.store.load(a);
    if (!o)
      return (r = this.logger) === null || r === void 0 || r.debug("Skipping cached config: no config found"), null;
    if (!this.isBucketedUserConfig(o))
      return (n = this.logger) === null || n === void 0 || n.debug(`Skipping cached config: invalid config found: ${JSON.stringify(o)}`), null;
    const u = await this.loadConfigExpiryDate(e);
    if (Date.now() > u) {
      (i = this.logger) === null || i === void 0 || i.debug("Skipping cached config: config has expired");
      const E = this.getConfigExpiryKey(e);
      return await Promise.all([
        this.store.remove(a),
        this.store.remove(E)
      ]), null;
    }
    return o;
  }
  async saveAnonUserId(e) {
    var r;
    await this.store.save(_e.AnonUserId, e), (r = this.logger) === null || r === void 0 || r.info("Successfully saved anonymous user id to local storage");
  }
  async loadAnonUserId() {
    return await this.store.load(_e.AnonUserId);
  }
  async removeAnonUserId() {
    const e = await this.loadAnonUserId();
    if (e) {
      const r = `${_e.AnonymousConfig}.${e}`, n = `${r}.expiry_date`;
      await Promise.all([
        this.store.remove(r),
        this.store.remove(n)
      ]);
    }
    await this.store.remove(_e.AnonUserId);
  }
  async migrateLegacyConfigs() {
    await Promise.all([
      this.migrateLegacyConfigType(_e.AnonymousConfig, !0),
      this.migrateLegacyConfigType(_e.IdentifiedConfig, !1)
    ]);
  }
  async migrateLegacyConfigType(e, r) {
    var n, i;
    try {
      const a = await this.store.load(e);
      if (!a || !this.isBucketedUserConfig(a))
        return;
      const o = `${e}.user_id`, u = await this.store.load(o);
      if (!u)
        return;
      const v = new We({ user_id: u, isAnonymous: r }, {}), E = `${e}.fetch_date`, b = this.getConfigKey(v);
      if (await this.store.load(b)) {
        await Promise.all([
          this.store.remove(e),
          this.store.remove(o),
          this.store.remove(E),
          this.store.remove(_e.User)
        ]);
        return;
      }
      (n = this.logger) === null || n === void 0 || n.debug(`Migrating legacy ${r ? "anonymous" : "identified"} config for user ${u} to new format`), await this.saveConfig(a, v), await Promise.all([
        this.store.remove(e),
        this.store.remove(o),
        this.store.remove(E),
        this.store.remove(_e.User)
      ]);
    } catch (a) {
      (i = this.logger) === null || i === void 0 || i.debug(`Failed to migrate legacy config from ${e}: ${a}`);
    }
  }
  /**
   * Clean up expired config entries from storage.
   * This removes configs for any user that have passed their expiry date.
   */
  async cleanupExpiredConfigs() {
    var e, r, n, i;
    if (!this.store.listKeys) {
      (e = this.logger) === null || e === void 0 || e.debug("Storage does not support key enumeration, skipping cleanup");
      return;
    }
    try {
      const a = Date.now(), o = [
        _e.AnonymousConfig,
        _e.IdentifiedConfig
      ];
      for (const u of o) {
        const v = await this.store.listKeys(u);
        for (const E of v) {
          if (E.endsWith(".expiry_date"))
            continue;
          const b = `${E}.expiry_date`, P = await this.store.load(b);
          if (P) {
            const d = parseInt(P, 10);
            a > d && ((r = this.logger) === null || r === void 0 || r.debug(`Cleaning up expired config: ${E}`), await Promise.all([
              this.store.remove(E),
              this.store.remove(b)
            ]));
          } else
            (n = this.logger) === null || n === void 0 || n.debug(`Cleaning up orphaned config: ${E}`), await this.store.remove(E);
        }
      }
    } catch (a) {
      (i = this.logger) === null || i === void 0 || i.debug(`Failed to cleanup expired configs: ${a}`);
    }
  }
}
class Wi {
}
class ks extends Wi {
  constructor(e = !1) {
    super(), this.isTesting = e, this.init();
  }
  async init() {
    this.store = this.isTesting ? Ms : window.localStorage;
  }
  async save(e, r) {
    this.store.setItem(e, JSON.stringify(r));
  }
  async load(e) {
    const r = this.store.getItem(e);
    return r ? JSON.parse(r) : void 0;
  }
  async remove(e) {
    this.store.removeItem(e);
  }
  async listKeys(e) {
    const r = [];
    for (let n = 0; n < this.store.length; n++) {
      const i = this.store.key(n);
      i && i.startsWith(e) && r.push(i);
    }
    return r;
  }
}
const Ms = {
  getItem: () => null,
  setItem: () => {
  },
  removeItem: () => {
  },
  clear: () => {
  },
  key: () => null,
  length: 0
};
class ve extends Wi {
  constructor() {
    super(), this.connectionPromise = new Promise((e, r) => {
      this.init().then((n) => {
        this.store = n, this.isReady = !0, e();
      }).catch((n) => r(n));
    });
  }
  async init() {
    return new Promise((e, r) => {
      const n = indexedDB.open(ve.DBName, 1);
      n.onupgradeneeded = (i) => {
        const a = n.result;
        a.objectStoreNames.contains(ve.storeName) || a.createObjectStore(ve.storeName, {
          keyPath: "id"
        });
      }, n.onsuccess = (i) => {
        e(n.result);
      }, n.onerror = (i) => {
        r(n.error);
      };
    });
  }
  async save(e, r) {
    await this.connectionPromise, this.store.transaction(ve.storeName, "readwrite").objectStore(ve.storeName).put({ id: e, data: r });
  }
  // IndexedDB load
  async load(e) {
    await this.connectionPromise;
    const i = this.store.transaction(ve.storeName, "readonly").objectStore(ve.storeName).get(e);
    return new Promise((a, o) => {
      i.onsuccess = () => {
        a(i.result ? i.result.data : void 0);
      }, i.onerror = () => o(i.error);
    });
  }
  // IndexedDB remove
  async remove(e) {
    await this.connectionPromise, this.store.transaction(ve.storeName, "readwrite").objectStore(ve.storeName).delete(e);
  }
  async listKeys(e) {
    const r = [];
    await this.connectionPromise;
    const a = this.store.transaction(ve.storeName, "readonly").objectStore(ve.storeName).openCursor();
    return new Promise((o, u) => {
      a.onsuccess = (v) => {
        const E = v.target.result;
        if (E) {
          const b = E.key;
          b.startsWith(e) && r.push(b), E.continue();
        } else
          o(r);
      }, a.onerror = () => u(a.error);
    });
  }
}
ve.storeName = "DevCycleStore";
ve.DBName = "DevCycleDB";
function Ls() {
  return $i() ? new ve() : new ks(typeof window > "u");
}
const de = {
  INITIALIZED: "initialized",
  NEW_VARIABLES: "newVariables",
  ERROR: "error",
  VARIABLE_UPDATED: "variableUpdated",
  FEATURE_UPDATED: "featureUpdated",
  CONFIG_UPDATED: "configUpdated",
  VARIABLE_EVALUATED: "variableEvaluated",
  DEBUG_USER_SET: "debugUserSet",
  DEBUG_USER_REVERTED: "debugUserReverted"
}, Xn = (t) => !Object.values(de).includes(t) && !t.startsWith(de.VARIABLE_UPDATED) && !t.startsWith(de.FEATURE_UPDATED) && !t.startsWith(de.NEW_VARIABLES) && !t.startsWith(de.VARIABLE_EVALUATED);
class js {
  constructor() {
    this.handlers = {};
  }
  subscribe(e, r) {
    if (ut("key", e, "string"), ut("handler", r, "function"), Xn(e))
      throw new Error("Not a valid event to subscribe to");
    this.handlers[e] ? this.handlers[e].push(r) : this.handlers[e] = [r];
  }
  unsubscribe(e, r) {
    if (ut("key", e, "string"), !Xn(e))
      if (r) {
        const n = this.handlers[e].findIndex((i) => i === r);
        this.handlers[e].splice(n, 1);
      } else
        this.handlers[e] = [];
  }
  emit(e, ...r) {
    var n;
    ut("key", e, "string"), (n = this.handlers[e]) === null || n === void 0 || n.forEach((i) => {
      new Promise((a) => {
        i(...r), a(!0);
      });
    });
  }
  emitDebugUserSet(e) {
    this.emit(de.DEBUG_USER_SET, e);
  }
  emitDebugUserReverted(e) {
    this.emit(de.DEBUG_USER_REVERTED, e);
  }
  emitInitialized(e) {
    this.emit(de.INITIALIZED, e);
  }
  emitError(e) {
    this.emit(de.ERROR, e);
  }
  emitConfigUpdate(e) {
    this.emit(de.CONFIG_UPDATED, e);
  }
  emitVariableEvaluated(e) {
    this.emit(`${de.VARIABLE_EVALUATED}:*`, e.key, e), this.emit(`${de.VARIABLE_EVALUATED}:${e.key}`, e.key, e);
  }
  emitVariableUpdates(e, r, n) {
    const i = new Set(Object.keys(e).concat(Object.keys(r)));
    let a = !1;
    i.forEach((o) => {
      const u = e[o] && e[o].value, v = r[o], E = v && r[o].value;
      if (JSON.stringify(u) !== JSON.stringify(E)) {
        const b = n[o] && Object.values(n[o]);
        b && (a = !0, b.forEach((d) => {
          var w;
          d.value = E ?? d.defaultValue, d.isDefaulted = E == null, (w = d.callback) === null || w === void 0 || w.call(d, d.value);
        }));
        const P = v || null;
        this.emit(`${de.VARIABLE_UPDATED}:*`, o, P), this.emit(`${de.VARIABLE_UPDATED}:${o}`, o, P);
      }
    }), a && this.emit(`${de.NEW_VARIABLES}`);
  }
  emitFeatureUpdates(e, r) {
    Object.keys(e).concat(Object.keys(r)).forEach((i) => {
      const a = e[i] && e[i]._variation, o = r[i], u = o && r[i]._variation, v = o || null;
      a !== u && (this.emit(`${de.FEATURE_UPDATED}:*`, i, v), this.emit(`${de.FEATURE_UPDATED}:${i}`, i, v));
    });
  }
}
class Fs {
  constructor(e, r, n) {
    this.requestConfigFunction = e, this.handleConfigReceivedFunction = r, this.nextUser = n, this.resolvers = [], this.requestParams = null;
  }
  async queue(e, r) {
    e && (this.nextUser = e), r && (this.requestParams = r);
    const n = new Promise((i, a) => {
      this.resolvers.push({
        resolve: i,
        reject: a
      });
    });
    return this.currentPromise || this.processQueue(), n;
  }
  async processQueue() {
    if (!this.resolvers.length)
      return;
    const e = this.resolvers.splice(0);
    await this.performRequest(this.nextUser).then((r) => {
      this.resolvers.length ? this.resolvers.push(...e) : (this.handleConfigReceivedFunction(r, this.nextUser), e.forEach(({ resolve: n }) => n(r)));
    }).catch((r) => {
      e.forEach(({ reject: n }) => n(r));
    }), this.resolvers.length && this.processQueue();
  }
  async performRequest(e) {
    return this.currentPromise = this.requestConfigFunction(e, this.requestParams ? this.requestParams : void 0), this.requestParams = null, await this.currentPromise.finally(() => {
      this.currentPromise = null;
    });
  }
}
const Zn = "[DevCycle]: ";
var $e;
(function(t) {
  t[t.debug = 0] = "debug", t[t.info = 1] = "info", t[t.warn = 2] = "warn", t[t.error = 3] = "error";
})($e || ($e = {}));
function Ki(t) {
  const e = t?.level && ji($e[t?.level]) ? $e[t?.level] : $e.error, r = t?.logWriter || console.log, n = t?.logWriter || console.error, i = (u) => r(Zn + u), a = (u, v) => n(Zn + u, v), o = (u) => {
  };
  return {
    error: $e.error >= e ? a : o,
    warn: $e.warn >= e ? i : o,
    info: $e.info >= e ? i : o,
    debug: $e.debug >= e ? i : o
  };
}
class Us {
  constructor(e, r, n) {
    this.url = e, this.onMessage = r, this.logger = n, this.openConnection();
  }
  updateURL(e) {
    this.close(), this.url = e, this.openConnection();
  }
  openConnection() {
    if (typeof EventSource > "u") {
      this.logger.warn("StreamingConnection not opened. EventSource is not available.");
      return;
    }
    this.connection = new EventSource(this.url, { withCredentials: !0 }), this.connection.onmessage = (e) => {
      this.onMessage(e.data);
    }, this.connection.onerror = () => {
      this.logger.warn("StreamingConnection warning. Connection failed to establish.");
    }, this.connection.onopen = () => {
      this.logger.debug("StreamingConnection opened");
    };
  }
  isConnected() {
    var e, r;
    return ((e = this.connection) === null || e === void 0 ? void 0 : e.readyState) === ((r = this.connection) === null || r === void 0 ? void 0 : r.OPEN);
  }
  reopen() {
    this.isConnected() || (this.close(), this.openConnection());
  }
  close() {
    var e;
    (e = this.connection) === null || e === void 0 || e.close();
  }
}
class Vs {
  constructor(e, r, n, i, a) {
    this.user = e, this.variableKey = r, this.defaultValue = n, this.metadata = i, this.evaluationContext = a;
  }
}
class Hs {
  constructor(e = [], r) {
    this.hooks = e, this.logger = r;
  }
  runHooksForEvaluation(e, r, n, i) {
    const a = new Vs(e ?? {}, r, n, {}), o = [...this.hooks], u = [...o].reverse();
    let v;
    try {
      const E = Object.freeze({
        ...a
      });
      this.runBefore(o, E), v = i.call(E);
      const b = {
        key: r,
        value: v.value,
        isDefaulted: v.isDefaulted,
        eval: v.eval
      };
      a.evaluationContext = b, this.runAfter(u, a);
    } catch (E) {
      throw this.runError(u, a, E), this.runFinally(u, a), E;
    }
    return this.runFinally(u, a), v;
  }
  runBefore(e, r) {
    for (const n of e)
      n.before(r);
  }
  runAfter(e, r) {
    for (const n of e)
      n.after(r);
  }
  runFinally(e, r) {
    var n;
    try {
      for (const i of e)
        i.onFinally(r);
    } catch (i) {
      (n = this.logger) === null || n === void 0 || n.error("Error running before hooks", i);
    }
  }
  runError(e, r, n) {
    var i;
    try {
      for (const a of e)
        a.error(r, n);
    } catch (a) {
      (i = this.logger) === null || i === void 0 || i.error("Error running error hooks", a);
    }
  }
  enqueue(e) {
    this.hooks.push(e);
  }
  clear() {
    this.hooks = [];
  }
}
class ei {
  get isInitialized() {
    return this._isInitialized;
  }
  constructor(e, r, n = {}) {
    var i;
    if (this._isInitialized = !1, this.userSaved = !1, this._closing = !1, this.isConfigCached = !1, this.initializeTriggered = !1, this.clientInitialization = async (a) => {
      if (this.initializeTriggered || this._closing)
        return this;
      this.initializeTriggered = !0;
      const o = a.user_id ? void 0 : await this.store.loadAnonUserId();
      this.user = new We(a, this.options, void 0, o, void 0, this.store), this.options.bootstrapConfig || await this.getConfigCache(this.user), this.requestConsolidator = new Fs((u, v) => Ss(this.sdkKey, u, this.logger, this.options, v), (u, v) => this.handleConfigReceived(u, v), this.user);
      try {
        this.options.bootstrapConfig ? this.handleConfigReceived(this.options.bootstrapConfig, this.user) : await this.requestConsolidator.queue(this.user), this._isInitialized = !0, this.settleOnInitialized(this), this.logger.info("Client initialized");
      } catch (u) {
        return this.initializeOnConfigFailure(this.user, u), this;
      }
      return this.eventEmitter.emitInitialized(!0), this;
    }, this.initializeOnConfigFailure = (a, o) => {
      this.isInitialized || (this.eventEmitter.emitInitialized(!1), o && this.eventEmitter.emitError(o), this.setUser(a), this.settleOnInitialized(this, o instanceof mt ? o : null));
    }, n.sdkPlatform || (n.sdkPlatform = "js"), !((i = n.next) === null || i === void 0) && i.configRefreshHandler && (this.configRefetchHandler = n.next.configRefreshHandler), this.logger = n.logger || Ki({ level: n.logLevel }), this.store = new Ds(n.storage || Ls(), this.logger, n.configCacheTTL), this.options = n, this.sdkKey = e, this.variableDefaultMap = {}, this.evalHooksRunner = new Hs(n.hooks), this.options.disableAutomaticEventLogging && this.options.disableCustomEventLogging || (this.eventQueue = new vs(e, this, n)), this.eventEmitter = new js(), this.options.disableRealtimeUpdates || this.registerVisibilityChangeHandler(), this.onInitialized = new Promise((a, o) => {
      this.settleOnInitialized = (u, v) => {
        v ? (this._isInitialized = !1, o(v)) : (this._isInitialized = !0, a(u));
      };
    }), this.options.deferInitialization) {
      if (this.options.bootstrapConfig)
        throw new Error("bootstrapConfig option can not be combined with deferred initialization!");
    } else {
      if (!r)
        throw new Error("User must be provided to initialize SDK");
      this.clientInitialization(r);
    }
    !n?.reactNative && typeof window < "u" && (this.windowMessageHandler = (a) => {
      const o = a.data;
      o?.type === "DVC.optIn.saved" && this.refetchConfig(!1);
    }, window.addEventListener("message", this.windowMessageHandler), this.windowPageHideHandler = () => {
      this.flushEvents();
    }, window.addEventListener("pagehide", this.windowPageHideHandler));
  }
  onClientInitialized(e) {
    if (e && typeof e == "function") {
      this.onInitialized.then(() => e(null, this)).catch((r) => e(r));
      return;
    }
    return this.onInitialized;
  }
  /**
   * Get variable object associated with Features. Use the variable's key to fetch the DVCVariable object.
   * If the user does not receive the feature, the default value is used in the returned DVCVariable object.
   * DVCVariable is returned, which has a `value` property that is used to grab the variable value,
   * and a convenience method to pass in a callback to notify the user when the value has changed from the server.
   *
   * @param key
   * @param defaultValue
   */
  variable(e, r) {
    return this.evalHooksRunner.runHooksForEvaluation(this.user, e, r, () => this._variable(e, r));
  }
  _variable(e, r) {
    var n, i;
    if (r == null)
      throw new Error("Default value is a required param");
    const a = Dn(r, e, this.logger, !0), o = typeof r == "string" ? r : JSON.stringify(r);
    let u;
    if (this.variableDefaultMap[e] && this.variableDefaultMap[e][o])
      u = this.variableDefaultMap[e][o];
    else {
      const v = (i = (n = this.config) === null || n === void 0 ? void 0 : n.variables) === null || i === void 0 ? void 0 : i[e], E = {
        key: e,
        defaultValue: r
      };
      v ? v.type === a ? (E.value = v.value, E._feature = v._feature, E.eval = v.eval) : (this.logger.warn(`Type mismatch for variable ${e}. Expected ${a}, got ${v.type}`), E.eval = {
        reason: At.DEFAULT,
        details: It.TYPE_MISMATCH
      }) : E.eval = {
        reason: At.DEFAULT,
        details: It.USER_NOT_TARGETED
      }, u = new fs(E), this.variableDefaultMap[e] = {
        [o]: u,
        ...this.variableDefaultMap[e]
      };
    }
    return this.trackVariableEvaluated(u), this.eventEmitter.emitVariableEvaluated(u), u;
  }
  trackVariableEvaluated(e) {
    var r, n, i;
    if (!this.options.disableAutomaticEventLogging)
      try {
        const a = (n = (r = this.config) === null || r === void 0 ? void 0 : r.variables) === null || n === void 0 ? void 0 : n[e.key];
        (i = this.eventQueue) === null || i === void 0 || i.queueAggregateEvent({
          type: e.isDefaulted ? Sr.variableDefaulted : Sr.variableEvaluated,
          target: e.key,
          metaData: {
            value: e.value,
            type: Dn(e.defaultValue, e.key, this.logger),
            _variable: a?._id,
            eval: e.eval
          }
        });
      } catch (a) {
        this.eventEmitter.emitError(a), this.logger.warn(`Error with queueing aggregate events ${a}`);
      }
  }
  /**
   * Get a variable's value associated with a Feature. Use the variable's key to fetch the variable's value.
   * If the user is not segmented into the feature, the default value is returned.
   *
   * @param key
   * @param defaultValue
   */
  variableValue(e, r) {
    return this.variable(e, r).value;
  }
  identifyUser(e, r) {
    if (this.options.next) {
      this.logger.error("Unable to change user identity from the clientside in Next.js");
      return;
    }
    const n = this._identifyUser(e);
    if (r && typeof r == "function") {
      n.then((i) => r(null, i)).catch((i) => r(i, null));
      return;
    }
    return n;
  }
  async _identifyUser(e) {
    var r, n;
    let i;
    if (this.options.deferInitialization && !this.initializeTriggered)
      return await this.clientInitialization(e), ((r = this.config) === null || r === void 0 ? void 0 : r.variables) || {};
    (n = this.eventQueue) === null || n === void 0 || n.flushEvents();
    try {
      await this.onInitialized;
      const a = await this.store.loadAnonUserId();
      this.user && e.user_id === this.user.user_id ? i = this.user.updateUser(e, this.options) : i = new We(e, this.options, void 0, a, void 0, this.store);
      const o = await this.requestConsolidator.queue(i);
      if (o)
        return o.variables;
      throw this.logger.error("Config fetch returned no config"), new Error("Failed to fetch user configuration");
    } catch (a) {
      if (i)
        try {
          const o = await this.store.loadConfig(i);
          if (o)
            return this.logger.warn("Config fetch failed, using cached user config"), this.handleConfigReceived(o, i), o.variables || {};
          this.logger.debug("Config fetch failed and no cached config available");
        } catch (o) {
          this.logger.error("Failed to load cached config", o);
        }
      throw this.eventEmitter.emitError(a), a;
    }
  }
  resetUser(e) {
    if (this.options.next) {
      this.logger.error("Unable to change user identity from the clientside in Next.js");
      return;
    }
    const r = new Promise((n, i) => {
      var a;
      (a = this.eventQueue) === null || a === void 0 || a.flushEvents(), this.onInitialized.then(async () => {
        const o = await this.store.loadAnonUserId();
        await this.store.removeAnonUserId();
        const u = new We({ isAnonymous: !0 }, this.options, void 0, void 0, void 0, this.store);
        try {
          const v = await this.requestConsolidator.queue(u);
          if (!v)
            throw this.logger.error("Config fetch returned no config"), new Error("Failed to fetch user configuration");
          return v;
        } catch (v) {
          throw o ? await this.store.saveAnonUserId(o) : await this.store.removeAnonUserId(), v;
        }
      }).then(async (o) => {
        n(o.variables);
      }).catch(async (o) => {
        this.eventEmitter.emitError(o), i(o);
      });
    });
    if (e && typeof e == "function") {
      r.then((n) => e(null, n)).catch((n) => e(n, null));
      return;
    }
    return r;
  }
  /**
   * Retrieve data on all Features, Object mapped by feature `key`.
   * Use the `DVCFeature.segmented` value to determine if the user was segmented into a
   * feature's audience.
   */
  allFeatures() {
    var e;
    return ((e = this.config) === null || e === void 0 ? void 0 : e.features) || {};
  }
  /**
   * Retrieve data on all Variables, Object mapped by variable `key`.
   */
  allVariables() {
    var e;
    return ((e = this.config) === null || e === void 0 ? void 0 : e.variables) || {};
  }
  subscribe(e, r) {
    this.eventEmitter.subscribe(e, r);
  }
  /**
   * Unsubscribe to remove existing event emitter subscription.
   *
   * @param key
   * @param handler
   */
  unsubscribe(e, r) {
    this.eventEmitter.unsubscribe(e, r);
  }
  /**
   * Track Event to DevCycle
   *
   * @param event
   */
  track(e) {
    if (this._closing) {
      this.logger.error("Client is closing, cannot track new events.");
      return;
    }
    this.options.disableCustomEventLogging || (yt("type", e.type), this.onInitialized.then(() => {
      var r;
      (r = this.eventQueue) === null || r === void 0 || r.queueEvent(e);
    }));
  }
  /**
   * Flush all queued events to DevCycle
   *
   * @param callback
   */
  flushEvents(e) {
    var r, n;
    return (n = (r = this.eventQueue) === null || r === void 0 ? void 0 : r.flushEvents().then(() => e?.())) !== null && n !== void 0 ? n : Promise.resolve().then(() => e?.());
  }
  /**
   * Close all open connections to DevCycle, flush any pending events and
   * stop any running timers and event handlers. Use to clean up a client instance
   * that is no longer needed.
   */
  async close() {
    var e, r;
    this.logger.debug("Closing client"), this._closing = !0, typeof document !== void 0 && this.pageVisibilityHandler && document.removeEventListener("visibilitychange", this.pageVisibilityHandler), this.windowMessageHandler && window.removeEventListener("message", this.windowMessageHandler), this.windowPageHideHandler && window.removeEventListener("pagehide", this.windowPageHideHandler), (e = this.streamingConnection) === null || e === void 0 || e.close(), await ((r = this.eventQueue) === null || r === void 0 ? void 0 : r.close());
  }
  /**
   * Reflects whether `close()` has been called on the client instance.
   */
  get closing() {
    return this._closing;
  }
  /**
   * Method to be called by the Isomorphic SDKs to update the bootstrapped config and user data when the server's
   * representation has changed.
   * NOTE: It is not recommended to call this yourself.
   * @param config
   * @param user
   * @param userAgent
   */
  synchronizeBootstrapData(e, r, n) {
    const i = new We(r, this.options, void 0, void 0, n, this.store);
    if (!e) {
      this.initializeOnConfigFailure(i);
      return;
    }
    if (this.options.bootstrapConfig = e, this.options.deferInitialization && !this.initializeTriggered) {
      this.clientInitialization(r);
      return;
    }
    this.handleConfigReceived(e, i);
  }
  async refetchConfig(e, r, n) {
    await this.onInitialized, this.configRefetchHandler ? this.configRefetchHandler(r) : await this.requestConsolidator.queue(null, {
      sse: e,
      lastModified: r,
      etag: n
    });
  }
  addHook(e) {
    this.evalHooksRunner.enqueue(e);
  }
  clearHooks() {
    this.evalHooksRunner.clear();
  }
  handleConfigReceived(e, r) {
    var n, i, a, o, u;
    if (!e)
      return;
    const v = this.config;
    this.config = e, this.store.saveConfig(e, r), this.isConfigCached = !1, this.setUser(r);
    const E = v?.features || {}, b = v?.variables || {};
    this.eventEmitter.emitFeatureUpdates(E, e.features), this.eventEmitter.emitVariableUpdates(b, e.variables, this.variableDefaultMap);
    const P = (a = (i = (n = this.config) === null || n === void 0 ? void 0 : n.sse) === null || i === void 0 ? void 0 : i.url) === null || a === void 0 ? void 0 : a.includes("dvc_user");
    if ((!v || P || v.etag !== this.config.etag) && this.eventEmitter.emitConfigUpdate(e.variables), !((o = e?.sse) === null || o === void 0) && o.url)
      if (this.streamingConnection)
        e.sse.url !== ((u = v?.sse) === null || u === void 0 ? void 0 : u.url) && this.streamingConnection.updateURL(e.sse.url);
      else if (this.options.disableRealtimeUpdates)
        this.logger.info("Disabling Realtime Updates based on Initialization parameter");
      else {
        const d = this.options.sseConnectionClass || Us;
        this.streamingConnection = new d(e.sse.url, this.onSSEMessage.bind(this), this.logger);
      }
  }
  async setUser(e) {
    var r;
    if (this.user != e || !this.userSaved) {
      if (this.user = e, !this.user.isAnonymous && Gs(this.logger, this.config, (r = this.options) === null || r === void 0 ? void 0 : r.enableEdgeDB, !0)) {
        const n = await Is(this.user, this.sdkKey, this.logger, this.options);
        this.logger.info(`Saved response entity! ${n}`);
      }
      this.userSaved = !0;
    }
  }
  onSSEMessage(e) {
    var r, n;
    try {
      const i = JSON.parse(e), a = JSON.parse(i.data);
      if (!a)
        return;
      (!a.type || a.type === "refetchConfig") && (!(!((r = this.config) === null || r === void 0) && r.etag) || a.etag !== ((n = this.config) === null || n === void 0 ? void 0 : n.etag)) && this.refetchConfig(!0, a.lastModified, a.etag).catch((o) => {
        this.logger.warn(`Failed to refetch config ${o}`);
      });
    } catch (i) {
      this.logger.warn(`Streaming Connection: Unparseable message ${i}`);
    }
  }
  registerVisibilityChangeHandler() {
    var e, r, n;
    if (typeof document > "u")
      return;
    const i = ((r = (e = this.config) === null || e === void 0 ? void 0 : e.sse) === null || r === void 0 ? void 0 : r.inactivityDelay) || 12e4;
    this.pageVisibilityHandler = () => {
      var a, o, u;
      if (!((a = this.config) === null || a === void 0) && a.sse)
        document.visibilityState === "visible" ? (!((o = this.streamingConnection) === null || o === void 0) && o.isConnected() || (this.logger.debug("Page became visible, refetching config"), this.refetchConfig(!1).catch((v) => {
          this.logger.warn(`Failed to refetch config ${v}`);
        }), (u = this.streamingConnection) === null || u === void 0 || u.reopen()), window?.clearTimeout(this.inactivityHandlerId)) : (window?.clearTimeout(this.inactivityHandlerId), this.inactivityHandlerId = window?.setTimeout(() => {
          var v;
          this.logger.debug("Page is not visible, closing streaming connection"), (v = this.streamingConnection) === null || v === void 0 || v.close();
        }, i));
      else return;
    }, (n = document.addEventListener) === null || n === void 0 || n.call(document, "visibilitychange", this.pageVisibilityHandler);
  }
  async getConfigCache(e) {
    if (this.options.disableConfigCache) {
      this.logger.info("Skipping config cache");
      return;
    }
    const r = await this.store.loadConfig(e);
    r && (this.config = r, this.isConfigCached = !0, this.eventEmitter.emitFeatureUpdates({}, r.features), this.eventEmitter.emitVariableUpdates({}, r.variables, this.variableDefaultMap), this.logger.debug("Initialized with a cached config"));
  }
}
const Gs = (t, e, r, n = !1) => {
  var i, a, o;
  return !((o = (a = (i = e?.project) === null || i === void 0 ? void 0 : i.settings) === null || a === void 0 ? void 0 : a.edgeDB) === null || o === void 0) && o.enabled ? !!r : (r && n && t.warn("EdgeDB is not enabled for this project. Only using local user data."), !1);
}, Bs = (t, e = {}) => {
  let r;
  if (t && "deferInitialization" in t) {
    if (t.deferInitialization)
      return {
        user: void 0,
        options: t,
        isDeferred: !0
      };
  } else
    r = t;
  if (!r)
    throw new Error("Missing user! Call initialize with a valid user");
  return { user: r, options: e, isDeferred: !1 };
};
function Ji(t, e, r = {}) {
  if (!t)
    throw new mt("Missing SDK key! Call initialize with a valid SDK key");
  if (!t.startsWith("client") && !t.startsWith("dvc_client") && !r?.next)
    throw new mt("Invalid SDK key provided. Please call initialize with a valid client SDK key");
  const n = Bs(e, r), { options: i } = n, a = $i();
  if (typeof window < "u" && !window.addEventListener && !a && !i?.reactNative)
    throw new Error("Window is not defined, try initializing in a browser context. If running on React Native, initialize with the option reactNative: true");
  if (i?.reactNative && !globalThis.DeviceInfo)
    throw new Error("DeviceInfo is not defined. Import react-native-device-info and set global.DeviceInfo when running on React Native");
  if (!i || i === null)
    throw new Error("Invalid options! Call initialize with valid options");
  let o;
  return n.isDeferred ? o = new ei(t, void 0, n.options) : o = new ei(t, n.user, n.options), o.onClientInitialized().then(() => o.logger.info("Successfully initialized DevCycle!")).catch((u) => o.logger.error(`Error initializing DevCycle: ${u}`)), o;
}
const $s = Ji, zs = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  DVCPopulatedUser: We,
  StoreKey: _e,
  UserError: mt,
  dvcDefaultLogger: Ki,
  initialize: $s,
  initializeDevCycle: Ji
}, Symbol.toStringTag, { value: "Module" })), qs = /* @__PURE__ */ Oa(zs);
var ti;
function Ys() {
  if (ti) return bt;
  ti = 1, Object.defineProperty(bt, "__esModule", { value: !0 });
  const t = /* @__PURE__ */ Ra(), e = qs;
  let r = class {
    get devcycleClient() {
      return this._devcycleClient;
    }
    constructor(i, a = {}) {
      this.metadata = {
        name: "devcycle-web-provider"
      }, this.runsOn = "client", this.events = new t.OpenFeatureEventEmitter(), this._devcycleClient = null, this.sdkKey = i, a.sdkPlatform ? a.sdkPlatform.toLowerCase().endsWith("-of") || (a.sdkPlatform = `${a.sdkPlatform}-of`) : a.sdkPlatform = "js-of", this.options = a;
    }
    async initialize(i) {
      this._devcycleClient = await (0, e.initializeDevCycle)(this.sdkKey, i ? this.dvcUserFromContext(i) : {}, this.options).onClientInitialized(), this._devcycleClient.eventEmitter.subscribe("configUpdated", (a) => {
        this.events.emit(t.ProviderEvents.ConfigurationChanged, a);
      }), this._devcycleClient.eventEmitter.subscribe("error", (a) => {
        this.events.emit(t.ProviderEvents.Error, a);
      }), i || this._devcycleClient.logger.warn("DevCycle initialized without context being set. It is highly recommended to set a context `OpenFeature.setContext()` before setting an OpenFeature Provider `OpenFeature.setProvider()` to avoid multiple API fetch calls.");
    }
    get status() {
      var i;
      return !((i = this._devcycleClient) === null || i === void 0) && i.isInitialized ? t.ProviderStatus.READY : t.ProviderStatus.NOT_READY;
    }
    async onClose() {
      var i;
      await ((i = this._devcycleClient) === null || i === void 0 ? void 0 : i.close());
    }
    async onContextChange(i, a) {
      var o;
      await ((o = this._devcycleClient) === null || o === void 0 ? void 0 : o.identifyUser(this.dvcUserFromContext(a)));
    }
    track(i, a, o) {
      var u;
      (u = this._devcycleClient) === null || u === void 0 || u.track({
        type: i,
        value: o?.value,
        metaData: o && {
          ...o,
          value: void 0
        }
      });
    }
    /**
     * Generic function to retrieve a DVC variable and convert it to a ResolutionDetails.
     * @param flagKey
     * @param dvcDefaultValue
     * @param ofDefaultValue
     * @private
     */
    getDVCVariable(i, a, o) {
      var u;
      const v = (u = this._devcycleClient) === null || u === void 0 ? void 0 : u.variable(i, a);
      return this.resultFromDVCVariable(v, o);
    }
    /**
     * Resolve a boolean OpenFeature flag and its evaluation details.
     * @param flagKey
     * @param defaultValue
     */
    resolveBooleanEvaluation(i, a) {
      return this.getDVCVariable(i, a, a);
    }
    /**
     * Resolve a string OpenFeature flag and its evaluation details.
     * @param flagKey
     * @param defaultValue
     */
    resolveStringEvaluation(i, a) {
      return this.getDVCVariable(i, a, a);
    }
    /**
     * Resolve a number OpenFeature flag and its evaluation details.
     * @param flagKey
     * @param defaultValue
     */
    resolveNumberEvaluation(i, a) {
      return this.getDVCVariable(i, a, a);
    }
    /**
     * Resolve an object OpenFeature flag and its evaluation details.
     * @param flagKey
     * @param defaultValue
     */
    resolveObjectEvaluation(i, a) {
      return this.getDVCVariable(i, this.defaultValueFromJsonValue(a), a);
    }
    /**
     * Convert a OpenFeature JsonValue default value into DVCJSON default value for evaluation.
     * @param jsonValue
     * @private
     */
    defaultValueFromJsonValue(i) {
      if (typeof i != "object" || Array.isArray(i))
        throw new t.ParseError("DevCycle only supports object values for JSON flags");
      if (!i)
        throw new t.ParseError("DevCycle does not support null default values for JSON flags");
      return i;
    }
    /**
     * Convert a DVCVariable result into a OpenFeature ResolutionDetails.
     * TODO: add support for variant / reason / and more error codes from DVC.
     * @param variable
     * @param ofDefaultValue
     * @private
     */
    resultFromDVCVariable(i, a) {
      var o, u;
      return i ? {
        value: i.value,
        reason: i.isDefaulted ? t.StandardResolutionReasons.DEFAULT : (u = (o = i.eval) === null || o === void 0 ? void 0 : o.reason) !== null && u !== void 0 ? u : t.StandardResolutionReasons.TARGETING_MATCH
      } : {
        value: a,
        reason: t.StandardResolutionReasons.DEFAULT
      };
    }
    /**
     * Convert an OpenFeature EvaluationContext into a DevCycleUser.
     * @param context
     * @private
     */
    dvcUserFromContext(i) {
      var a, o, u, v, E, b;
      const P = [i.targetingKey, i.user_id, i.userId].filter((_) => typeof _ == "string" && _ !== "").shift() || null, d = {};
      let w = {}, m = {};
      P && typeof P == "string" && (d.user_id = P);
      for (const [_, S] of Object.entries(i))
        _ === "targetingKey" || _ === "user_id" || _ === "userId" || (_ === "email" || _ === "name" || _ === "language" || _ === "country" || _ === "appVersion" ? typeof S == "string" ? d[_] = S : (a = this._devcycleClient) === null || a === void 0 || a.logger.warn(`Expected DevCycleUser property "${_}" to be "string" but got "${typeof S}" in EvaluationContext. Ignoring value.`) : _ === "appBuild" ? typeof S == "number" ? d[_] = S : (o = this._devcycleClient) === null || o === void 0 || o.logger.warn(`Expected DevCycleUser property "${_}" to be "number" but got "${typeof S}" in EvaluationContext. Ignoring value.`) : _ === "isAnonymous" ? typeof S == "boolean" ? d[_] = S : (u = this._devcycleClient) === null || u === void 0 || u.logger.warn(`Expected isAnonymous to be boolean but got "${typeof S}" in EvaluationContext. Ignoring value.`) : _ === "privateCustomData" ? typeof S == "object" && S !== null && !Array.isArray(S) ? m = this.convertToDVCCustomDataJSON(S) : (v = this._devcycleClient) === null || v === void 0 || v.logger.warn(`Expected DevCycleUser property "privateCustomData" to be "object" but got "${typeof S}" in EvaluationContext. Ignoring value.`) : _ === "customData" ? typeof S == "object" && S !== null && !Array.isArray(S) ? w = {
          ...w,
          ...this.convertToDVCCustomDataJSON(S)
        } : (E = this._devcycleClient) === null || E === void 0 || E.logger.warn(`Expected DevCycleUser property "customData" to be "object" but got "${typeof S}" in EvaluationContext. Ignoring value.`) : this.isFlatJsonValue(S) ? w[_] = S : (b = this._devcycleClient) === null || b === void 0 || b.logger.warn(`Unknown EvaluationContext property "${_}" type. DevCycleUser only supports flat customData properties of type string / number / boolean / null`));
      return !P && typeof i.isAnonymous != "boolean" && (d.isAnonymous = !0), {
        ...d,
        customData: Object.keys(w).length ? w : void 0,
        privateCustomData: Object.keys(m).length ? m : void 0
      };
    }
    /**
     * Convert customData from an OpenFeature EvaluationContextObject into a DevCycleUser customData.
     * @param evaluationData
     * @private
     */
    convertToDVCCustomDataJSON(i) {
      var a;
      const o = {};
      for (const [u, v] of Object.entries(i))
        switch (typeof v) {
          case "string":
            o[u] = v;
            break;
          case "number":
            o[u] = v;
            break;
          case "boolean":
            o[u] = v;
            break;
          case "undefined":
            o[u] = null;
            break;
          default:
            (a = this._devcycleClient) === null || a === void 0 || a.logger.warn(`EvaluationContext property "customData" contains "${u}" property of type ${typeof v}.DevCycleUser only supports flat customData properties of type string / number / boolean / null`);
            break;
        }
      return o;
    }
    /**
     * Check if a value is a flat JSON value supported by DevCycle.
     * @param value
     * @private
     */
    isFlatJsonValue(i) {
      return typeof i == "string" || typeof i == "number" || typeof i == "boolean" || i === null;
    }
  };
  return bt.default = r, bt;
}
var ri;
function Ws() {
  if (ri) return tt;
  ri = 1;
  var t = tt && tt.__importDefault || function(r) {
    return r && r.__esModule ? r : { default: r };
  };
  Object.defineProperty(tt, "__esModule", { value: !0 });
  const e = t(Ys());
  return tt.default = e.default, tt;
}
var ni;
function Ks() {
  if (ni) return et;
  ni = 1;
  var t = et && et.__importDefault || function(n) {
    return n && n.__esModule ? n : { default: n };
  };
  Object.defineProperty(et, "__esModule", { value: !0 });
  const e = t(Ws());
  class r extends e.default {
    constructor(i, a = {}) {
      a.sdkPlatform = "react-of", super(i, a);
    }
  }
  return et.default = r, et;
}
var Js = Ks();
const Qs = /* @__PURE__ */ Pe(Js);
var Xs = Object.defineProperty, Zs = Object.defineProperties, el = Object.getOwnPropertyDescriptors, ii = Object.getOwnPropertySymbols, tl = Object.prototype.hasOwnProperty, rl = Object.prototype.propertyIsEnumerable, ai = (t, e, r) => e in t ? Xs(t, e, { enumerable: !0, configurable: !0, writable: !0, value: r }) : t[e] = r, yr = (t, e) => {
  for (var r in e || (e = {}))
    tl.call(e, r) && ai(t, r, e[r]);
  if (ii)
    for (var r of ii(e))
      rl.call(e, r) && ai(t, r, e[r]);
  return t;
}, _r = (t, e) => Zs(t, el(e)), it = (t, e, r) => new Promise((n, i) => {
  var a = (v) => {
    try {
      u(r.next(v));
    } catch (E) {
      i(E);
    }
  }, o = (v) => {
    try {
      u(r.throw(v));
    } catch (E) {
      i(E);
    }
  }, u = (v) => v.done ? n(v.value) : Promise.resolve(v.value).then(a, o);
  u((r = r.apply(t, e)).next());
}), nl = class {
  constructor() {
    this.data = /* @__PURE__ */ new Map();
  }
  set(t, e) {
    this.data.set(t, e);
  }
  get(t) {
    return this.data.get(t);
  }
  has(t) {
    return this.data.has(t);
  }
  delete(t) {
    return this.data.delete(t);
  }
  clear() {
    this.data.clear();
  }
}, il = {
  /**
   * The resolved value was the result of an error.
   *
   * Note: The `errorCode` and `errorMessage` fields may contain additional details of this error.
   */
  ERROR: "ERROR"
}, Qi = /* @__PURE__ */ ((t) => (t.PROVIDER_NOT_READY = "PROVIDER_NOT_READY", t.PROVIDER_FATAL = "PROVIDER_FATAL", t.FLAG_NOT_FOUND = "FLAG_NOT_FOUND", t.PARSE_ERROR = "PARSE_ERROR", t.TYPE_MISMATCH = "TYPE_MISMATCH", t.TARGETING_KEY_MISSING = "TARGETING_KEY_MISSING", t.INVALID_CONTEXT = "INVALID_CONTEXT", t.GENERAL = "GENERAL", t))(Qi || {}), Je = class Xi extends Error {
  constructor(e, r) {
    super(e), Object.setPrototypeOf(this, Xi.prototype), this.name = "OpenFeatureError", this.cause = r?.cause;
  }
}, al = class Zi extends Je {
  constructor(e, r) {
    super(e, r), Object.setPrototypeOf(this, Zi.prototype), this.name = "FlagNotFoundError", this.code = "FLAG_NOT_FOUND";
  }
}, ea = class ta extends Je {
  constructor(e, r) {
    super(e, r), Object.setPrototypeOf(this, ta.prototype), this.name = "GeneralError", this.code = "GENERAL";
  }
}, ol = class ra extends Je {
  constructor(e, r) {
    super(e, r), Object.setPrototypeOf(this, ra.prototype), this.name = "InvalidContextError", this.code = "INVALID_CONTEXT";
  }
}, sl = class na extends Je {
  constructor(e, r) {
    super(e, r), Object.setPrototypeOf(this, na.prototype), this.name = "ParseError", this.code = "PARSE_ERROR";
  }
}, ia = class aa extends Je {
  constructor(e, r) {
    super(e, r), Object.setPrototypeOf(this, aa.prototype), this.name = "ProviderFatalError", this.code = "PROVIDER_FATAL";
  }
}, oa = class sa extends Je {
  constructor(e, r) {
    super(e, r), Object.setPrototypeOf(this, sa.prototype), this.name = "ProviderNotReadyError", this.code = "PROVIDER_NOT_READY";
  }
}, ll = class la extends Je {
  constructor(e, r) {
    super(e, r), Object.setPrototypeOf(this, la.prototype), this.name = "TargetingKeyMissingError", this.code = "TARGETING_KEY_MISSING";
  }
}, ul = class ua extends Je {
  constructor(e, r) {
    super(e, r), Object.setPrototypeOf(this, ua.prototype), this.name = "TypeMismatchError", this.code = "TYPE_MISMATCH";
  }
}, cl = (t, e) => {
  switch (t) {
    case "FLAG_NOT_FOUND":
      return new al(e);
    case "PARSE_ERROR":
      return new sl(e);
    case "TYPE_MISMATCH":
      return new ul(e);
    case "TARGETING_KEY_MISSING":
      return new ll(e);
    case "INVALID_CONTEXT":
      return new ol(e);
    case "PROVIDER_NOT_READY":
      return new oa(e);
    case "PROVIDER_FATAL":
      return new ia(e);
    default:
      return new ea(e);
  }
}, Xe = /* @__PURE__ */ ((t) => (t.NOT_READY = "NOT_READY", t.READY = "READY", t.ERROR = "ERROR", t.STALE = "STALE", t.FATAL = "FATAL", t.RECONCILING = "RECONCILING", t))(Xe || {}), ie = /* @__PURE__ */ ((t) => (t.Ready = "PROVIDER_READY", t.Error = "PROVIDER_ERROR", t.ConfigurationChanged = "PROVIDER_CONFIGURATION_CHANGED", t.ContextChanged = "PROVIDER_CONTEXT_CHANGED", t.Reconciling = "PROVIDER_RECONCILING", t.Stale = "PROVIDER_STALE", t))(ie || {}), dl = {
  READY: "PROVIDER_READY",
  ERROR: "PROVIDER_ERROR",
  FATAL: "PROVIDER_ERROR",
  STALE: "PROVIDER_STALE",
  RECONCILING: "PROVIDER_RECONCILING",
  NOT_READY: void 0
}, ca = (t, e) => !e && t === "PROVIDER_READY" || dl[e] === t, da = class {
  error(...t) {
    console.error(...t);
  }
  warn(...t) {
    console.warn(...t);
  }
  info() {
  }
  debug() {
  }
}, hl = ["error", "warn", "info", "debug"], Hr = class {
  constructor(t) {
    this.fallbackLogger = new da();
    try {
      for (const e of hl)
        if (!t[e] || typeof t[e] != "function")
          throw new Error(`The provided logger is missing the ${e} method.`);
      this.logger = t;
    } catch (e) {
      console.error(e), console.error("Falling back to the default logger."), this.logger = this.fallbackLogger;
    }
  }
  error(...t) {
    this.log("error", ...t);
  }
  warn(...t) {
    this.log("warn", ...t);
  }
  info(...t) {
    this.log("info", ...t);
  }
  debug(...t) {
    this.log("debug", ...t);
  }
  log(t, ...e) {
    try {
      this.logger[t](...e);
    } catch {
      this.fallbackLogger[t](...e);
    }
  }
}, fl = class {
  constructor(t) {
    this.globalLogger = t, this._handlers = {
      PROVIDER_CONFIGURATION_CHANGED: /* @__PURE__ */ new WeakMap(),
      PROVIDER_CONTEXT_CHANGED: /* @__PURE__ */ new WeakMap(),
      PROVIDER_READY: /* @__PURE__ */ new WeakMap(),
      PROVIDER_ERROR: /* @__PURE__ */ new WeakMap(),
      PROVIDER_STALE: /* @__PURE__ */ new WeakMap(),
      PROVIDER_RECONCILING: /* @__PURE__ */ new WeakMap()
    };
  }
  // here we use E, to restrict the events a provider can manually emit (PROVIDER_CONTEXT_CHANGED is emitted by the SDK)
  emit(t, e) {
    this.eventEmitter.emit(t, e);
  }
  addHandler(t, e) {
    const r = (i) => it(this, null, function* () {
      var a;
      try {
        yield e(i);
      } catch (o) {
        (a = this._logger) == null || a.error("Error running event handler:", o);
      }
    }), n = this._handlers[t].get(e);
    this._handlers[t].set(e, [...n || [], r]), this.eventEmitter.on(t, r);
  }
  removeHandler(t, e) {
    const r = this._handlers[t].get(e);
    if (r) {
      const n = r.pop();
      n && this.eventEmitter.removeListener(t, n);
    }
  }
  removeAllHandlers(t) {
    t ? this.eventEmitter.removeAllListeners(t) : this.eventEmitter.removeAllListeners();
  }
  getHandlers(t) {
    return this.eventEmitter.listeners(t);
  }
  setLogger(t) {
    return this._eventLogger = new Hr(t), this;
  }
  get _logger() {
    var t, e;
    return (e = this._eventLogger) != null ? e : (t = this.globalLogger) == null ? void 0 : t.call(this);
  }
};
function vl(t) {
  return typeof t == "string";
}
function at(t) {
  return vl(t) ? t : void 0;
}
function gl(t) {
  return typeof t == "object";
}
function Re(t) {
  return gl(t) ? t : void 0;
}
function oi(t) {
  return typeof t < "u" && t !== null;
}
var Ir = class {
  constructor(t, e, r) {
    this._provider = t, this._status = e, this._pendingContextChanges = 0;
    var n, i, a;
    (n = t.events) == null || n.addHandler("PROVIDER_READY", () => {
      this._status = r.READY;
    }), (i = t.events) == null || i.addHandler("PROVIDER_STALE", () => {
      this._status = r.STALE;
    }), (a = t.events) == null || a.addHandler("PROVIDER_ERROR", (o) => {
      o?.errorCode === "PROVIDER_FATAL" ? this._status = r.FATAL : this._status = r.ERROR;
    });
  }
  get provider() {
    return this._provider;
  }
  set provider(t) {
    this._provider = t;
  }
  get status() {
    return this._status;
  }
  set status(t) {
    this._status = t;
  }
  get allContextChangesSettled() {
    return this._pendingContextChanges === 0;
  }
  incrementPendingContextChanges() {
    this._pendingContextChanges++;
  }
  decrementPendingContextChanges() {
    this._pendingContextChanges--;
  }
}, pl = class {
  constructor(t) {
    this._hooks = [], this._context = {}, this._logger = new da(), this._clientEventHandlers = /* @__PURE__ */ new Map(), this._domainScopedContext = /* @__PURE__ */ new Map(), this._clientEvents = /* @__PURE__ */ new Map(), this._runsOn = t;
  }
  addHooks(...t) {
    return this._hooks = [...this._hooks, ...t], this;
  }
  getHooks() {
    return this._hooks;
  }
  clearHooks() {
    return this._hooks = [], this;
  }
  setLogger(t) {
    return this._logger = new Hr(t), this;
  }
  /**
   * Get metadata about the default provider.
   * @returns {ProviderMetadata} Provider Metadata
   */
  get providerMetadata() {
    return this.getProviderMetadata();
  }
  /**
   * Get metadata about a registered provider using the client name.
   * An unbound or empty client name will return metadata from the default provider.
   * @param {string} domain An identifier which logically binds clients with providers
   * @returns {ProviderMetadata} Provider Metadata
   */
  getProviderMetadata(t) {
    return this.getProviderForClient(t).metadata;
  }
  /**
   * Adds a handler for the given provider event type.
   * The handlers are called in the order they have been added.
   * API (global) events run for all providers.
   * @param {AnyProviderEvent} eventType The provider event type to listen to
   * @param {EventHandler} handler The handler to run on occurrence of the event type
   * @param {EventOptions} options Optional options such as signal for aborting
   */
  addHandler(t, e, r) {
    [.../* @__PURE__ */ new Map([[void 0, this._defaultProvider]]), ...this._domainScopedProviders].forEach((n) => {
      var i;
      const a = n[0], o = n[1].provider, u = n[1].status;
      if (ca(t, u))
        try {
          e({ domain: a, providerName: o.metadata.name });
        } catch (E) {
          (i = this._logger) == null || i.error("Error running event handler:", E);
        }
    }), this._apiEmitter.addHandler(t, e), r?.signal && typeof r.signal.addEventListener == "function" && r.signal.addEventListener("abort", () => {
      this.removeHandler(t, e);
    });
  }
  /**
   * Removes a handler for the given provider event type.
   * @param {AnyProviderEvent} eventType The provider event type to remove the listener for
   * @param {EventHandler} handler The handler to remove for the provider event type
   */
  removeHandler(t, e) {
    this._apiEmitter.removeHandler(t, e);
  }
  /**
   * Removes all event handlers.
   */
  clearHandlers() {
    this._apiEmitter.removeAllHandlers();
  }
  /**
   * Gets the current handlers for the given provider event type.
   * @param {AnyProviderEvent} eventType The provider event type to get the current handlers for
   * @returns {EventHandler[]} The handlers currently attached to the given provider event type
   */
  getHandlers(t) {
    return this._apiEmitter.getHandlers(t);
  }
  setAwaitableProvider(t, e) {
    var r, n, i, a, o, u, v, E;
    const b = at(t), P = (r = Re(t)) != null ? r : Re(e);
    if (!P) {
      this._logger.debug("No provider defined, ignoring setProvider call");
      return;
    }
    const d = this.getProviderForClient(b), w = P.metadata.name;
    if (d === P) {
      this._logger.debug("Provider is already set, ignoring setProvider call");
      return;
    }
    if (!P.runsOn)
      this._logger.debug(`Provider '${P.metadata.name}' has not defined its intended use.`);
    else if (P.runsOn !== this._runsOn)
      throw new ea(`Provider '${P.metadata.name}' is intended for use on the ${P.runsOn}.`);
    const m = this.getAssociatedEventEmitters(b);
    let _;
    const S = new Ir(
      P,
      this._statusEnumType.NOT_READY,
      this._statusEnumType
    );
    return typeof P.initialize == "function" && !this.allProviders.includes(P) ? _ = (o = (a = (i = P.initialize) == null ? void 0 : i.call(P, b ? (n = this._domainScopedContext.get(b)) != null ? n : this._context : this._context)) == null ? void 0 : a.then(() => {
      var k;
      S.status = this._statusEnumType.READY, this.getAssociatedEventEmitters(b).forEach((z) => {
        z?.emit("PROVIDER_READY", { clientName: b, domain: b, providerName: w });
      }), (k = this._apiEmitter) == null || k.emit("PROVIDER_READY", { clientName: b, domain: b, providerName: w });
    })) == null ? void 0 : o.catch((k) => {
      var z;
      throw k?.code === "PROVIDER_FATAL" ? S.status = this._statusEnumType.FATAL : S.status = this._statusEnumType.ERROR, this.getAssociatedEventEmitters(b).forEach((j) => {
        j?.emit("PROVIDER_ERROR", {
          clientName: b,
          domain: b,
          providerName: w,
          message: k?.message
        });
      }), (z = this._apiEmitter) == null || z.emit("PROVIDER_ERROR", {
        clientName: b,
        domain: b,
        providerName: w,
        message: k?.message
      }), k;
    }) : (S.status = this._statusEnumType.READY, m.forEach((k) => {
      k?.emit("PROVIDER_READY", { clientName: b, domain: b, providerName: w });
    }), (u = this._apiEmitter) == null || u.emit("PROVIDER_READY", { clientName: b, domain: b, providerName: w })), b ? this._domainScopedProviders.set(b, S) : this._defaultProvider = S, this.transferListeners(d, P, b, m), this.allProviders.includes(d) || (E = (v = d?.onClose) == null ? void 0 : v.call(d)) == null || E.catch((k) => {
      this._logger.error(`error closing provider: ${k?.message}, ${k?.stack}`);
    }), _;
  }
  getProviderForClient(t) {
    var e, r;
    return t ? (r = (e = this._domainScopedProviders.get(t)) == null ? void 0 : e.provider) != null ? r : this._defaultProvider.provider : this._defaultProvider.provider;
  }
  buildAndCacheEventEmitterForClient(t) {
    const e = this._clientEvents.get(t);
    if (e)
      return e;
    const r = this._createEventEmitter();
    this._clientEvents.set(t, r);
    const n = this.getProviderForClient(t);
    return Object.values(ie).forEach(
      (i) => {
        var a;
        return (a = n.events) == null ? void 0 : a.addHandler(i, (o) => it(this, null, function* () {
          r.emit(i, _r(yr({}, o), {
            clientName: t,
            domain: t,
            providerName: n.metadata.name
          }));
        }));
      }
    ), r;
  }
  getUnboundEmitters() {
    const t = [...this._domainScopedProviders.keys()];
    return [
      // all unbound, named emitters
      ...[...this._clientEvents.keys()].filter(oi).filter((n) => !t.includes(n)).map((n) => this._clientEvents.get(n)),
      // the default emitter
      this._clientEvents.get(void 0)
    ].filter(oi);
  }
  getAssociatedEventEmitters(t) {
    return t ? [this.buildAndCacheEventEmitterForClient(t)] : this.getUnboundEmitters();
  }
  transferListeners(t, e, r, n) {
    var i;
    (i = this._clientEventHandlers.get(r)) == null || i.forEach((o) => {
      var u;
      return (u = t.events) == null ? void 0 : u.removeHandler(...o);
    });
    const a = Object.values(ie).map((o) => [o, (v) => it(this, null, function* () {
      n.forEach((E) => {
        E?.emit(o, _r(yr({}, v), { clientName: r, domain: r, providerName: e.metadata.name }));
      }), this._apiEmitter.emit(o, _r(yr({}, v), {
        clientName: r,
        domain: r,
        providerName: e.metadata.name
      }));
    })]);
    this._clientEventHandlers.set(r, a), a.forEach((o) => {
      var u;
      return (u = e.events) == null ? void 0 : u.addHandler(...o);
    });
  }
  close() {
    return it(this, null, function* () {
      var t, e;
      try {
        yield (e = (t = this == null ? void 0 : this._defaultProvider.provider) == null ? void 0 : t.onClose) == null ? void 0 : e.call(t);
      } catch (n) {
        this.handleShutdownError(this._defaultProvider.provider, n);
      }
      const r = Array.from(this._domainScopedProviders);
      yield Promise.all(
        r.map((n) => it(this, [n], function* ([, i]) {
          var a, o;
          try {
            yield (o = i == null ? void 0 : (a = i.provider).onClose) == null ? void 0 : o.call(a);
          } catch (u) {
            this.handleShutdownError(i?.provider, u);
          }
        }))
      );
    });
  }
  clearProvidersAndSetDefault(t) {
    return it(this, null, function* () {
      try {
        yield this.close();
      } catch {
        this._logger.error("Unable to cleanly close providers. Resetting to the default configuration.");
      } finally {
        this._domainScopedProviders.clear(), this._defaultProvider = new Ir(
          t,
          this._statusEnumType.NOT_READY,
          this._statusEnumType
        );
      }
    });
  }
  get allProviders() {
    return [
      ...[...this._domainScopedProviders.values()].map((t) => t.provider),
      this._defaultProvider.provider
    ];
  }
  handleShutdownError(t, e) {
    this._logger.error(`Error during shutdown of provider ${t.metadata.name}: ${e}`), this._logger.error(e?.stack);
  }
}, ml = Object.create, Gr = Object.defineProperty, yl = Object.defineProperties, _l = Object.getOwnPropertyDescriptor, El = Object.getOwnPropertyDescriptors, ha = Object.getOwnPropertyNames, si = Object.getOwnPropertySymbols, fa = Object.getPrototypeOf, va = Object.prototype.hasOwnProperty, bl = Object.prototype.propertyIsEnumerable, wl = Reflect.get, li = (t, e, r) => e in t ? Gr(t, e, { enumerable: !0, configurable: !0, writable: !0, value: r }) : t[e] = r, Er = (t, e) => {
  for (var r in e || (e = {}))
    va.call(e, r) && li(t, r, e[r]);
  if (si)
    for (var r of si(e))
      bl.call(e, r) && li(t, r, e[r]);
  return t;
}, Ol = (t, e) => yl(t, El(e)), Rl = (t, e) => function() {
  return e || (0, t[ha(t)[0]])((e = { exports: {} }).exports, e), e.exports;
}, Cl = (t, e, r, n) => {
  if (e && typeof e == "object" || typeof e == "function")
    for (let i of ha(e))
      !va.call(t, i) && i !== r && Gr(t, i, { get: () => e[i], enumerable: !(n = _l(e, i)) || n.enumerable });
  return t;
}, Nl = (t, e, r) => (r = t != null ? ml(fa(t)) : {}, Cl(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  Gr(r, "default", { value: t, enumerable: !0 }),
  t
)), Sl = (t, e, r) => wl(fa(t), r, e), nt = (t, e, r) => new Promise((n, i) => {
  var a = (v) => {
    try {
      u(r.next(v));
    } catch (E) {
      i(E);
    }
  }, o = (v) => {
    try {
      u(r.throw(v));
    } catch (E) {
      i(E);
    }
  }, u = (v) => v.done ? n(v.value) : Promise.resolve(v.value).then(a, o);
  u((r = r.apply(t, e)).next());
}), Al = Rl({
  "../../node_modules/eventemitter3/index.js"(t, e) {
    var r = Object.prototype.hasOwnProperty, n = "~";
    function i() {
    }
    Object.create && (i.prototype = /* @__PURE__ */ Object.create(null), new i().__proto__ || (n = !1));
    function a(E, b, P) {
      this.fn = E, this.context = b, this.once = P || !1;
    }
    function o(E, b, P, d, w) {
      if (typeof P != "function")
        throw new TypeError("The listener must be a function");
      var m = new a(P, d || E, w), _ = n ? n + b : b;
      return E._events[_] ? E._events[_].fn ? E._events[_] = [E._events[_], m] : E._events[_].push(m) : (E._events[_] = m, E._eventsCount++), E;
    }
    function u(E, b) {
      --E._eventsCount === 0 ? E._events = new i() : delete E._events[b];
    }
    function v() {
      this._events = new i(), this._eventsCount = 0;
    }
    v.prototype.eventNames = function() {
      var b = [], P, d;
      if (this._eventsCount === 0) return b;
      for (d in P = this._events)
        r.call(P, d) && b.push(n ? d.slice(1) : d);
      return Object.getOwnPropertySymbols ? b.concat(Object.getOwnPropertySymbols(P)) : b;
    }, v.prototype.listeners = function(b) {
      var P = n ? n + b : b, d = this._events[P];
      if (!d) return [];
      if (d.fn) return [d.fn];
      for (var w = 0, m = d.length, _ = new Array(m); w < m; w++)
        _[w] = d[w].fn;
      return _;
    }, v.prototype.listenerCount = function(b) {
      var P = n ? n + b : b, d = this._events[P];
      return d ? d.fn ? 1 : d.length : 0;
    }, v.prototype.emit = function(b, P, d, w, m, _) {
      var S = n ? n + b : b;
      if (!this._events[S]) return !1;
      var k = this._events[S], z = arguments.length, j, x;
      if (k.fn) {
        switch (k.once && this.removeListener(b, k.fn, void 0, !0), z) {
          case 1:
            return k.fn.call(k.context), !0;
          case 2:
            return k.fn.call(k.context, P), !0;
          case 3:
            return k.fn.call(k.context, P, d), !0;
          case 4:
            return k.fn.call(k.context, P, d, w), !0;
          case 5:
            return k.fn.call(k.context, P, d, w, m), !0;
          case 6:
            return k.fn.call(k.context, P, d, w, m, _), !0;
        }
        for (x = 1, j = new Array(z - 1); x < z; x++)
          j[x - 1] = arguments[x];
        k.fn.apply(k.context, j);
      } else {
        var B = k.length, Y;
        for (x = 0; x < B; x++)
          switch (k[x].once && this.removeListener(b, k[x].fn, void 0, !0), z) {
            case 1:
              k[x].fn.call(k[x].context);
              break;
            case 2:
              k[x].fn.call(k[x].context, P);
              break;
            case 3:
              k[x].fn.call(k[x].context, P, d);
              break;
            case 4:
              k[x].fn.call(k[x].context, P, d, w);
              break;
            default:
              if (!j) for (Y = 1, j = new Array(z - 1); Y < z; Y++)
                j[Y - 1] = arguments[Y];
              k[x].fn.apply(k[x].context, j);
          }
      }
      return !0;
    }, v.prototype.on = function(b, P, d) {
      return o(this, b, P, d, !1);
    }, v.prototype.once = function(b, P, d) {
      return o(this, b, P, d, !0);
    }, v.prototype.removeListener = function(b, P, d, w) {
      var m = n ? n + b : b;
      if (!this._events[m]) return this;
      if (!P)
        return u(this, m), this;
      var _ = this._events[m];
      if (_.fn)
        _.fn === P && (!w || _.once) && (!d || _.context === d) && u(this, m);
      else {
        for (var S = 0, k = [], z = _.length; S < z; S++)
          (_[S].fn !== P || w && !_[S].once || d && _[S].context !== d) && k.push(_[S]);
        k.length ? this._events[m] = k.length === 1 ? k[0] : k : u(this, m);
      }
      return this;
    }, v.prototype.removeAllListeners = function(b) {
      var P;
      return b ? (P = n ? n + b : b, this._events[P] && u(this, P)) : (this._events = new i(), this._eventsCount = 0), this;
    }, v.prototype.off = v.prototype.removeListener, v.prototype.addListener = v.prototype.on, v.prefixed = n, v.EventEmitter = v, typeof e < "u" && (e.exports = v);
  }
}), Il = "No-op", Pl = class {
  constructor() {
    this.metadata = {
      name: "No-op Provider"
    };
  }
  resolveBooleanEvaluation(t, e) {
    return this.noOp(e);
  }
  resolveStringEvaluation(t, e) {
    return this.noOp(e);
  }
  resolveNumberEvaluation(t, e) {
    return this.noOp(e);
  }
  resolveObjectEvaluation(t, e) {
    return this.noOp(e);
  }
  noOp(t) {
    return {
      value: t,
      reason: Il
    };
  }
}, Pr = new Pl(), xl = Nl(Al()), ui = class extends fl {
  constructor() {
    super(), this.eventEmitter = new xl.default();
  }
}, Tl = class {
  constructor(t, e, r, n, i, a, o) {
    this.providerAccessor = t, this.providerStatusAccessor = e, this.emitterAccessor = r, this.apiContextAccessor = n, this.apiHooksAccessor = i, this.globalLogger = a, this.options = o, this._hooks = [];
  }
  get metadata() {
    var t, e;
    return {
      // Use domain if name is not provided
      name: (t = this.options.domain) != null ? t : this.options.name,
      domain: (e = this.options.domain) != null ? e : this.options.name,
      version: this.options.version,
      providerMetadata: this.providerAccessor().metadata
    };
  }
  get providerStatus() {
    return this.providerStatusAccessor();
  }
  addHandler(t, e, r) {
    var n;
    if (this.emitterAccessor().addHandler(t, e), ca(t, this.providerStatus))
      try {
        e({
          clientName: this.metadata.name,
          domain: this.metadata.domain,
          providerName: this._provider.metadata.name
        });
      } catch (a) {
        (n = this._logger) == null || n.error("Error running event handler:", a);
      }
    r?.signal && typeof r.signal.addEventListener == "function" && r.signal.addEventListener("abort", () => {
      this.removeHandler(t, e);
    });
  }
  removeHandler(t, e) {
    this.emitterAccessor().removeHandler(t, e);
  }
  getHandlers(t) {
    return this.emitterAccessor().getHandlers(t);
  }
  setLogger(t) {
    return this._clientLogger = new Hr(t), this;
  }
  addHooks(...t) {
    return this._hooks = [...this._hooks, ...t], this;
  }
  getHooks() {
    return this._hooks;
  }
  clearHooks() {
    return this._hooks = [], this;
  }
  getBooleanValue(t, e, r) {
    return this.getBooleanDetails(t, e, r).value;
  }
  getBooleanDetails(t, e, r) {
    return this.evaluate(t, this._provider.resolveBooleanEvaluation, e, "boolean", r);
  }
  getStringValue(t, e, r) {
    return this.getStringDetails(t, e, r).value;
  }
  getStringDetails(t, e, r) {
    return this.evaluate(
      t,
      // this isolates providers from our restricted string generic argument.
      this._provider.resolveStringEvaluation,
      e,
      "string",
      r
    );
  }
  getNumberValue(t, e, r) {
    return this.getNumberDetails(t, e, r).value;
  }
  getNumberDetails(t, e, r) {
    return this.evaluate(
      t,
      // this isolates providers from our restricted number generic argument.
      this._provider.resolveNumberEvaluation,
      e,
      "number",
      r
    );
  }
  getObjectValue(t, e, r) {
    return this.getObjectDetails(t, e, r).value;
  }
  getObjectDetails(t, e, r) {
    return this.evaluate(t, this._provider.resolveObjectEvaluation, e, "object", r);
  }
  track(t, e = {}) {
    var r, n, i;
    try {
      if (this.shortCircuitIfNotReady(), typeof this._provider.track == "function") {
        const a = Object.freeze(Er({}, this.apiContextAccessor((r = this == null ? void 0 : this.options) == null ? void 0 : r.domain)));
        return (i = (n = this._provider).track) == null ? void 0 : i.call(n, t, a, e);
      } else
        this._logger.debug("Provider does not support the track function; will no-op.");
    } catch (a) {
      this._logger.debug("Error recording tracking event.", a);
    }
  }
  evaluate(t, e, r, n, i = {}) {
    var a, o;
    const u = [
      ...this.apiHooksAccessor(),
      ...this.getHooks(),
      ...i.hooks || [],
      ...this._provider.hooks || []
    ], v = [...u].reverse(), E = Er({}, this.apiContextAccessor((a = this == null ? void 0 : this.options) == null ? void 0 : a.domain)), b = v.map(
      () => Object.freeze({
        flagKey: t,
        defaultValue: r,
        flagValueType: n,
        clientMetadata: this.metadata,
        providerMetadata: this._provider.metadata,
        context: E,
        logger: this._logger,
        hookData: new nl()
      })
    );
    let P;
    try {
      this.beforeHooks(u, b, i), this.shortCircuitIfNotReady();
      const d = e.call(this._provider, t, r, E, this._logger), w = Ol(Er({}, d), {
        flagMetadata: Object.freeze((o = d.flagMetadata) != null ? o : {}),
        flagKey: t
      });
      if (w.errorCode) {
        const m = cl(w.errorCode, w.errorMessage);
        this.errorHooks(v, b, m, i), P = this.getErrorEvaluationDetails(t, r, m, w.flagMetadata);
      } else
        this.afterHooks(v, b, w, i), P = w;
    } catch (d) {
      this.errorHooks(v, b, d, i), P = this.getErrorEvaluationDetails(t, r, d);
    }
    return this.finallyHooks(v, b, P, i), P;
  }
  beforeHooks(t, e, r) {
    var n;
    for (const [i, a] of t.entries()) {
      const o = t.length - 1 - i, u = e[o];
      Object.freeze(u), Object.freeze(u.context), (n = a?.before) == null || n.call(a, u, Object.freeze(r.hookHints));
    }
  }
  afterHooks(t, e, r, n) {
    var i;
    for (const [a, o] of t.entries()) {
      const u = e[a];
      (i = o?.after) == null || i.call(o, u, r, n.hookHints);
    }
  }
  errorHooks(t, e, r, n) {
    var i;
    for (const [a, o] of t.entries())
      try {
        const u = e[a];
        (i = o?.error) == null || i.call(o, u, r, n.hookHints);
      } catch (u) {
        this._logger.error(`Unhandled error during 'error' hook: ${u}`), u instanceof Error && this._logger.error(u.stack), this._logger.error(u?.stack);
      }
  }
  finallyHooks(t, e, r, n) {
    var i;
    for (const [a, o] of t.entries())
      try {
        const u = e[a];
        (i = o?.finally) == null || i.call(o, u, r, n.hookHints);
      } catch (u) {
        this._logger.error(`Unhandled error during 'finally' hook: ${u}`), u instanceof Error && this._logger.error(u.stack), this._logger.error(u?.stack);
      }
  }
  get _provider() {
    return this.providerAccessor();
  }
  get _logger() {
    return this._clientLogger || this.globalLogger();
  }
  shortCircuitIfNotReady() {
    if (this.providerStatus === Xe.NOT_READY)
      throw new oa("provider has not yet initialized");
    if (this.providerStatus === Xe.FATAL)
      throw new ia("provider is in an irrecoverable error state");
  }
  getErrorEvaluationDetails(t, e, r, n = {}) {
    const i = r?.message;
    return {
      errorCode: r?.code || Qi.GENERAL,
      errorMessage: i,
      value: e,
      reason: il.ERROR,
      flagMetadata: Object.freeze(n),
      flagKey: t
    };
  }
}, ci = /* @__PURE__ */ Symbol.for("@openfeature/web-sdk/api"), di = globalThis, Dl = class xr extends pl {
  constructor() {
    super("client"), this._statusEnumType = Xe, this._apiEmitter = new ui(), this._defaultProvider = new Ir(
      Pr,
      Xe.NOT_READY,
      this._statusEnumType
    ), this._domainScopedProviders = /* @__PURE__ */ new Map(), this._createEventEmitter = () => new ui();
  }
  /**
   * Gets a singleton instance of the OpenFeature API.
   * @ignore
   * @returns {OpenFeatureAPI} OpenFeature API
   */
  static getInstance() {
    const e = di[ci];
    if (e)
      return e;
    const r = new xr();
    return di[ci] = r, r;
  }
  getProviderStatus(e) {
    var r, n;
    return e ? (n = (r = this._domainScopedProviders.get(e)) == null ? void 0 : r.status) != null ? n : this._defaultProvider.status : this._defaultProvider.status;
  }
  setProviderAndWait(e, r, n) {
    return nt(this, null, function* () {
      const i = at(e), a = Re(i ? r : e), o = Re(i ? n : r);
      o && (i ? this._domainScopedContext.set(i, o) : this._context = o), yield this.setAwaitableProvider(i, a);
    });
  }
  setProvider(e, r, n) {
    const i = at(e), a = Re(i ? r : e), o = Re(i ? n : r);
    o && (i ? this._domainScopedContext.set(i, o) : this._context = o);
    const u = this.setAwaitableProvider(i, a);
    return Promise.resolve(u).catch((v) => {
      this._logger.error("Error during provider initialization:", v);
    }), this;
  }
  getProvider(e) {
    return this.getProviderForClient(e);
  }
  setContext(e, r) {
    return nt(this, null, function* () {
      var n, i;
      const a = at(e), o = (i = (n = Re(e)) != null ? n : Re(r)) != null ? i : {};
      if (a) {
        const u = this._domainScopedProviders.get(a);
        if (u) {
          const v = this.getContext(a);
          this._domainScopedContext.set(a, o), yield this.runProviderContextChangeHandler(a, u, v, o);
        } else
          this._domainScopedContext.set(a, o);
      } else {
        const u = this._context;
        this._context = o;
        const v = Array.from(this._domainScopedProviders.entries()).filter(([b]) => !this._domainScopedContext.has(b)).reduce((b, [P, d]) => (b.push({ domain: P, wrapper: d }), b), []), E = [
          // add in the default (no domain)
          { domain: void 0, wrapper: this._defaultProvider },
          ...v
        ];
        yield Promise.all(
          E.map((b) => this.runProviderContextChangeHandler(b.domain, b.wrapper, u, o))
        );
      }
    });
  }
  getContext(e) {
    const r = at(e);
    if (r) {
      const n = this._domainScopedContext.get(r);
      if (n)
        return n;
      this._logger.debug(`Unable to find context for '${r}'.`);
    }
    return this._context;
  }
  clearContext(e) {
    return nt(this, null, function* () {
      const r = at(e);
      if (r) {
        const n = this._domainScopedProviders.get(r);
        if (n) {
          const i = this.getContext(r);
          this._domainScopedContext.delete(r);
          const a = this.getContext();
          yield this.runProviderContextChangeHandler(r, n, i, a);
        } else
          this._domainScopedContext.delete(r);
      } else
        return this.setContext({});
    });
  }
  /**
   * Resets the global evaluation context and removes the evaluation context for
   * all domains.
   */
  clearContexts() {
    return nt(this, null, function* () {
      yield this.clearContext(), yield Promise.allSettled(Array.from(this._domainScopedProviders.keys()).map((e) => this.clearContext(e)));
    });
  }
  /**
   * A factory function for creating new domain-scoped OpenFeature clients. Clients
   * can contain their own state (e.g. logger, hook, context). Multiple domains
   * can be used to segment feature flag configuration.
   *
   * If there is already a provider bound to this name via {@link this.setProvider setProvider}, this provider will be used.
   * Otherwise, the default provider is used until a provider is assigned to that name.
   * @param {string} domain An identifier which logically binds clients with providers
   * @param {string} version The version of the client (only used for metadata)
   * @returns {Client} OpenFeature Client
   */
  getClient(e, r) {
    return new Tl(
      // functions are passed here to make sure that these values are always up to date,
      // and so we don't have to make these public properties on the API class.
      () => this.getProviderForClient(e),
      () => this.getProviderStatus(e),
      () => this.buildAndCacheEventEmitterForClient(e),
      (n) => this.getContext(n),
      () => this.getHooks(),
      () => this._logger,
      { domain: e, version: r }
    );
  }
  /**
   * Clears all registered providers and resets the default provider.
   * @returns {Promise<void>}
   */
  clearProviders() {
    return nt(this, null, function* () {
      yield Sl(xr.prototype, this, "clearProvidersAndSetDefault").call(this, Pr), this._domainScopedContext.clear();
    });
  }
  runProviderContextChangeHandler(e, r, n, i) {
    return nt(this, null, function* () {
      var a, o, u, v, E, b;
      const P = ((o = (a = r.provider) == null ? void 0 : a.metadata) == null ? void 0 : o.name) || "unnamed-provider";
      try {
        if (typeof r.provider.onContextChange == "function") {
          const d = r.provider.onContextChange(n, i);
          d && typeof d?.then == "function" && (r.incrementPendingContextChanges(), r.status = this._statusEnumType.RECONCILING, this.getAssociatedEventEmitters(e).forEach((w) => {
            w?.emit(ie.Reconciling, { domain: e, providerName: P });
          }), (u = this._apiEmitter) == null || u.emit(ie.Reconciling, { domain: e, providerName: P }), yield d, r.decrementPendingContextChanges());
        }
        r.status = this._statusEnumType.READY, r.allContextChangesSettled && (this.getAssociatedEventEmitters(e).forEach((d) => {
          d?.emit(ie.ContextChanged, { clientName: e, domain: e, providerName: P });
        }), (v = this._apiEmitter) == null || v.emit(ie.ContextChanged, { clientName: e, domain: e, providerName: P }));
      } catch (d) {
        if (r.decrementPendingContextChanges(), r.status = this._statusEnumType.ERROR, r.allContextChangesSettled) {
          const w = d, m = `Error running ${P}'s context change handler: ${w?.message}`;
          (E = this._logger) == null || E.error(`${m}`, d), this.getAssociatedEventEmitters(e).forEach((_) => {
            _?.emit(ie.Error, { clientName: e, domain: e, providerName: P, message: m });
          }), (b = this._apiEmitter) == null || b.emit(ie.Error, { clientName: e, domain: e, providerName: P, message: m });
        }
      }
    });
  }
}, Et = Dl.getInstance(), kl = Object.defineProperty, xt = Object.getOwnPropertySymbols, ga = Object.prototype.hasOwnProperty, pa = Object.prototype.propertyIsEnumerable, hi = (t, e, r) => e in t ? kl(t, e, { enumerable: !0, configurable: !0, writable: !0, value: r }) : t[e] = r, Qe = (t, e) => {
  for (var r in e || (e = {}))
    ga.call(e, r) && hi(t, r, e[r]);
  if (xt)
    for (var r of xt(e))
      pa.call(e, r) && hi(t, r, e[r]);
  return t;
}, Ml = (t, e) => {
  var r = {};
  for (var n in t)
    ga.call(t, n) && e.indexOf(n) < 0 && (r[n] = t[n]);
  if (t != null && xt)
    for (var n of xt(t))
      e.indexOf(n) < 0 && pa.call(t, n) && (r[n] = t[n]);
  return r;
}, Ll = (t, e, r) => new Promise((n, i) => {
  var a = (v) => {
    try {
      u(r.next(v));
    } catch (E) {
      i(E);
    }
  }, o = (v) => {
    try {
      u(r.throw(v));
    } catch (E) {
      i(E);
    }
  }, u = (v) => v.done ? n(v.value) : Promise.resolve(v.value).then(a, o);
  u((r = r.apply(t, e)).next());
}), Lt = ct.createContext(
  void 0
);
function jl() {
  const { options: t } = ct.useContext(Lt) || {};
  return ma(t);
}
function Tr(t, e) {
  if (t === e)
    return !0;
  if (typeof t != typeof e)
    return !1;
  if (typeof t == "object" && t !== null && typeof e == "object" && e !== null) {
    const r = Object.keys(t), n = Object.keys(e);
    if (r.length !== n.length)
      return !1;
    for (const i of r)
      if (!Tr(t[i], e[i]))
        return !1;
    return !0;
  }
  return !1;
}
var Fl = {
  updateOnContextChanged: !0,
  updateOnConfigurationChanged: !0,
  suspendUntilReady: !1,
  suspendWhileReconciling: !1
}, ma = (t = {}) => {
  const e = t.updateOnContextChanged, r = t.updateOnConfigurationChanged, n = "suspendUntilReady" in t ? t.suspendUntilReady : t.suspend, i = "suspendWhileReconciling" in t ? t.suspendWhileReconciling : t.suspend;
  return Qe(Qe(Qe(Qe({}, typeof n == "boolean" && { suspendUntilReady: n }), typeof i == "boolean" && { suspendWhileReconciling: i }), typeof e == "boolean" && { updateOnContextChanged: e }), typeof r == "boolean" && { updateOnConfigurationChanged: r });
}, Dr = ct.use || // This extra generic is to avoid TypeScript mixing up the generic and JSX syntax
// and emitting an error.
// We assume that this is only for the `use(thenable)` case, not `use(context)`.
// https://github.com/facebook/react/blob/aed00dacfb79d17c53218404c52b1c7aa59c4a89/packages/react-server/src/ReactFizzThenable.js#L45
// eslint-disable-next-line @typescript-eslint/no-unused-vars
((t) => {
  switch (t.status) {
    case "pending":
      throw t;
    case "fulfilled":
      return t.value;
    case "rejected":
      throw t.reason;
    default:
      throw t.status = "pending", t.then(
        (e) => {
          t.status = "fulfilled", t.value = e;
        },
        (e) => {
          t.status = "rejected", t.reason = e;
        }
      ), t;
  }
}), fi = /* @__PURE__ */ new WeakMap();
function Ul(t, e) {
  const r = fi.get(t);
  if (r)
    Dr(r);
  else {
    const n = t !== Pr ? ya(e) : Promise.resolve();
    fi.set(t, n), Dr(n);
  }
}
function Vl(t) {
  Dr(ya(t));
}
function ya(t) {
  return Ll(this, null, function* () {
    const e = new AbortController();
    try {
      return yield new Promise((r, n) => {
        t.addHandler(ie.Ready, r, { signal: e.signal }), t.addHandler(ie.Error, n, { signal: e.signal });
      });
    } finally {
      e.abort();
    }
  });
}
var Hl = "Components using OpenFeature must be wrapped with an <OpenFeatureProvider>.", Gl = "If you are seeing this in a test, see: https://openfeature.dev/docs/reference/technologies/client/web/react#testing", _a = class extends Error {
  constructor(t) {
    super(`${t}: ${Hl} ${Gl}`), this.name = "MissingContextError";
  }
};
function Ea() {
  const { client: t } = ct.useContext(Lt) || {};
  if (!t)
    throw new _a("No OpenFeature client available");
  return t;
}
function Bl() {
  const t = Ea(), [e, r] = pi(t.providerStatus);
  return Rt(() => {
    const n = new AbortController(), i = () => r(t.providerStatus);
    return t.addHandler(ie.ConfigurationChanged, i, { signal: n.signal }), t.addHandler(ie.ContextChanged, i, { signal: n.signal }), t.addHandler(ie.Error, i, { signal: n.signal }), t.addHandler(ie.Ready, i, { signal: n.signal }), t.addHandler(ie.Stale, i, { signal: n.signal }), t.addHandler(ie.Reconciling, i, { signal: n.signal }), () => {
      n.abort();
    };
  }, [t]), e;
}
function $l() {
  const t = ct.useContext(Lt);
  if (!t)
    throw new _a("No OpenFeature context available");
  return Et.getProvider(t.client.metadata.domain);
}
function zl(t, e, r) {
  return ql(t, e, r).value;
}
function ql(t, e, r) {
  return ba(
    t,
    e,
    (n) => n.getBooleanDetails,
    r
  );
}
function Yl(t, e, r) {
  return Wl(t, e, r).value;
}
function Wl(t, e, r) {
  return ba(
    t,
    e,
    (n) => n.getStringDetails,
    r
  );
}
function Kl(t, e) {
  return !e || e.includes(t);
}
function ba(t, e, r, n) {
  const i = Qe(Qe(Qe({}, Fl), jl()), ma(n)), a = Ea(), o = Bl(), u = $l(), v = qr(!0);
  i.suspendUntilReady && o === Xe.NOT_READY && Ul(u, a), i.suspendWhileReconciling && o === Xe.RECONCILING && Vl(a);
  const [E, b] = pi(
    () => r(a).call(a, t, e, n)
  );
  Rt(() => {
    if (v.current) {
      v.current = !1;
      return;
    }
    const m = r(a).call(a, t, e, n);
    Tr(m, E) || b(m);
  }, [a, t, e, n, r, E]);
  const P = qr(E);
  Rt(() => {
    P.current = E;
  }, [E]);
  const d = Yr(() => {
    const m = r(a).call(a, t, e, n);
    Tr(m, P.current) || b(m);
  }, [a, t, e, n, r]), w = Yr(
    (m) => {
      Kl(t, m?.flagsChanged) && d();
    },
    [t, d]
  );
  return Rt(() => {
    const m = new AbortController();
    return a.addHandler(ie.Ready, d, { signal: m.signal }), i.updateOnContextChanged && a.addHandler(ie.ContextChanged, d, { signal: m.signal }), i.updateOnConfigurationChanged && a.addHandler(ie.ConfigurationChanged, w, {
      signal: m.signal
    }), () => {
      m.abort();
    };
  }, [
    a,
    i.updateOnContextChanged,
    i.updateOnConfigurationChanged,
    d,
    w
  ]), E;
}
function Jl(t) {
  var e = t, { client: r, domain: n, children: i } = e, a = Ml(e, ["client", "domain", "children"]);
  const o = zr.useMemo(() => r || Et.getClient(n), [r, n]);
  return /* @__PURE__ */ zr.createElement(Lt.Provider, { value: { client: o, options: a } }, i);
}
const se = {
  current: {
    liveEvents: [],
    loadCount: 0,
    expanded: !1,
    allowIdentify: !0
  }
}, Ql = () => process.env.NODE_ENV === "development";
class Xl {
  constructor(e, { position: r = "right", debuggerUrl: n = "https://debugger.devcycle.com", debugLogs: i = !1 } = {}) {
    this.client = e, se.current.allowIdentify = "identifyUser" in e, this.debuggerUrl = n, this.position = r, this.debugLogs = i, this.mainIframe = document.createElement("iframe"), this.buttonIframe = document.createElement("iframe"), this.debouncedUpdateIframeData = this.debounce(() => {
      this._updateIframeData();
    }, 300);
  }
  debounce(e, r) {
    let n = null;
    return () => {
      n && clearTimeout(n), n = setTimeout(() => {
        e(), n = null;
      }, r);
    };
  }
  createIframesWhenReady() {
    this.client.onClientInitialized().then(() => {
      se.current.config = this.client.config, se.current.user = this.client.user, this.createMainIframe(), this.createButtonIframe();
    });
  }
  _updateIframeData() {
    var e;
    se.current.config = this.client.config, se.current.user = this.client.user, this.synchronizeIframeUrl(), this.debugLogs && this.log("posting message", se.current), se.current.loadCount && ((e = this.mainIframe.contentWindow) === null || e === void 0 || e.postMessage({
      ...se.current,
      type: "dvcDebuggerData"
    }, this.debuggerUrl));
  }
  updateIframeData() {
    this.debouncedUpdateIframeData();
  }
  setupSubscriptions() {
    const e = (u) => {
      se.current.liveEvents.unshift(u), se.current.liveEvents.length > 200 && se.current.liveEvents.pop();
    }, r = () => {
      se.current.config = this.client.config, se.current.user = this.client.user, e({ type: "configUpdated", date: Date.now() }), this.updateIframeData();
    }, n = (u, v) => {
      e({
        type: "variableEvaluated",
        key: u,
        variable: { ...v },
        date: Date.now()
      }), this.updateIframeData();
    }, i = (u, v) => {
      e({
        type: "variableUpdated",
        key: u,
        variable: v ? { ...v } : null,
        date: Date.now()
      }), this.updateIframeData();
    };
    this.log("subscribing to events"), this.client.subscribe("configUpdated", r), this.client.subscribe("variableEvaluated:*", n), this.client.subscribe("variableUpdated:*", i);
    const a = this.client.track.bind(this.client);
    this.client.track = (...u) => {
      const [v] = u;
      e({
        type: v.type,
        target: v.target,
        value: v.value,
        date: Date.now()
      }), this.updateIframeData(), a(...u);
    };
    const o = this.iframeMessageReceiver.bind(this);
    return window.addEventListener("message", o), () => {
      this.log("unsubscribing from events"), this.client.unsubscribe("configUpdated", r), this.client.unsubscribe("variableEvaluated:*", n), this.client.unsubscribe("variableUpdated:*", i), window.removeEventListener("message", o);
    };
  }
  createButtonIframe() {
    this.buttonIframe.id = "devcycle-debugger-button-iframe", this.buttonIframe.style.width = "80px", this.buttonIframe.style.height = "80px", this.buttonIframe.style.position = "fixed", this.buttonIframe.style.bottom = "25px", this.position === "left" ? this.buttonIframe.style.left = "25px" : this.buttonIframe.style.right = "25px", this.buttonIframe.style.zIndex = "100", this.buttonIframe.style.border = "none", this.buttonIframe.style.overflow = "hidden", this.buttonIframe.title = "Devcycle Debugger";
    const e = new URLSearchParams();
    e.set("parentOrigin", window.location.origin), e.set("position", this.position), this.buttonIframe.src = `${this.debuggerUrl}/button?${e.toString()}`, document.body.appendChild(this.buttonIframe);
  }
  createMainIframe() {
    this.mainIframe.id = "devcycle-debugger-iframe", this.synchronizeIframeUrl(), this.mainIframe.style.width = "0px", this.mainIframe.style.height = "0px", this.mainIframe.style.position = "fixed", this.mainIframe.style.bottom = "25px", this.position === "left" ? this.mainIframe.style.left = "25px" : this.mainIframe.style.right = "25px", this.mainIframe.style.border = "none", this.mainIframe.style.overflow = "hidden", this.mainIframe.title = "Devcycle Debugger", this.mainIframe.allow = "clipboard-read; clipboard-write", this.mainIframe.onload = () => {
      se.current.loadCount += 1;
    }, document.body.appendChild(this.mainIframe);
  }
  synchronizeIframeUrl() {
    const e = new URLSearchParams();
    e.set("parentOrigin", window.location.origin), e.set("position", this.position);
    const r = `${this.debuggerUrl}/${this.client.config.project.a0_organization}/${this.client.config.project._id}/${this.client.config.environment._id}?${e.toString()}`;
    r !== this.mainIframe.src && (this.mainIframe.src = r);
  }
  iframeMessageReceiver(e) {
    e.origin === this.debuggerUrl && (this.log("Message received from iframe: ", e.data), e.data.type === "DEVCYCLE_IDENTIFY_USER" && e.data.user ? "identifyUser" in this.client ? this.client.identifyUser(e.data.user).then(() => {
      this.updateIframeData();
    }) : this.log("Unable to change user identity from debugger in Next.js") : e.data.type === "DEVCYCLE_RESET_USER" ? "resetUser" in this.client ? this.client.resetUser().then(() => {
      this.updateIframeData();
    }) : this.log("Unable to change user identity from debugger in Next.js") : e.data.type === "DEVCYCLE_REFRESH" ? this.updateIframeData() : e.data.type === "DEVCYCLE_TOGGLE_OVERLAY" && (se.current.expanded = !se.current.expanded, this.mainIframe.style.width = se.current.expanded ? "500px" : "0px", this.mainIframe.style.height = se.current.expanded ? "700px" : "0px", setTimeout(() => this.updateIframeData(), 10)));
  }
  log(...e) {
    this.debugLogs && console.log(...e);
  }
}
const Zl = async (t, { shouldEnable: e, shouldEnableVariable: r }) => {
  if (typeof e < "u") {
    if (!e || typeof e == "function" && !e())
      return !1;
  } else if (typeof r == "string") {
    if (await t.onClientInitialized(), !t.variableValue(r, !1))
      return !1;
  } else if (!Ql())
    return !1;
  return !0;
}, eu = async (t, { shouldEnable: e, shouldEnableVariable: r, ...n } = {}) => {
  if (!await Zl(t, {
    shouldEnable: e,
    shouldEnableVariable: r
  }))
    return () => {
    };
  const i = new Xl(t, n);
  document.readyState === "complete" || document.readyState === "interactive" ? i.createIframesWhenReady() : document.addEventListener("DOMContentLoaded", () => {
    i.createIframesWhenReady();
  });
  const a = i.setupSubscriptions();
  return () => {
    a(), document.body.contains(i.mainIframe) && document.body.removeChild(i.mainIframe), document.body.contains(i.buttonIframe) && document.body.removeChild(i.buttonIframe);
  };
}, wa = {
  user_id: "anonymous",
  email: "anonymous@worktango.com"
};
var br = { exports: {} }, ft = {};
var vi;
function tu() {
  if (vi) return ft;
  vi = 1;
  var t = ct, e = /* @__PURE__ */ Symbol.for("react.element"), r = /* @__PURE__ */ Symbol.for("react.fragment"), n = Object.prototype.hasOwnProperty, i = t.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, a = { key: !0, ref: !0, __self: !0, __source: !0 };
  function o(u, v, E) {
    var b, P = {}, d = null, w = null;
    E !== void 0 && (d = "" + E), v.key !== void 0 && (d = "" + v.key), v.ref !== void 0 && (w = v.ref);
    for (b in v) n.call(v, b) && !a.hasOwnProperty(b) && (P[b] = v[b]);
    if (u && u.defaultProps) for (b in v = u.defaultProps, v) P[b] === void 0 && (P[b] = v[b]);
    return { $$typeof: e, type: u, key: d, ref: w, props: P, _owner: i.current };
  }
  return ft.Fragment = r, ft.jsx = o, ft.jsxs = o, ft;
}
var gi;
function ru() {
  return gi || (gi = 1, br.exports = tu()), br.exports;
}
var nu = ru();
let wr, Ot, pt = !1;
function su({
  children: t
}) {
  return /* @__PURE__ */ nu.jsx(Jl, {
    children: t
  });
}
const lu = async (t) => {
  if (pt = t?.strictMode ?? !1, !t.sdkKey && pt)
    throw new Error("⚠️ Feature flag client SDK key is not set");
  if (!t.sdkKey) {
    console.warn("⚠️ Feature flag client SDK key is not set");
    return;
  }
  const e = {
    disableAutomaticEventLogging: !0
  };
  try {
    wr = new Qs(t.sdkKey, {
      ...e,
      ...t.options ?? {}
    }), await iu(t.user || wa), await Et.setProviderAndWait(wr), Ot = wr.devcycleClient, Ot && t.shouldEnableDebugger && await eu(Ot, {
      shouldEnable: !0
    });
  } catch (r) {
    if (Ot = null, pt)
      throw console.error("⚠️ Error initializing feature flag provider", r), r;
    console.warn("⚠️ Error initializing feature flag provider", r);
  }
};
let vt = wa;
async function Or(t) {
  await Et.setContext(t);
}
const iu = async (t) => {
  vt = t;
  try {
    await Or(t), vt !== t && await Or(vt);
  } catch (e) {
    throw vt !== t && await Or(vt), e;
  }
}, Br = () => Et.getClient();
function jt(t = Br()) {
  if (!t && !pt)
    return console.warn("⚠️ Feature flag client is not initialized"), !1;
  if (!t && pt)
    throw new Error("⚠️ Feature flag client is not initialized");
  return !0;
}
function uu(t, e) {
  return jt() ? Br().getBooleanValue(t, e) : e;
}
function cu(t, e) {
  return jt() ? Br().getStringValue(t, e) : e;
}
function du(t, e, r) {
  return jt() ? zl(t, e, r) : e;
}
function hu(t, e, r) {
  return jt() ? Yl(t, e, r) : e;
}
export {
  su as OpenFeatureProvider,
  uu as getBooleanFlagValue,
  Br as getFeatureFlagClient,
  cu as getStringFlagValue,
  lu as initializeFeatureFlagProvider,
  iu as setFeatureFlagUser,
  du as useBooleanFlagValue,
  hu as useStringFlagValue
};
//# sourceMappingURL=index.es.js.map
